<template>
  <div>
    <vx-card>
 <img class="" v-bind:src="logoUrl" alt="algolia-logo" />
    <div v-if="firma == 'Murat'">
      <div>
        <div>
          <p>MESAFELİ SATIŞ S&Ouml;ZLEŞMESİ&nbsp;</p>
        </div>
        <div>
          <p>MURAT S&Ouml;YLER TEKSTİL SANAYİ TİCARET LTD. ŞTİ&nbsp;</p>
        </div>
        <div>
          <p>1. TARAFLAR&nbsp;</p>
        </div>
        <div>
          <p>İşbu Mesafeli Satış S&ouml;zleşmesi (&quot;S&ouml;zleşme&quot;); adresi 7. maddede belirtilen
            (&quot;ALICI&rdquo;) ile adresi 6. Maddede belirtilen (&ldquo;SATICI&rdquo;) arasında aşağıda belirtilen
            h&uuml;k&uuml;m ve şartlar &ccedil;er&ccedil;evesinde elektronik ortamda kurulmuştur.&nbsp;</p>
        </div>
        <div>
          <p>2. TANIMLAR&nbsp;</p>
        </div>
        <div>
          <p>İşbu s&ouml;zleşmenin uygulanmasında ve yorumlanmasında aşağıda yazılı terimler karşılarındaki yazılı
            a&ccedil;ıklamaları ifade edeceklerdir.&nbsp;</p>
        </div>
        <div>
          <p>ALICI :Bir&nbsp;mal veya hizmeti ticari veya mesleki olmayan ama&ccedil;larla edinen, kullanan veya
            yararlanan ger&ccedil;ek ya da t&uuml;zel kişiyi,&nbsp;</p>
        </div>
        <div>
          <p>Bakan :Ticaret&nbsp;Bakanı&rsquo;nı,&nbsp;</p>
        </div>
        <div>
          <p>Bakanlık :Ticaret&nbsp;Bakanlığı&rsquo;nı,&nbsp;</p>
        </div>
        <div>
          <p>MURAT S&Ouml;YLER TEKSTİL SANAYİ TİCARET LTD. ŞTİ:&nbsp;SATICI&rsquo;lar&rsquo;ın&nbsp;&uuml;r&uuml;n ve
            hizmet sunduğu&nbsp;Platform&rsquo;u&nbsp;sağlayan aracı hizmet sağlayıcısı olan&nbsp;MURAT S&Ouml;YLER
            TEKSTİL SANAYİ TİCARET LTD. ŞTİ&nbsp;Şirketi&nbsp;</p>
        </div>
        <div>
          <p>Hizmet :Bir&nbsp;&uuml;cret veya menfaat karşılığında yapılan ya da yapılması taahh&uuml;t edilen mal sağlama
            dışındaki her t&uuml;rl&uuml; t&uuml;ketici işleminin konusu,&nbsp;</p>
        </div>
        <div>
          <p>Kanun :T&uuml;keticinin&nbsp;Korunması Hakkında Kanun&rsquo;u,&nbsp;</p>
        </div>
        <div>
          <p>Platform :MURAT&nbsp;S&Ouml;YLER TEKSTİL SANAYİ TİCARET LTD.&nbsp;ŞTİ&rsquo;e&nbsp;ait <a
              href="http://www.murattekstil.com.tr/" target="_blank"
              rel="noreferrer noopener">www.murattekstil.com.tr</a> adlı internet sitesini ve mobil uygulamasını,&nbsp;
          </p>
        </div>
        <div>
          <p>SATICI:Kamu&nbsp;t&uuml;zel kişileri de dahil olmak &uuml;zere ticari veya mesleki ama&ccedil;larla
            t&uuml;keticiye mal sunan ya da mal sunanın adına ya da hesabına hareket eden ve S&ouml;zleşme&rsquo;nin 6.
            maddesinde bilgileri bulunan ger&ccedil;ek ve/veya t&uuml;zel kişiyi,&nbsp;</p>
        </div>
        <div>
          <p>Sipariş&nbsp;Veren :Bir&nbsp;mal veya hizmeti&nbsp;MURAT S&Ouml;YLER TEKSTİL SANAYİ TİCARET
            LTD.&nbsp;ŞTİ&rsquo;e&nbsp;ait <a href="http://www.murattekstil.com.tr/" target="_blank"
              rel="noreferrer noopener">www.murattekstil.com.tr</a> adlı internet sitesi veya mobil uygulaması
            &uuml;zerinden talep eden ger&ccedil;ek ya da t&uuml;zel kişiyi,&nbsp;</p>
        </div>
        <div>
          <p>S&ouml;zleşme :SATICI&nbsp;ve ALICI arasında akdedilen işbu&nbsp;S&ouml;zleşme&rsquo;yi,&nbsp;</p>
        </div>
        <div>
          <p>Taraflar :SATICI&nbsp;ve&nbsp;ALICI&rsquo;yı,&nbsp;</p>
        </div>
        <div>
          <p>&Uuml;r&uuml;n veya&nbsp;&Uuml;r&uuml;nler :Alışverişe&nbsp;konu olan taşınır t&uuml;m eşya.&nbsp;</p>
        </div>
        <div>
          <p>Y&ouml;netmelik :Mesafeli&nbsp;Satışlar Y&ouml;netmeliği&rsquo;ni,&nbsp;</p>
        </div>
        <div>
          <p>3. S&Ouml;ZLEŞMENİN KONUSU ve KAPSAMI&nbsp;</p>
        </div>
        <div>
          <p>İşbu S&ouml;zleşme 6502 Sayılı T&uuml;keticinin Korunması Hakkında Kanun ve Mesafeli S&ouml;zleşmeler
            Y&ouml;netmeliği&apos;ne uygun olarak d&uuml;zenlenmiştir. Taraflar işbu S&ouml;zleşme tahtında 6502 Sayılı
            T&uuml;keticinin Korunması Hakkında Kanun ve Mesafeli S&ouml;zleşmeler Y&ouml;netmeliği&apos;nden kaynaklanan
            y&uuml;k&uuml;ml&uuml;l&uuml;k ve sorumluluklarını bildiklerini ve anladıklarını kabul ve beyan ederler. İşbu
            S&ouml;zleşmenin konusunu&nbsp;ALICI&apos;nın,&nbsp;MURAT S&Ouml;YLER TEKSTİL SANAYİ TİCARET
            LTD.&nbsp;ŞTİ&apos;e&nbsp;ait&nbsp;Platform&rsquo;da, Mal/Hizmet satışa sunan&nbsp;SATICI&apos;ya&nbsp;ait
            Mal/Hizmetin satın alınmasına y&ouml;nelik elektronik olarak sipariş
            verdiği,&nbsp;S&ouml;zleşme&rsquo;de&nbsp;belirtilen niteliklere sahip Mal/Hizmetin satışı ve teslimi ile
            ilgili olarak 6502 Sayılı T&uuml;keticinin Korunması Hakkındaki&nbsp;</p>
        </div>
        <div>
          <p>2&nbsp;</p>
        </div>
        <div>
          <p>Kanun ve Mesafeli S&ouml;zleşmeler Y&ouml;netmeliği h&uuml;k&uuml;mleri
            gereğince&nbsp;Taraflar&rsquo;ın&nbsp;hak ve y&uuml;k&uuml;ml&uuml;l&uuml;klerinin saptanması
            oluşturur.&nbsp;İşbu S&ouml;zleşme&rsquo;nin akdedilmesi&nbsp;Taraflar&rsquo;ın&nbsp;ayrı ayrı&nbsp;MURAT
            S&Ouml;YLER TEKSTİL SANAYİ TİCARET LTD. ŞTİ&nbsp;ile akdetmiş oldukları &uuml;yelik s&ouml;zleşmelerinin
            h&uuml;k&uuml;mlerinin ifasını engellemeyecek olup Taraflar işbu S&ouml;zleşme konusu Mal/Hizmetin
            satışında&nbsp;MURAT S&Ouml;YLER TEKSTİL SANAYİ TİCARET LTD.&nbsp;ŞTİ&rsquo;in&nbsp;herhangi bir şekilde taraf
            olmadığını ve S&ouml;zleşme kapsamında&nbsp;Taraflar&rsquo;ın&nbsp;y&uuml;k&uuml;ml&uuml;l&uuml;klerini yerine
            getirmeleri ile ilgili herhangi bir sorumluluğu ve taahh&uuml;d&uuml; bulunmadığını kabul ve beyan
            ederler.&nbsp;</p>
        </div>
        <div>
          <p>ALICI&rsquo;nın&nbsp;işbu s&ouml;zleşmenin akdinden evvel akdetmiş&nbsp;olduğu
            &hellip;&nbsp;tarihli&nbsp;Murattekstil&nbsp;Parekende&nbsp;Mağaza Bayilik S&ouml;zleşmesindeki maddelerin
            uygulanması devam eder ve işbu s&ouml;zleşme,
            &hellip;&nbsp;tarihli&nbsp;Murattekstil&nbsp;Parekende&nbsp;Mağaza Bayilik S&ouml;zleşmesi
            h&uuml;k&uuml;mlerinin ifasına engel teşkil etmez.&nbsp;</p>
        </div>
        <div>
          <p>4. ALICI&rsquo;NIN &Ouml;NCEDEN BİLGİLENDİRİLDİĞİ HUSUSLAR&nbsp;</p>
        </div>
        <div>
          <p>4.1. ALICI, aşağıdaki hususlarda, bu S&ouml;zleşme&apos;nin ALICI
            tarafından&nbsp;Platform&rsquo;dan&nbsp;kabul&uuml; ile kurulmasından ve gerek siparişi gerek &ouml;deme
            y&uuml;k&uuml;ml&uuml;l&uuml;ğ&uuml; altına girmesinden &ouml;nce&nbsp;Platform&rsquo;un&nbsp;ilgili
            sayfaları-kısımlarındaki t&uuml;m genel-&ouml;zel a&ccedil;ıklamaları incelediğini, okuduğunu, anladığını ve
            kendisine gerekli bilgilendirmenin yapıldığını kabul eder.&nbsp;</p>
        </div>
        <div>
          <p>a)&nbsp;SATICI&apos;nın&nbsp;unvanı ve iletişim bilgileri ile g&uuml;ncel tanıtıcı bilgileri,&nbsp;</p>
        </div>
        <div>
          <p>b)&nbsp;&Uuml;r&uuml;nler&apos;in&nbsp;Platform&rsquo;dan&nbsp;alınması sırasındaki satış işlemi aşamaları
            ile yanlış girilen bilgilerin d&uuml;zeltilmesine ilişkin amaca uygun ara&ccedil;lar-y&ouml;ntemler,&nbsp;</p>
        </div>
        <div>
          <p>c)&nbsp;SATICI&apos;nın&nbsp;mensubu olduğu Meslek Odası&nbsp;Bursa&nbsp;Ticaret&nbsp;ve Sanayi&nbsp;Odası)
            ve&nbsp;BTSO&rsquo;nun&nbsp;meslek ile ilgili &ouml;ng&ouml;rd&uuml;ğ&uuml; davranış kuralları bilgisinin
            edinebileceği elektronik iletişim bilgileri (Telefon:&nbsp;444 7 005)&nbsp;</p>
        </div>
        <div>
          <p>d)&nbsp;MURAT S&Ouml;YLER TEKSTİL SANAYİ TİCARET LTD. ŞTİ&nbsp;tarafından uygulanan ALICI bilgileri
            i&ccedil;in ge&ccedil;erli gizlilik, veri kullanımı-işleme ve&nbsp;ALICI&rsquo;ya&nbsp;elektronik iletişim
            kuralları ile&nbsp;ALICI&rsquo;nın&nbsp;bu hususlarda&nbsp;MURAT S&Ouml;YLER TEKSTİL SANAYİ TİCARET
            LTD.&nbsp;ŞTİ&rsquo;ye&nbsp;verdiği izinler,&nbsp;ALICI&rsquo;nın&nbsp;kanuni
            hakları,&nbsp;SATICI&rsquo;nın&nbsp;hakları ve&nbsp;Taraflar&rsquo;ın&nbsp;haklarını kullanım usulleri,&nbsp;
          </p>
        </div>
        <div>
          <p>e) &Uuml;r&uuml;nler i&ccedil;in SATICI tarafından &ouml;ng&ouml;r&uuml;len g&ouml;nderim
            kısıtlamaları,&nbsp;</p>
        </div>
        <div>
          <p>f) S&ouml;zleşme konusu &Uuml;r&uuml;nler i&ccedil;in&nbsp;MURAT S&Ouml;YLER TEKSTİL SANAYİ TİCARET LTD.
            ŞTİ&nbsp;tarafından kabul edilen &ouml;deme y&ouml;ntem-ara&ccedil;ları
            ile&nbsp;&Uuml;r&uuml;nler&apos;in&nbsp;temel &ouml;zellik-nitelikleri,&nbsp;vergiler&nbsp;dahil&nbsp;toplam
            fiyatı (ilgili masraflar da dahil olmak
            &uuml;zere&nbsp;ALICI&rsquo;nın&nbsp;SATICI&apos;ya&nbsp;&ouml;deyeceği toplam bedel),&nbsp;</p>
        </div>
        <div>
          <p>g)&nbsp;&Uuml;r&uuml;nler&apos;in&nbsp;ALICI&rsquo;ya&nbsp;teslimine ilişkin usuller ile nakliye-teslim-kargo
            masrafları hakkında bilgiler,&nbsp;</p>
        </div>
        <div>
          <p>3&nbsp;</p>
        </div>
        <div>
          <p>h) &Uuml;r&uuml;nler ile ilgili diğer &ouml;deme/tahsilat ve teslimat bilgileri ile S&ouml;zleşme&apos;nin
            ifasına ilişkin bilgiler, bu hususlarda&nbsp;Taraflar&rsquo;ın&nbsp;sorumlulukları,&nbsp;</p>
        </div>
        <div>
          <p>i)&nbsp;ALICI&rsquo;nın&nbsp;cayma hakkına sahip olmadığı &Uuml;r&uuml;nler ve diğer mal-hizmetler,&nbsp;</p>
        </div>
        <div>
          <p>j)&nbsp;ALICI&rsquo;nın&nbsp;cayma hakkının olduğu durumlarda bu hakkını kullanma şartları, s&uuml;resi ve
            usul&uuml; ile hakkın s&uuml;resinde kullanılmaması durumunda&nbsp;ALICI&rsquo;nın&nbsp;cayma hakkını
            kaybedeceği,&nbsp;</p>
        </div>
        <div>
          <p>k) Cayma hakkı olan&nbsp;&Uuml;r&uuml;nler&apos;de, &Uuml;r&uuml;n cayma s&uuml;resi i&ccedil;inde kullanım
            talimatlarına, olağan işleyişine veya teknik &ouml;zelliklerine uygun kullanılmamasından &ouml;t&uuml;r&uuml;
            bozulduğu veya bir değişikliğe uğradığı takdirde&nbsp;ALICI&rsquo;nın&nbsp;cayma talebinin kabul
            edilmeyebileceği ve her durumda&nbsp;SATICI&apos;ya&nbsp;karşı sorumlu
            olacağı,&nbsp;SATICI&apos;nın&nbsp;kabul ettiği hallerde s&ouml;z konusu bozukluğa veya değişime g&ouml;re
            uygun bulduğu bir tutarı&nbsp;ALICI&rsquo;ya&nbsp;yapacağı geri &ouml;demeden mahsup edebileceği,&nbsp;</p>
        </div>
        <div>
          <p>l) Cayma hakkının bulunduğu durumlarda &Uuml;r&uuml;nleri&nbsp;SATICI&apos;ya&nbsp;ne şekilde iade
            edebileceği ve ilgili t&uuml;m mali hususlar (iade yolları, masrafı ve &Uuml;r&uuml;n bedelinin iadesi ve iade
            sırasında, ALICI tarafından kazanılmış/kullanılmış &ouml;d&uuml;l puanları i&ccedil;in yapılabilecek indirim
            ve mahsuplar&nbsp;dahil),&nbsp;</p>
        </div>
        <div>
          <p>m)&nbsp;ALICI&rsquo;nın&nbsp;Platform&rsquo;da&nbsp;d&ouml;nem&nbsp;d&ouml;nem&nbsp;uygulanabilecek
            &ccedil;eşitli fırsatlara ilişkin yararlanma koşullarının (&ouml;zel şartlar) detaylarını,&nbsp;</p>
        </div>
        <div>
          <p>n) Mahiyetine g&ouml;re bu&nbsp;S&ouml;zleşme&apos;de&nbsp;de yer alan diğer t&uuml;m satış şartları ile işbu
            S&ouml;zleşme ALICI tarafından&nbsp;Platform&rsquo;da&nbsp;onaylanarak kurulduktan
            sonra&nbsp;ALICI&rsquo;ya&nbsp;elektronik posta ile g&ouml;nderildiğinden ALICI tarafından istenen s&uuml;re
            ile saklanıp buradan erişilebileceği,&nbsp;MURAT S&Ouml;YLER TEKSTİL SANAYİ TİCARET
            LTD.&nbsp;ŞTİ&rsquo;in&nbsp;de &uuml;&ccedil; yıl s&uuml;re ile nezdinde saklayabileceği.&nbsp;</p>
        </div>
        <div>
          <p>o) Uyuşmazlık hallerinde&nbsp;ALICI&rsquo;nın&nbsp;MURAT S&Ouml;YLER TEKSTİL SANAYİ TİCARET
            LTD.&nbsp;ŞTİ&rsquo;e&nbsp;veya&nbsp;SATICI&rsquo;ya&nbsp;şikayetlerini&nbsp;iletebileceği iletişim bilgileri
            ile yasal başvurularını, 6502 Sayılı Kanun&apos;un ilgili h&uuml;k&uuml;mlerine uygun olarak İl&ccedil;e/İl
            Hakem Heyetlerine ve T&uuml;ketici Mahkemeleri&apos;ne yapabileceği.&nbsp;</p>
        </div>
        <div>
          <p>5. SATICI BİLGİLERİ&nbsp;</p>
        </div>
        <div>
          <p>&Uuml;nvanı&nbsp;:&nbsp;MURAT&nbsp;S&Ouml;YLER TEKSTİL SANAYİ TİCARET LTD. ŞTİ.&nbsp;</p>
        </div>
        <div>
          <p>Adresi :&nbsp;Ovaak&ccedil;a&nbsp;Merkez&nbsp;mah.&nbsp;İstanbul&nbsp;cad.&nbsp;No:567-A/B
            Osmangazi/Bursa&nbsp;</p>
        </div>
        <div>
          <p>Mersis&nbsp;:&nbsp;0624036646400012&nbsp;</p>
        </div>
        <div>
          <p>Telefon :&nbsp;444&nbsp;7 005&nbsp;</p>
        </div>
        <div>
          <p>6. ALICI BİLGİLERİ&nbsp;</p>
        </div>
        <div>
          <p>Teslim Edilecek&nbsp;Kişi :&nbsp;</p>
        </div>
        <div>
          <p>Teslimat&nbsp;Adresi :&nbsp;</p>
        </div>
        <div>
          <p>Telefon :&nbsp;</p>
        </div>
        <div>
          <p>Faks :&nbsp;</p>
        </div>
        <div>
          <p>E-posta/Kullanıcı&nbsp;Adı :&nbsp;</p>
        </div>
        <div>
          <p>4&nbsp;</p>
        </div>
        <div>
          <p>8. FATURA BİLGİLERİ&nbsp;</p>
        </div>
        <div>
          <p>Fatura Teslim: Fatura sipariş teslimatı sırasında teslimat adresine sipariş ile birlikte teslim
            edilecektir.&nbsp;</p>
        </div>
        <div>
          <p>9. S&Ouml;ZLEŞME KONUSU &Uuml;R&Uuml;N/&Uuml;R&Uuml;NLER BİLGİLERİ&nbsp;</p>
        </div>
        <div>
          <p>9.1. Malın/&Uuml;r&uuml;n/&Uuml;r&uuml;nlerin/ Hizmetin temel &ouml;zelliklerini (t&uuml;r&uuml;, miktarı,
            marka/modeli, rengi, adedi)&nbsp;MURAT S&Ouml;YLER TEKSTİL SANAYİ TİCARET
            LTD.&nbsp;ŞTİ&rsquo;e&nbsp;ait&nbsp;Platform&rsquo;da&nbsp;yer almaktadır. &Uuml;r&uuml;n&uuml;n temel
            &ouml;zelliklerini kampanya s&uuml;resince inceleyebilirsiniz.&nbsp;</p>
        </div>
        <div>
          <p>9.2. Listelenen ve sitede ilan edilen fiyatlar satış fiyatıdır. İlan edilen fiyatlar ve vaatler
            g&uuml;ncelleme yapılana ve değiştirilene kadar ge&ccedil;erlidir. S&uuml;reli olarak ilan edilen fiyatlar ise
            belirtilen s&uuml;re sonuna kadar ge&ccedil;erlidir.&nbsp;</p>
        </div>
        <div>
          <p>9.3. S&ouml;zleşme konusu mal ya da hizmetin t&uuml;m vergiler d&acirc;hil satış fiyatı aşağıdaki tabloda
            g&ouml;sterilmiştir. Bu birim kar&nbsp;marjları&nbsp;13.06.2022 tarihli fiyat listelerindeki marjlardır.
            Toplam siparişteki miktarın toleransı +/- 10%&apos;dur.&nbsp;</p>
        </div>
        <div>
          <p>&Uuml;r&uuml;n A&ccedil;ıklaması Adet Peşin Fiyatı Ara Toplam (KDV&nbsp;Dahil)&nbsp;</p>
        </div>
        <div>
          <p>3500 TL ve &uuml;st&uuml; kargolarda Nakliye ve sigorta alıcıya aittir.&nbsp;</p>
        </div>
        <div>
          <p>* <a href="http://www.murattekstil.com.tr/" target="_blank"
              rel="noreferrer noopener">www.murattekstil.com.tr</a> internet sitesinin a&ccedil;ık pazar ve/veya diğer
            butiklerinden eş zamanlı olarak ger&ccedil;ekleştirilen alışverişlerde hak kazanılan toplam indirim tutarı,
            kargo bedeli ve taksit farkı tutarı birlikte yukarıda g&ouml;sterilmiştir.&nbsp;</p>
        </div>
        <div>
          <p>Teslimat&nbsp;Adresi :&nbsp;</p>
        </div>
        <div>
          <p>Teslim Edilecek&nbsp;Kişi :&nbsp;</p>
        </div>
        <div>
          <p>Fatura&nbsp;Adresi :&nbsp;</p>
        </div>
        <div>
          <p>Sipariş&nbsp;Tarihi :&nbsp;</p>
        </div>
        <div>
          <p>Teslim&nbsp;Şekli : Alıcıya&nbsp;Teslim&nbsp;</p>
        </div>
        <div>
          <p>Etiket ve&nbsp;paketleme : &Ccedil;oklu&nbsp;paketleme.&nbsp;</p>
        </div>
        <div>
          <p>ALICI&rsquo;nın&nbsp;sipariş esnasında &uuml;r&uuml;n&uuml; Teslimat Noktasına teslim y&ouml;ntemiyle
            teslimat se&ccedil;eneğini se&ccedil;mesi halinde, &uuml;r&uuml;n&nbsp;MURAT S&Ouml;YLER TEKSTİL SANAYİ
            TİCARET LTD.&nbsp;ŞTİ&rsquo;in&nbsp;entegrasyon&nbsp;halinde olduğu lojistik firması
            tarafından&nbsp;ALICI&rsquo;nın&nbsp;se&ccedil;miş olduğu teslimat noktasına en ge&ccedil; 30 g&uuml;n
            i&ccedil;erisinde teslim edilecektir. &Uuml;r&uuml;n&uuml;n teslimat noktasına bırakılmasının ardından
            ALICI&nbsp;Platform&rsquo;a&nbsp;kaydolurken iletmiş olduğu telefon numarasına gelen kod ile en ge&ccedil; 3
            g&uuml;n i&ccedil;erisinde &uuml;r&uuml;n&uuml; teslim alacaktır.&nbsp;ALICI&rsquo;nın&nbsp;işbu s&uuml;re
            i&ccedil;erisinde &uuml;r&uuml;n&uuml; teslim almaması halinde &uuml;r&uuml;n&uuml; iade ettiği kabul edilecek
            olup &uuml;r&uuml;n bedeli, siparişi ger&ccedil;ekleştirdiği kredi kartı/banka hesabına iade edilecektir.
            M&uuml;cbir sebep halleri olan&nbsp;yangın,sel, deprem, salgın&nbsp;hastalık,doğal&nbsp;afetler kaynaklı
            işletmede ve tedarik zincirinde işlerin kısmen ve&nbsp;tamamiyle&nbsp;yapılamaması halinde teslimat tarihleri
            revize edilebilir.&nbsp;</p>
        </div>
        <div>
          <p>9.4. S&Ouml;Z KONUSU &Uuml;R&Uuml;N BEDELİ, &ldquo;Murattekstil&nbsp;ALICI G&Uuml;VENCESİ&rdquo; KAPSAMINDA
            SATICI ADINA,&nbsp;MURAT S&Ouml;YLER TEKSTİL SANAYİ TİCARET LTD. ŞTİ&nbsp;TARAFINDAN&nbsp;</p>
        </div>
        <div>
          <p>5&nbsp;</p>
        </div>
        <div>
          <p>ALICI&rsquo;DAN TAHSİL EDİLMEKTEDİR. ALICI MALIN BEDELİNİ&nbsp;MURAT S&Ouml;YLER TEKSTİL SANAYİ TİCARET LTD.
            ŞTİ&apos;E &Ouml;DEMEKLE, &Uuml;R&Uuml;N BEDELİNİ SATICI&rsquo;YA &Ouml;DEMİŞ SAYILACAK VE BİR DAHA &Ouml;DEME
            Y&Uuml;K&Uuml;ML&Uuml;L&Uuml;Ğ&Uuml; ALTINA GİRMEYECEKTİR. ALICI&rsquo;NIN İLGİLİ MEVZUAT KAPSAMINDA İADE
            HAKLARI SAKLIDIR.&nbsp;</p>
        </div>
        <div>
          <p>10. GENEL H&Uuml;K&Uuml;MLER&nbsp;</p>
        </div>
        <div>
          <p>10.1. ALICI,&nbsp;Platform&rsquo;da&nbsp;S&ouml;zleşme konusu &Uuml;r&uuml;n&rsquo;&uuml;n temel nitelikleri,
            satış fiyatı ve &ouml;deme şekli ile teslimata ilişkin &ouml;n bilgileri okuyup, bilgi sahibi olduğunu,
            elektronik ortamda gerekli teyidi verdiğini kabul, beyan ve taahh&uuml;t eder. ALICI t&uuml;ketici sıfatıyla
            talep ve&nbsp;şikayetlerini&nbsp;yukarıda yer alan SATICI iletişim bilgilerine
            ve/veya&nbsp;Platform&rsquo;un&nbsp;sağladığı kanallarla ulaştırabilirler.&nbsp;ALICI&rsquo;nın; &Ouml;n
            Bilgilendirme&nbsp;Formu&rsquo;nu&nbsp;elektronik ortamda teyit etmesinden, Mesafeli Satış
            S&ouml;zleşmesi&rsquo;nin kurulmasından evvel, SATICI tarafından&nbsp;ALICI&rsquo;ya&nbsp;verilmesi gereken
            adresi, siparişi verilen &uuml;r&uuml;nlere ait temel &ouml;zellikleri, &uuml;r&uuml;nlerin vergiler
            d&acirc;hil fiyatını, &ouml;deme ve teslimat bilgilerini de doğru ve eksiksiz olarak edindiğini, siparişin
            verilmesi ile satın alınan &uuml;r&uuml;nlerin bedellerinin vadesi hakkında ihtar edilmiş olduğunu, vade
            tarihinde borcun ALICI tarafından &ouml;denmediği takdirde, ek bir ihtar yapılması gerekmeksizin
            temerr&uuml;de d&uuml;şeceğini ve aylık %3 tutarındaki temerr&uuml;t faizi &ouml;demekle
            y&uuml;k&uuml;ml&uuml; olacağını hi&ccedil;bir koşul olmaksızın kabul, beyan ve taahh&uuml;t eder.&nbsp;</p>
        </div>
        <div>
          <p>10.2.Alıcı, işbu s&ouml;zleşme ile satıcının sipariş konusu &uuml;r&uuml;nleri &uuml;retime başlayacağını,
            ham madde teminini yapacağını ve &uuml;retim planlamasını bu sipariş doğduğunda g&uuml;ncellediğini
            bilmektedir. Sipariş konusu &uuml;r&uuml;nleri almaktan hi&ccedil;bir koşulda vazge&ccedil;meyeceğini,
            s&ouml;zleşmeden d&ouml;nmeyeceğini, bu maddeye aykırı davranması halinde ya da ilerleyen s&uuml;re&ccedil;te
            siparişin bir kısmını almaktan vazge&ccedil;mesi halinde verilen kaparonun yanacağını, hi&ccedil;bir şekilde
            geri istenemeyeceğini, ayrıca satıcının doğacak t&uuml;m zararlarını karşılayacağını peşinen kabul ve
            taahh&uuml;t etmiştir.&nbsp;</p>
        </div>
        <div>
          <p>10.3. S&ouml;zleşme konusu her bir &uuml;r&uuml;n, 30 g&uuml;nl&uuml;k yasal s&uuml;reyi aşmamak kaydı
            ile&nbsp;ALICI&rsquo;nın&nbsp;yerleşim yeri uzaklığına bağlı olarak internet sitesindeki &ouml;n bilgiler
            kısmında belirtilen s&uuml;re zarfında ALICI veya&nbsp;ALICI&rsquo;nın&nbsp;g&ouml;sterdiği adresteki kişi
            ve/veya kuruluşa veya&nbsp;Murattekstil&nbsp;Teslimat Noktasına&nbsp;MURAT S&Ouml;YLER TEKSTİL SANAYİ TİCARET
            LTD.&nbsp;ŞTİ&rsquo;in&nbsp;entegrasyon&nbsp;halinde olduğu kargo şirketi aracılığıyla teslim edilir. Bu
            s&uuml;re i&ccedil;erisinde&nbsp;SATICI&rsquo;nın&nbsp;edimini yerine getirmemesi durumunda
            ALICI&nbsp;S&ouml;zleşme&apos;yi&nbsp;feshedebilir. İnternet sitesinde &ldquo;tahmini teslimat tarihi&rdquo;
            şeklinde belirtilen teslimat tarihi tahmini olarak belirtilmiş olup bu ifade herhangi bir
            taahh&uuml;t&nbsp;i&ccedil;ermemektedir. Bu &uuml;r&uuml;nler mevzuatta belirtildiği &uuml;zere en ge&ccedil;
            30 g&uuml;n i&ccedil;erisinde&nbsp;ALICI&rsquo;ya&nbsp;teslim edilecektir.&nbsp;ALICI&rsquo;nın&nbsp;veya
            teslim edilecek kişinin teslim anında adreste bulunmaması
            durumunda&nbsp;ALICI&apos;nın&nbsp;&uuml;r&uuml;n&uuml; ge&ccedil; teslim almasından ve/veya hi&ccedil; teslim
            almamasından kaynaklanan zararlardan ve giderlerden SATICI sorumlu değildir.&nbsp;</p>
        </div>
        <div>
          <p>T&uuml;keticinin, satıcının belirlediği taşıyıcı dışında başka bir taşıyıcı ile malın g&ouml;nderilmesini
            talep etmesi durumunda, malın ilgili taşıyıcıya tesliminden itibaren oluşabilecek kayıp ya da hasardan satıcı
            sorumlu değildir.&nbsp;</p>
        </div>
        <div>
          <p>10.4. SATICI, S&ouml;zleşme konusu &uuml;r&uuml;n&uuml; eksiksiz, siparişte belirtilen niteliklere uygun ve
            varsa garanti belgeleri, kullanım kılavuzları ile işin gereği olan bilgi ve belgeler ile teslim etmeyi,
            her&nbsp;</p>
        </div>
        <div>
          <p>6&nbsp;</p>
        </div>
        <div>
          <p>t&uuml;rl&uuml;&nbsp;ayıptan ar&icirc; olarak yasal mevzuat gereklerine g&ouml;re sağlam, standartlara uygun
            bir şekilde işi doğruluk ve d&uuml;r&uuml;stl&uuml;k esasları d&acirc;hilinde ifa etmeyi, hizmet kalitesini
            koruyup y&uuml;kseltmeyi, işin ifası sırasında gerekli dikkat ve &ouml;zeni g&ouml;stermeyi, ihtiyat ve
            &ouml;ng&ouml;r&uuml; ile hareket etmeyi kabul, beyan ve taahh&uuml;t eder.&nbsp;</p>
        </div>
        <div>
          <p>10.5. Malın teslimi sonrasında, gizli ayıp haricinde, malda bir eksiklik ya da ayıp bulunması durumunda,
            alıcı 15 g&uuml;n i&ccedil;erisinde bu durumu satıcıya bildirecektir. Teslimden itibaren 15 g&uuml;n
            sonrasında teslim edilen &uuml;r&uuml;nler hi&ccedil;bir gerek&ccedil;e ile iade edilemeyecek, gizli ayıp
            haricinde ayıp, hata ihbarında bulunulamayacaktır. ALICI, ayıba ilişkin işbu bildirim
            y&uuml;k&uuml;ml&uuml;l&uuml;ğ&uuml;n&uuml; peşinen kabul ve taahh&uuml;t etmiştir.&nbsp;</p>
        </div>
        <div>
          <p>10.5. SATICI,&nbsp;S&ouml;zleşme&apos;den&nbsp;doğan ifa y&uuml;k&uuml;ml&uuml;l&uuml;ğ&uuml;n&uuml;n
            s&uuml;resi dolmadan&nbsp;ALICI&rsquo;yı&nbsp;bilgilendirmek ve a&ccedil;ık&ccedil;a onayını almak suretiyle
            eşit kalite ve fiyatta farklı bir &uuml;r&uuml;n tedarik edebilir.&nbsp;</p>
        </div>
        <div>
          <p>10.6. ALICI, S&ouml;zleşme konusu &Uuml;r&uuml;n&rsquo;&uuml;n teslimatı i&ccedil;in
            işbu&nbsp;S&ouml;zleşme&rsquo;yi&nbsp;elektronik ortamda teyit edeceğini, herhangi bir nedenle S&ouml;zleşme
            konusu &uuml;r&uuml;n bedelinin &ouml;denmemesi ve/veya banka, finans kuruluşu kayıtlarında iptal edilmesi
            halinde,&nbsp;SATICI&rsquo;nın&nbsp;s&ouml;zleşme konusu &uuml;r&uuml;n&uuml; teslim
            y&uuml;k&uuml;ml&uuml;l&uuml;ğ&uuml;n&uuml;n sona ereceğini kabul, beyan ve taahh&uuml;t eder. Herhangi bir
            sebeple banka ve/veya finans kuruluşu tarafından başarısız kodu g&ouml;nderilen ancak banka ve/veya finans
            kuruluşu tarafından&nbsp;SATICI&rsquo;ya&nbsp;yapılan &ouml;demelere ilişkin
            ALICI,&nbsp;SATICI&rsquo;nın&nbsp;herhangi bir sorumluluğunun bulunmadığını kabul, beyan ve taahh&uuml;t
            eder.&nbsp;</p>
        </div>
        <div>
          <p>10.7. ALICI, S&ouml;zleşme konusu &Uuml;r&uuml;n&rsquo;&uuml;n ALICI
            veya&nbsp;ALICI&rsquo;nın&nbsp;g&ouml;sterdiği adresteki kişi ve/veya kuruluşa tesliminden sonra
            veya&nbsp;Murattekstil&nbsp;Teslimat Noktasından ALICI tarafından teslim alınmasından
            sonra&nbsp;ALICI&rsquo;ya&nbsp;ait kredi kartının yetkisiz kişilerce haksız kullanılması sonucunda
            S&ouml;zleşme konusu &uuml;r&uuml;n bedelinin ilgili banka veya finans kuruluşu
            tarafından&nbsp;SATICI&rsquo;ya&nbsp;&ouml;denmemesi halinde, ALICI S&ouml;zleşme konusu &uuml;r&uuml;n&uuml;
            3 g&uuml;n i&ccedil;erisinde nakliye gideri&nbsp;ALICI&rsquo;ya&nbsp;ait olacak
            şekilde&nbsp;SATICI&rsquo;ya&nbsp;iade edeceğini kabul, beyan ve taahh&uuml;t eder.&nbsp;</p>
        </div>
        <div>
          <p>10.8. ALICI, S&ouml;zleşme konusu mal/hizmeti teslim almadan &ouml;nce muayene edecek; ezik, kırık, ambalajı
            yırtılmış vb. hasarlı ve ayıplı mal/hizmeti kargo şirketinden teslim almayacaktır. Teslim alınan mal/hizmetin
            hasarsız ve sağlam olduğu kabul edilecektir. Teslimden sonra mal/hizmetin &ouml;zenle korunması
            borcu,&nbsp;ALICI&rsquo;ya&nbsp;aittir. Cayma hakkı kullanılacaksa mal/hizmet kullanılmamalıdır. Fatura iade
            edilmelidir.&nbsp;</p>
        </div>
        <div>
          <p>10.9. Malın teslimat masrafları aksine bir h&uuml;k&uuml;m yoksa&nbsp;ALICI&rsquo;ya&nbsp;aittir.
            SATICI,&nbsp;Platform&rsquo;da&nbsp;teslimat &uuml;cretinin kendisince karşılanacağını beyan etmişse teslimat
            masrafları&nbsp;SATICI&apos;ya&nbsp;ait olacaktır. Malın teslimatı&nbsp;SATICI&apos;nın&nbsp;stokunun
            m&uuml;sait olması halinde ve &ouml;demenin ger&ccedil;ekleşmesinden sonra taahh&uuml;t edilen s&uuml;rede
            yapılır.&nbsp;</p>
        </div>
        <div>
          <p>10.10. Sipariş konusu mal ya da hizmet ediminin yerine
            getirilmesinin&nbsp;imkansızlaştığı&nbsp;hallerde&nbsp;SATICI&rsquo;nın&nbsp;bu durumu &ouml;ğrendiği tarihten
            itibaren 3 (&uuml;&ccedil;) g&uuml;n i&ccedil;inde&nbsp;ALICI&rsquo;ya&nbsp;yazılı olarak veya ALICI veri
            saklayıcısı ile bildirmesi ve varsa teslimat masrafları da d&acirc;hil olmak &uuml;zere tahsil edilen t&uuml;m
            &ouml;demeleri bildirim tarihinden itibaren en ge&ccedil; on beş g&uuml;n i&ccedil;inde iade etmesi
            zorunludur. Malın stokta bulunmaması durumu, mal ediminin yerine getirilmesinin&nbsp;</p>
        </div>
        <div>
          <p>7&nbsp;</p>
        </div>
        <div>
          <p>imk&acirc;nsızlaşması&nbsp;olarak kabul edilmez.&nbsp;ALICI&rsquo;nın&nbsp;kredi kartı ile yaptığı
            &ouml;demelerde ise SATICI tarafından kredi kartına iade edilen tutarın banka tarafından ALICI hesabına
            yansıtılmasına ilişkin ortalama s&uuml;recin 2 (iki) ile 3 (&uuml;&ccedil;) haftayı bulabileceğini, bu tutarın
            bankaya iadesinden sonra&nbsp;ALICI&rsquo;nın&nbsp;hesaplarına yansıması halinin tamamen banka işlem
            s&uuml;reci ile ilgili olduğundan ALICI, olası gecikmeler i&ccedil;in&nbsp;SATICI&rsquo;yı&nbsp;sorumlu
            tutamayacağını kabul, beyan ve taahh&uuml;t eder.&nbsp;</p>
        </div>
        <div>
          <p>10.11. ALICI ile sipariş esnasında kullanılan kredi kartı hamilinin aynı kişi olmaması veya
            &uuml;r&uuml;n&uuml;n&nbsp;ALICI&rsquo;ya&nbsp;tesliminden evvel, siparişte kullanılan kredi kartına ilişkin
            g&uuml;venlik a&ccedil;ığı tespit edilmesi halinde, SATICI, kredi kartı hamiline ilişkin kimlik ve iletişim
            bilgilerini, siparişte kullanılan kredi kartının bir &ouml;nceki aya ait&nbsp;ekstresini&nbsp;yahut kart
            hamilinin bankasından kredi kartının kendisine ait olduğuna ilişkin yazıyı ibraz
            etmesini&nbsp;ALICI&rsquo;dan&nbsp;talep edebilir.&nbsp;ALICI&rsquo;nın&nbsp;talebe konu bilgi/belgeleri temin
            etmesine kadar ge&ccedil;ecek s&uuml;rede sipariş dondurulacak olup, mezk&ucirc;r taleplerin 24 (yirmi
            d&ouml;rt) saat i&ccedil;erisinde karşılanmaması halinde ise SATICI, siparişi iptal etme hakkını
            haizdir.&nbsp;</p>
        </div>
        <div>
          <p>10.12. ALICI &uuml;r&uuml;n bedelini &ouml;demesi ve bu siparişe ilişkin cayma hakkını kullanması halinde
            cayma hakkından kaynaklı bedel iadesi&nbsp;Paytr&nbsp;&uuml;zerinden hesabına yapılacaktır.&nbsp;</p>
        </div>
        <div>
          <p>10.13. &Ouml;deme şekli: %50&apos;si işbu s&ouml;zleşmenin tebliğine istinaden peşin ve kalan 50% mal
            tesliminden 60 g&uuml;n sonra&nbsp;&hellip;&hellip;&hellip;...&hellip;&hellip;&hellip;&nbsp;tarihinde&nbsp;TL
            bazında banka havalesiyle peşin &ouml;denecektir.&nbsp;</p>
        </div>
        <div>
          <p>10.14. Vadesinde yapılmayan &ouml;demelerde, aylık % 3 faiz işletilir.&nbsp;</p>
        </div>
        <div>
          <p>10.15. Sipariş&cedil; edilmeyen malların g&ouml;nderilmesi durumunda,&nbsp;ALICI&rsquo;ya&nbsp;karşı herhangi
            bir hak ileri s&uuml;r&uuml;lemez. Bu hallerde,&nbsp;ALICI&rsquo;nın&nbsp;sessiz kalması ya da malı kullanmış
            olması, s&ouml;zleşmenin kurulmasına y&ouml;nelik kabul beyanı olarak yorumlanamaz.&nbsp;</p>
        </div>
        <div>
          <p>10.16.&nbsp;ALICI&rsquo;nın&nbsp;Platform&rsquo;dan&nbsp;duyurulan zamanlarda sipariş edebileceği
            &uuml;r&uuml;n adetlerine kısıt getirilebilir.&nbsp;ALICI&rsquo;nın&nbsp;Platform&rsquo;dan&nbsp;yapılan
            duyurularda belirtilen&nbsp;adetin&nbsp;&uuml;zerinde &uuml;r&uuml;n sipariş etmesi halinde siparişler iptal
            edilebilecek ve yasal s&uuml;resi i&ccedil;erisinde &uuml;r&uuml;n bedelleri&nbsp;ALICI&rsquo;ya&nbsp;iade
            edilecektir. ALICI işbu hususları kabul ederek siparişini oluşturduğunu, adet sınırlamasını ge&ccedil;en
            siparişlerde&nbsp;MURAT S&Ouml;YLER TEKSTİL SANAYİ TİCARET LTD.
            ŞTİ&nbsp;ve/veya&nbsp;SATICI&rsquo;nın&nbsp;siparişi iptal etme hakkının olduğunu kabul, beyan ve taahh&uuml;t
            eder.&nbsp;</p>
        </div>
        <div>
          <p>10.17.&nbsp;MURAT S&Ouml;YLER TEKSTİL SANAYİ TİCARET LTD. ŞTİ,&nbsp;SATICI&rsquo;nın&nbsp;herhangi bir
            sebeple tedarik edemediği siparişleri, mevzuattaki teslim s&uuml;resini aşmamak
            ve&nbsp;ALICI&rsquo;nın&nbsp;&uuml;r&uuml;n&uuml; ile aynı &ouml;zellikleri haiz olmak kaydıyla, bir başka
            satıcıya aktarma hakkına sahiptir. B&ouml;yle bir durumda &uuml;r&uuml;n yeni satıcı
            tarafından&nbsp;ALICI&rsquo;ya&nbsp;g&ouml;nderilecek olup mesafeli satış s&ouml;zleşmesi yeni satıcı ile
            ALICI arasında kurulmuş olacaktır.&nbsp;MURAT S&Ouml;YLER TEKSTİL SANAYİ TİCARET LTD. ŞTİ&nbsp;ve/veya
            SATICI,&nbsp;ALICI&rsquo;ya&nbsp;herhangi bir ek bedel, &uuml;cret ve/veya masraf yansıtmayacaktır..&nbsp;</p>
        </div>
        <div>
          <p>11. &Ouml;ZEL ŞARTLAR&nbsp;</p>
        </div>
        <div>
          <p>8&nbsp;</p>
        </div>
        <div>
          <p>11.1. ALICI&nbsp;Platform&rsquo;da&nbsp;aynı sepet i&ccedil;erisinde farklı kategorilerden alınan
            &uuml;r&uuml;nlerin her biri i&ccedil;in SATICI tarafından tek fatura kesilebilecektir. Ş&uuml;pheye mahal
            bırakmamak bakımından belirtilmelidir ki, SATICI&nbsp;ALICI&rsquo;nın&nbsp;aldığı &uuml;r&uuml;nlerin
            teslimatını mevzuattaki yasal s&uuml;re i&ccedil;erisinde kalmak koşuluyla farklı zamanlarda
            ger&ccedil;ekleştirebilecektir.&nbsp;</p>
        </div>
        <div>
          <p>11.2. Bankanız kampanyalar d&uuml;zenleyerek sizin se&ccedil;tiğiniz taksit adedinin daha &uuml;st&uuml;nde
            bir taksit adedi uygulayabilir, taksit &ouml;teleme gibi hizmetler sunulabilir. Bu t&uuml;r kampanyalar
            bankanızın&nbsp;inisiyatifindedir&nbsp;ve&nbsp;MURAT S&Ouml;YLER TEKSTİL SANAYİ TİCARET
            LTD.&nbsp;ŞTİ&rsquo;in&nbsp;bilgisi d&acirc;hilinde olması durumunda sayfalarımızda kampanyalar hakkında bilgi
            verilmektedir. Kredi kartınızın hesap kesim tarihinden itibaren sipariş toplamı taksit adedine
            b&ouml;l&uuml;nerek kredi kartı &ouml;zetinize bankanız tarafından yansıtılacaktır. Banka taksit tutarlarını
            k&uuml;surat farklarını dikkate alarak aylara eşit olarak dağıtmayabilir. Detaylı &ouml;deme planınızın
            oluşturulması bankanız&nbsp;inisiyatifindedir.&nbsp;</p>
        </div>
        <div>
          <p>11.3. Dijital &uuml;r&uuml;n satışlarında Satıcı, Alıcı&apos;ya &uuml;r&uuml;nlerin Alıcı&rsquo;ya tam ve
            gereği gibi iletildiği ve g&ouml;nderilen kodların eksiksiz şekilde &ccedil;alıştığını kanıtlayan t&uuml;m
            bilgi ve belgeleri ve g&uuml;venli şekilde tutulmuş&nbsp;log&nbsp;kayıtlarını&nbsp;Murat
            S&ouml;yler&nbsp;Teksil&rsquo;e&nbsp;iletmekle y&uuml;k&uuml;ml&uuml;d&uuml;r. Aksi halde&nbsp;MURAT
            S&Ouml;YLER TEKSTİL SANAYİ TİCARET LTD.&nbsp;ŞTİ&rsquo;in&nbsp;4.28. maddeden doğan hakları saklıdır.&nbsp;
          </p>
        </div>
        <div>
          <p>12. KİŞİSEL VERİLERİN KORUNMASI, TİCARİ ELEKTRONİK İLETİ VE FİKRİ-SINAİ HAKLAR İLE İLGİLİ KURALLAR&nbsp;</p>
        </div>
        <div>
          <p>12.1. 6698 sayılı Kişisel Verilerin Korunması Kanunu kapsamında kişisel veri olarak
            tanımlanabilecek&nbsp;ALICI&rsquo;ya&nbsp;ait ad,&nbsp;soyad, e-posta adresi, T.C. Kimlik numarası, demografik
            veriler, mali veriler vb. bilgiler;&nbsp;</p>
        </div>
        <div>
          <p>* sipariş almak, &uuml;r&uuml;n ve hizmetleri sunmak, &uuml;r&uuml;n ve hizmetleri geliştirmek, sistemsel
            sorunların &ccedil;&ouml;z&uuml;m&uuml;, &ouml;deme işlemlerini ger&ccedil;ekleştirmek, -&ouml;nceden onay
            verilmesi halinde- siparişler, &uuml;r&uuml;nler ve hizmetler hakkında pazarlama faaliyetlerinde
            kullanılmak,&nbsp;ALICI&rsquo;ya&nbsp;ait bilgilerin g&uuml;ncellenmesinde ve &uuml;yeliklerin y&ouml;netimi
            ve s&uuml;rd&uuml;r&uuml;lmesi ile ALICI ile SATICI arasında kurulan mesafeli satış s&ouml;zleşmesi ve sair
            s&ouml;zleşmelerin ifası amacıyla ve 3. kişilerin teknik, lojistik ve benzeri diğer işlevlerinin SATICI
            tarafından sağlanabilmesi i&ccedil;in yukarıda sayılan verileri&nbsp;MURAT S&Ouml;YLER TEKSTİL SANAYİ TİCARET
            LTD.&nbsp;ŞTİ,&nbsp;ve &uuml;&ccedil;&uuml;nc&uuml; kişi ve/veya kuruluşlar tarafından
            s&uuml;resiz/s&uuml;reli kaydedilebilir, yazılı/manyetik arşivlerde muhafaza edilebilir, kullanılabilir,
            g&uuml;ncellenebilir, paylaşılabilir, transfer olunabilir ve sair suretler ile işlenebilir.&nbsp;</p>
        </div>
        <div>
          <p>12.2.&nbsp;ALICILAR&rsquo;a, y&uuml;r&uuml;rl&uuml;kteki mevzuata uygun şekilde, her t&uuml;rl&uuml;
            &uuml;r&uuml;n ve hizmetlere ilişkin tanıtım, reklam, iletişim,&nbsp;promosyon, satış ve pazarlama amacıyla,
            kredi kartı ve &uuml;yelik bilgilendirme, işlem, uygulamaları i&ccedil;in&nbsp;MURAT S&Ouml;YLER TEKSTİL
            SANAYİ TİCARET LTD. ŞTİ&nbsp;tarafından SMS/kısa mesaj, anlık bildirim, otomatik arama, bilgisayar, telefon,
            e-posta/mail, faks, diğer elektronik iletişim ara&ccedil;ları ile ticari elektronik iletişimler yapılabilir,
            ALICI kendisine ticari elektronik iletiler g&ouml;nderilmesini kabul etmiştir.&nbsp;</p>
        </div>
        <div>
          <p>9&nbsp;</p>
        </div>
        <div>
          <p>12.3. ALICI tarafından&nbsp;Platform&rsquo;a&nbsp;girilen bilgilerin ve işlemlerin g&uuml;venliği i&ccedil;in
            gerekli &ouml;nlemler,&nbsp;MURAT S&Ouml;YLER TEKSTİL SANAYİ TİCARET LTD. ŞTİ&nbsp;tarafındaki kendi sistem
            altyapısında, bilgi ve işlemin mahiyetine g&ouml;re g&uuml;n&uuml;m&uuml;z
            teknik&nbsp;imkanları&nbsp;&ouml;l&ccedil;&uuml;s&uuml;nde alınmıştır. Bununla beraber, s&ouml;z konusu
            bilgiler&nbsp;ALICI&rsquo;ya&nbsp;ait cihazlardan girildiğinden ALICI tarafından korunmaları ve ilgisiz
            kişilerce erişilememesi i&ccedil;in, vir&uuml;s ve benzeri zararlı uygulamalara ilişkin olanlar&nbsp;dahil,
            gerekli tedbirlerin alınması sorumluluğu&nbsp;ALICI&rsquo;ya&nbsp;aittir.&nbsp;</p>
        </div>
        <div>
          <p>12.4. ALICI,&nbsp;MURAT S&Ouml;YLER TEKSTİL SANAYİ TİCARET LTD.&nbsp;ŞTİ&rsquo;e&nbsp;belirtilen iletişim
            kanallarından ulaşarak veri kullanımı-işlenmelerini ve/veya iletişimleri her zaman i&ccedil;in durdurulmasını
            talep edebilir.&nbsp;ALICI&rsquo;nın&nbsp;bu husustaki a&ccedil;ık bildirimine g&ouml;re, kişisel veri
            işlemleri ve/veya tarafına iletişimler yasal azami s&uuml;re i&ccedil;inde durdurulur; ayrıca dilerse, hukuken
            muhafazası gerekenler ve/veya m&uuml;mk&uuml;n olanlar haricindeki bilgileri, veri kayıt sisteminden silinir
            ya da kimliği belli olmayacak bi&ccedil;imde anonim hale getirilir.&nbsp;ALICI isterse kişisel verilerinin
            işlenmesi ile ilgili işlemler, aktarıldığı kişiler, eksik veya yanlış olması halinde d&uuml;zeltilmesi,
            d&uuml;zeltilen bilgilerin ilgili &uuml;&ccedil;&uuml;nc&uuml; kişilere bildirilmesi, verilerin silinmesi veya
            yok edilmesi, otomatik sistemler ile analiz edilmesi sureti ile kendisi aleyhine bir sonucun ortaya
            &ccedil;ıkmasına itiraz, verilerin kanuna aykırı olarak işlenmesi sebebi ile zarara uğrama halinde giderilmesi
            gibi konularda&nbsp;MURAT S&Ouml;YLER TEKSTİL SANAYİ TİCARET LTD.&nbsp;ŞTİ&rsquo;e&nbsp;her zaman başvurabilir
            ve bilgi alabilir.&nbsp;S&ouml;z konusu başvurular incelenerek yasal s&uuml;resi
            i&ccedil;erisinde&nbsp;ALICI&rsquo;ya&nbsp;mevzuatta &ouml;ng&ouml;r&uuml;len s&uuml;relerde d&ouml;n&uuml;ş
            yapılacaktır.&nbsp;</p>
        </div>
        <div>
          <p>12.5.&nbsp;Platform&rsquo;a&nbsp;ait her t&uuml;rl&uuml; bilgi ve i&ccedil;erik ile bunların
            d&uuml;zenlenmesi,&nbsp;revizyonu&nbsp;ve kısmen/tamamen kullanımı konusunda;&nbsp;MURAT S&Ouml;YLER TEKSTİL
            SANAYİ TİCARET LTD.&nbsp;ŞTİ&rsquo;in&nbsp;anlaşmasına g&ouml;re diğer &uuml;&ccedil;&uuml;nc&uuml; şahıslara
            ait olanlar hari&ccedil;; t&uuml;m fikri-sınai haklar ve m&uuml;lkiyet hakları&nbsp;MURAT S&Ouml;YLER TEKSTİL
            SANAYİ TİCARET LTD.&nbsp;ŞTİ&rsquo;e&nbsp;aittir.&nbsp;</p>
        </div>
        <div>
          <p>12.6.&nbsp;Platform&rsquo;dan&nbsp;ulaşılan diğer sitelerde kendilerine ait gizlilik-g&uuml;venlik
            politikaları ve kullanım şartları ge&ccedil;erlidir, oluşabilecek ihtilaflar ile menfi
            neticelerinden&nbsp;MURAT S&Ouml;YLER TEKSTİL SANAYİ TİCARET LTD. ŞTİ&nbsp;sorumlu değildir.&nbsp;</p>
        </div>
        <div>
          <p>13. CAYMA HAKKI&nbsp;</p>
        </div>
        <div>
          <p>13.1. ALICI hi&ccedil;bir hukuki ve cezai sorumluluk &uuml;stlenmeksizin ve hi&ccedil;bir gerek&ccedil;e
            g&ouml;stermeksizin satın aldığı mal/hizmeti teslim tarihinden itibaren 14 (on beş) g&uuml;n i&ccedil;erisinde
            cayma hakkını kullanarak iade edebilir.&nbsp;</p>
        </div>
        <div>
          <p>13.2. Cayma hakkı bildirimi ve&nbsp;S&ouml;zleşme&rsquo;ye&nbsp;ilişkin
            bildirimler&nbsp;Platform&rsquo;da&nbsp;belirtilen iletişim kanalları ile g&ouml;sterilecektir. Cayma
            bildiriminin yapılacağı iletişim kanallarına <a href="https://www.murattekstil.com.tr/" target="_blank"
              rel="noreferrer noopener">https://www.murattekstil.com.tr/</a> iletisim.html linkinden ulaşılabilir.&nbsp;
          </p>
        </div>
        <div>
          <p>13.3. Cayma hakkının kullanılması i&ccedil;in s&uuml;resi i&ccedil;erisinde SATICI veya&nbsp;MURAT
            S&Ouml;YLER TEKSTİL SANAYİ TİCARET LTD.&nbsp;ŞTİ&rsquo;in&nbsp;mevzuat h&uuml;k&uuml;mlerine
            ve&nbsp;Platform&rsquo;daki&nbsp;cayma hakkı kullanım se&ccedil;eneğine uygun olarak bildirimde bulunulması
            şarttır.&nbsp;</p>
        </div>
        <div>
          <p>13.5. Cayma hakkının kullanılması halinde:&nbsp;</p>
        </div>
        <div>
          <p>10&nbsp;</p>
        </div>
        <div>
          <p>a) ALICI cayma hakkını kullanmasından itibaren 10 (on) g&uuml;n i&ccedil;erisinde
            Malı&nbsp;SATICI&apos;ya&nbsp;anlaşmalı kargo şirketiyle geri g&ouml;nderir.&nbsp;</p>
        </div>
        <div>
          <p>b) Cayma hakkı kapsamında iade edilecek Mal kutusu, ambalajı, varsa standart aksesuarları varsa Mal ile
            birlikte hediye edilen diğer &uuml;r&uuml;nlerin de eksiksiz ve hasarsız olarak iade edilmesi
            gerekmektedir.&nbsp;</p>
        </div>
        <div>
          <p>13.6. ALICI cayma s&uuml;resi i&ccedil;inde malı, işleyişine, teknik &ouml;zelliklerine ve kullanım
            talimatlarına uygun bir şekilde kullandığı takdirde meydana gelen değişiklik ve bozulmalardan sorumlu
            değildir.&nbsp;</p>
        </div>
        <div>
          <p>13.7. Cayma hakkının kullanılmasını takip eden 14 (on d&ouml;rt) g&uuml;n i&ccedil;erisinde Mal
            bedeli&nbsp;ALICI&rsquo;ya&nbsp;&ouml;dediği şekilde iade edilir. Mal,&nbsp;SATICI&apos;ya&nbsp;iade
            edilirken, Malın teslimi sırasında&nbsp;ALICI&rsquo;ya&nbsp;ibraz edilmiş olan orijinal faturanın da ALICI
            tarafından iade edilmesi gerekmektedir.&nbsp;</p>
        </div>
        <div>
          <p>13.8. ALICI iade edeceği Malı &ouml;n bilgilendirme formunda belirtilen&nbsp;SATICI&apos;nın&nbsp;anlaşmalı
            kargo şirketi ile&nbsp;SATICI&apos;ya&nbsp;g&ouml;nderdiği s&uuml;rece iade kargo
            bedeli&nbsp;SATICI&apos;ya&nbsp;aittir. İade i&ccedil;in&nbsp;ALICI&rsquo;nın&nbsp;bulunduğu
            yerde&nbsp;SATICI&rsquo;nın&nbsp;anlaşmalı kargo şirketi şubesi bulunmaması halinde ALICI herhangi bir kargo
            şirketiyle g&ouml;nderebilecektir, bu halde kargo
            bedeli&nbsp;ALICI&rsquo;ya&nbsp;aittir.&nbsp;ALICI&rsquo;nın&nbsp;iade edeceği Malı &Ouml;n Bilgilendirme
            Formunda belirtilen&nbsp;SATICI&apos;nın&nbsp;anlaşmalı kargo şirketi dışında bir kargo şirketi ile
            g&ouml;ndermesi halinde iade kargo bedeli ve Malın kargo s&uuml;recinde uğrayacağı hasardan SATICI sorumlu
            değildir.&nbsp;</p>
        </div>
        <div>
          <p>13.9.&nbsp;ALICI&rsquo;nın&nbsp;cayma hakkını kullandığı durumlarda ya da siparişe konu olan
            &uuml;r&uuml;n&uuml;n &ccedil;eşitli sebeplerle tedarik edilememesi veya hakem heyeti kararları
            ile&nbsp;ALICI&rsquo;ya&nbsp;bedel iadesine karar verilen durumlarda, alışveriş kredi kartı ile ve taksitli
            olarak yapılmışsa, kredi kartına iade&nbsp;prosed&uuml;r&uuml;&nbsp;aşağıda belirtilmiştir:&nbsp;</p>
        </div>
        <div>
          <p>ALICI &uuml;r&uuml;n&uuml; ka&ccedil; taksit ile aldıysa Banka&nbsp;ALICI&rsquo;ya&nbsp;geri &ouml;demesini
            taksitle yapmaktadır. SATICI bankaya &uuml;r&uuml;n bedelinin tamamını tek seferde &ouml;dedikten sonra, Banka
            poslarından yapılan taksitli harcamaların&nbsp;ALICI&rsquo;nın&nbsp;kredi kartına iadesi durumunda, konuya
            m&uuml;dahil tarafların mağdur duruma d&uuml;şmemesi i&ccedil;in talep edilen iade tutarları, yine taksitli
            olarak hamil taraf hesaplarına Banka tarafından aktarılır.&nbsp;ALICI&rsquo;nın&nbsp;satış iptaline kadar
            &ouml;demiş olduğu taksit tutarları, eğer iade tarihi ile kartın hesap kesim tarihleri &ccedil;akışmazsa her
            ay karta 1 (bir) iade yansıyacak ve ALICI iade &ouml;ncesinde &ouml;demiş olduğu taksitleri satışın taksitleri
            bittikten sonra, iade &ouml;ncesinde &ouml;demiş olduğu taksitleri sayısı kadar ay daha alacak ve mevcut
            bor&ccedil;larından d&uuml;şm&uuml;ş olacaktır.&nbsp;</p>
        </div>
        <div>
          <p>14. CAYMA HAKKININ KULLANILAMAYACAĞI HALLER&nbsp;</p>
        </div>
        <div>
          <p>14.1. ALICI aşağıdaki s&ouml;zleşmelerde cayma hakkını kullanamaz:&nbsp;</p>
        </div>
        <div>
          <p>a) Fiyatı finansal piyasalardaki dalgalanmalara bağlı olarak değişen ve SATICI veya&nbsp;MURAT S&Ouml;YLER
            TEKSTİL SANAYİ TİCARET LTD.&nbsp;ŞTİ&rsquo;in&nbsp;kontrol&uuml;nde olmayan mal veya hizmetlere ilişkin
            s&ouml;zleşmeler&nbsp;</p>
        </div>
        <div>
          <p>11&nbsp;</p>
        </div>
        <div>
          <p>b) T&uuml;keticinin istekleri veya kişisel ihtiya&ccedil;ları doğrultusunda hazırlanan mallara ilişkin
            s&ouml;zleşmeler&nbsp;</p>
        </div>
        <div>
          <p>c) &Ccedil;abuk bozulabilen veya son kullanma tarihi ge&ccedil;ebilecek malların teslimine ilişkin
            s&ouml;zleşmeler&nbsp;</p>
        </div>
        <div>
          <p>&ccedil;) Tesliminden sonra ambalaj, bant, m&uuml;h&uuml;r, paket gibi koruyucu unsurları a&ccedil;ılmış olan
            mallardan; iadesi sağlık ve&nbsp;hijyen&nbsp;a&ccedil;ısından uygun olmayanların teslimine ilişkin
            s&ouml;zleşmeler.&nbsp;</p>
        </div>
        <div>
          <p>d) Tesliminden sonra başka &uuml;r&uuml;nlerle karışan ve doğası gereği ayrıştırılması m&uuml;mk&uuml;n
            olmayan mallara ilişkin s&ouml;zleşmeler.&nbsp;</p>
        </div>
        <div>
          <p>e) Malın tesliminden sonra ambalaj, bant, m&uuml;h&uuml;r, paket gibi koruyucu unsurları a&ccedil;ılmış
            olması halinde maddi ortamda sunulan kitap, dijital i&ccedil;erik ve bilgisayar sarf malzemelerine ilişkin
            s&ouml;zleşmeler.&nbsp;</p>
        </div>
        <div>
          <p>f) Abonelik s&ouml;zleşmesi kapsamında sağlananlar dışında gazete ve dergi gibi s&uuml;reli yayınların
            teslimine ilişkin s&ouml;zleşmeler.&nbsp;</p>
        </div>
        <div>
          <p>g) Belirli bir tarihte veya d&ouml;nemde yapılması gereken, konaklama, eşya taşıma, araba kiralama, yiyecek
            i&ccedil;ecek tedariki ve eğlence veya dinlenme amacıyla yapılan boş zamanın değerlendirilmesine ilişkin
            s&ouml;zleşmeler.&nbsp;</p>
        </div>
        <div>
          <p>ğ) Elektronik ortamda anında ifa edilen hizmetler ile&nbsp;ALICI&rsquo;ya&nbsp;anında teslim edilen gayri
            maddi mallara ilişkin s&ouml;zleşmeler.&nbsp;</p>
        </div>
        <div>
          <p>h) Cayma hakkı s&uuml;resi sona ermeden &ouml;nce,&nbsp;ALICI&rsquo;nın&nbsp;onayı ile ifasına başlanan
            hizmetlere ilişkin s&ouml;zleşmeler.&nbsp;</p>
        </div>
        <div>
          <p>S&ouml;zleşmeye konu Mal/Hizmet&apos;in&nbsp;Mesafeli S&ouml;zleşmeler Y&ouml;netmeliği&apos;nin uygulama
            alanı dışında bırakılmış olan (SATICI&rsquo;nın&nbsp;d&uuml;zenli teslimatları
            ile&nbsp;ALICInın&nbsp;meskenine teslim edilen gıda maddelerinin, i&ccedil;eceklerin ya da diğer
            g&uuml;nl&uuml;k t&uuml;ketim maddeleri ile seyahat, konaklama, lokantacılık, eğlence sekt&ouml;r&uuml; gibi
            alanlarda hizmetler) Mal/Hizmet t&uuml;rlerinden m&uuml;teşekkil olması halinde ALICI ve SATICI arasındaki
            hukuki ilişkiye Mesafeli S&ouml;zleşmeler Y&ouml;netmeliği h&uuml;k&uuml;mleri uygulanamaması sebebiyle cayma
            hakkı kullanılamayacaktır.&nbsp;</p>
        </div>
        <div>
          <p>14.2.&nbsp;MURAT S&Ouml;YLER TEKSTİL SANAYİ TİCARET LTD.&nbsp;ŞTİ&rsquo;e&nbsp;ait Platform &uuml;zerinden
            ELEKTRONİK KOD SATIN ALINDIĞI DURUMLARDA bahse konu siparişlerde Mesafeli S&ouml;zleşmeler
            Y&ouml;netmeliği&rsquo;nin 15/1.ğ maddesi gereği cayma hakkı s&ouml;z konusu olmayacaktır. Bu siparişler
            bakımından internet sitesi &uuml;zerinden iade kodu da oluşturulamayacaktır.&nbsp;</p>
        </div>
        <div>
          <p>15. UYUŞMAZLIKLARIN &Ccedil;&Ouml;Z&Uuml;M&Uuml;&nbsp;</p>
        </div>
        <div>
          <p>15.1. İşbu Mesafeli Satış S&ouml;zleşmesi&apos;nin uygulanması sırasında meydana gelebilecek ihtilaflarda
            yahut &ccedil;ekişmesiz işlerde&nbsp;Bursa&nbsp;Mahkemeleri ve İcra Daireleri yetkilidir.&nbsp;</p>
        </div>
        <div>
          <p>12&nbsp;</p>
        </div>
        <div>
          <p>15.2 İşbu Mesafeli Satış S&ouml;zleşmesi&apos;nin uygulanmasında, Ticaret Bakanlığınca ilan edilen değere
            kadar T&uuml;ketici Hakem Heyetleri ile T&uuml;ketici Mahkemeleri yetkilidir.&nbsp;</p>
        </div>
        <div>
          <p>15.3. 6502 Sayılı T&uuml;keticinin Korunması Hakkında Kanun&apos;un 68. maddesinin 1. fıkrasında belirtilen
            alt ve &uuml;st limitler doğrultusunda t&uuml;ketici talepleri hakkında t&uuml;ketici hakem heyetleri
            yetkilidir.&nbsp;</p>
        </div>
        <div>
          <p>16. MALIN/HİZMETİN FİYATI&nbsp;</p>
        </div>
        <div>
          <p>Malın peşin veya vadeli satış fiyatı, sipariş formunda yer almakla birlikte, sipariş sonu g&ouml;nderilen
            bilgilendirme maili ve &uuml;r&uuml;n ile birlikte m&uuml;şteriye g&ouml;nderilen fatura i&ccedil;eriğinde
            mevcut olan fiyattır. SATICI veya&nbsp;MURAT S&Ouml;YLER TEKSTİL SANAYİ TİCARET LTD. ŞTİ&nbsp;tarafından
            yapılan indirimler, kuponlar, kargo &uuml;creti ve sair uygulamalar satış fiyatına yansıtılır.&nbsp;</p>
        </div>
        <div>
          <p>17. TEMERR&Uuml;D HALİ VE HUKUKİ SONU&Ccedil;LARI&nbsp;</p>
        </div>
        <div>
          <p>17.1.&nbsp;SATICI&rsquo;nın&nbsp;&ouml;demekle y&uuml;k&uuml;ml&uuml; olduğu bedelin %50&apos;si işbu
            s&ouml;zleşmenin tebliğine istinaden peşin ve kalan 50% mal tesliminden 60 g&uuml;n
            sonra&nbsp;&hellip;&hellip;&hellip;...&hellip;&hellip;&hellip;&nbsp;tarihinde&nbsp;TL bazında banka
            havalesiyle peşin &ouml;denecektir.&nbsp;</p>
        </div>
        <div>
          <p>17.2. Vadesinde yapılmayan &ouml;demelerde, aylık % 3 faiz işletilir.&nbsp;</p>
        </div>
        <div>
          <p>17.3. İşbu siparişin verilmesi ile alıcı taraf, satın aldığı &uuml;r&uuml;nlerin bedellerinin vadesi hakkında
            ihtar edilmiş olur. Karşı taraf, vade tarihinde borcunu &ouml;demediği takdirde kendisine ek bir ihtar
            yapılması gerekmeksizin temerr&uuml;de d&uuml;şer ve satıcı temerr&uuml;t faizine hak kazanır. (TTK
            1530/2)&nbsp;</p>
        </div>
        <div>
          <p>17.4.&nbsp;ALICI&rsquo;nın, kredi kartı ile yapmış olduğu işlemlerde temerr&uuml;de d&uuml;şmesi halinde kart
            sahibi bankanın kendisi ile yapmış olduğu kredi kartı s&ouml;zleşmesi &ccedil;er&ccedil;evesinde, faiz
            &ouml;deyecek ve bankaya karşı sorumlu olacaktır. Bu durumda ilgili banka hukuki yollara başvurabilir, doğacak
            masrafları ve vek&acirc;let &uuml;cretini&nbsp;ALICI&rsquo;dan&nbsp;talep edebilir ve her
            koşulda&nbsp;ALICI&rsquo;nın&nbsp;borcundan dolayı temerr&uuml;de d&uuml;şmesi
            halinde,&nbsp;ALICI&rsquo;nın&nbsp;borcu gecikmeli ifasından dolayı&nbsp;SATICI&apos;nın&nbsp;uğradığı zarar
            ve ziyandan ALICI sorumlu olacaktır.&nbsp;</p>
        </div>
        <div>
          <p>17.5.&nbsp;ALICI&rsquo;nın&nbsp;kredi kartı ile yapmış olduğu işlemlerde temerr&uuml;de d&uuml;şmesi halinde
            kart sahibi bankanın kendisi ile yapmış olduğu kredi kartı s&ouml;zleşmesi &ccedil;er&ccedil;evesinde
            &ouml;deyeceği faiz,&nbsp;SATICI&rsquo;ya&nbsp;&ouml;demekle y&uuml;k&uuml;ml&uuml; olduğu temerr&uuml;t
            faizinden m&uuml;stesna olup, aylık %3 oranında &ouml;denecek temerr&uuml;t faizinin işlemesine engel teşkil
            etmez.&nbsp;</p>
        </div>
        <div>
          <p>18. BİLDİRİMLER ve DELİL S&Ouml;ZLEŞMESİ&nbsp;</p>
        </div>
        <div>
          <p>18.1. İşbu S&ouml;zleşme tahtında Taraflar arasında yapılacak her t&uuml;rl&uuml; yazışma, mevzuatta sayılan
            zorunlu haller dışında, e-mail aracılığıyla yapılacaktır.&nbsp;</p>
        </div>
        <div>
          <p>18.2. ALICI, işbu&nbsp;S&ouml;zleşme&apos;den&nbsp;doğabilecek
            ihtilaflarda&nbsp;SATICI&apos;nın&nbsp;ve&nbsp;MURAT S&Ouml;YLER TEKSTİL SANAYİ TİCARET
            LTD.&nbsp;ŞTİ&rsquo;in&nbsp;resmi defter ve ticari kayıtlarıyla, kendi veri&nbsp;tabanında, sunucularında
            tuttuğu elektronik bilgilerin ve bilgisayar kayıtlarının, bağlayıcı, kesin ve m&uuml;nhasır delil teşkil
            edeceğini, bu maddenin Hukuk Muhakemeleri Kanunu&apos;nun 193. maddesi anlamında delil s&ouml;zleşmesi
            niteliğinde olduğunu kabul, beyan ve taahh&uuml;t eder.&nbsp;</p>
        </div>
        <div>
          <p>13&nbsp;</p>
        </div>
        <div>
          <p>19. Y&Uuml;R&Uuml;RL&Uuml;K&nbsp;</p>
        </div>
        <div>
          <p>19.1. İşbu belge taraflar arasındaki&nbsp;mutakabat&nbsp;sonucunda oluşturulan nihai s&ouml;zleşmedir. Alıcı
            siparişin durumunda ve adetlerinde, modellerde değişiklik yapamaz. Ancak bazı durumlarda satıcının yazılı
            onayına istinaden değişiklikler satıcı&nbsp;insiyatifinde&nbsp;kabul edilebilir.&nbsp;</p>
        </div>
        <div>
          <p>19.2 .&nbsp;19 (on dokuz) maddeden ibaret bu S&ouml;zleşme, Taraflarca okunarak, işlem tarihinde, ALICI
            tarafından elektronik ortamda onaylanmak suretiyle akdedilmiş ve y&uuml;r&uuml;rl&uuml;ğe girmiştir.
            S&ouml;zleşmenin bir n&uuml;shası&nbsp;ALICI&rsquo;nın&nbsp;&uuml;yelik hesabında mevcuttur ve talep edilmesi
            halinde ayrıca e-posta ile de g&ouml;nderilebilecektir.&nbsp;</p>
        </div>
        <div>
          <p>&nbsp;</p>
        </div>
      </div>
      <div><br></div>
    </div>
    <div v-else-if="firma == 'Buldans'">
      <div>
        <p>1</p>
        <p>MESAFELİ SATIŞ S&Ouml;ZLEŞMESİ</p>
        <p>D&Ouml;NMEZ EV TEKSTİLİ VE GİYİM SAN. VE TİC. A.Ş</p>
        <p>1. TARAFLAR</p>
        <p>
          İşbu Mesafeli Satış S&ouml;zleşmesi (&quot;S&ouml;zleşme&quot;); adresi 7.
          maddede belirtilen (&quot;ALICI&rdquo;) ile adresi 6. Maddede belirtilen
          (&ldquo;SATICI&rdquo;) arasında aşağıda belirtilen h&uuml;k&uuml;m ve
          şartlar &ccedil;er&ccedil;evesinde elektronik ortamda kurulmuştur.
        </p>
        <p>2. TANIMLAR</p>
        <p>
          İşbu s&ouml;zleşmenin uygulanmasında ve yorumlanmasında aşağıda yazılı
          terimler karşılarındaki yazılı a&ccedil;ıklamaları ifade edeceklerdir.
        </p>
        <p>
          ALICI :Bir mal veya hizmeti ticari veya mesleki olmayan ama&ccedil;larla
          edinen, kullanan veya yararlanan ger&ccedil;ek ya da t&uuml;zel kişiyi,
        </p>
        <p>Bakan :Ticaret Bakanı&rsquo;nı,</p>
        <p>Bakanlık :Ticaret Bakanlığı&rsquo;nı,</p>
        <p>
          D&Ouml;NMEZ EV TEKSTİLİ VE GİYİM SAN. VE TİC. A.Ş:
          SATICI&rsquo;lar&rsquo;ın &uuml;r&uuml;n ve hizmet sunduğu
          Platform&rsquo;u sağlayan aracı hizmet sağlayıcısı olan D&Ouml;NMEZ EV
          TEKSTİLİ VE GİYİM SAN. VE TİC. A.Ş Şirketi
        </p>
        <p>
          Hizmet :Bir &uuml;cret veya menfaat karşılığında yapılan ya da yapılması
          taahh&uuml;t edilen mal sağlama dışındaki her t&uuml;rl&uuml;
          t&uuml;ketici işleminin konusu,
        </p>
        <p>Kanun :T&uuml;keticinin Korunması Hakkında Kanun&rsquo;u,</p>
        <p>
          Platform :D&Ouml;NMEZ EV TEKSTİLİ VE GİYİM SAN. VE TİC. A.Ş&rsquo;e ait
          <a data-fr-linked="true" href="//www.buldans.com.tr">www.buldans.com.tr</a>
          adlı internet sitesini ve mobil uygulamasını,
        </p>
        <p>
          SATICI:Kamu t&uuml;zel kişileri de dahil olmak &uuml;zere ticari veya
          mesleki ama&ccedil;larla t&uuml;keticiye mal sunan ya da mal sunanın adına
          ya da hesabına hareket eden ve S&ouml;zleşme&rsquo;nin 6. maddesinde
          bilgileri bulunan ger&ccedil;ek ve/veya t&uuml;zel kişiyi,
        </p>
        <p>
          Sipariş Veren :Bir mal veya hizmeti D&Ouml;NMEZ EV TEKSTİLİ VE GİYİM SAN.
          VE TİC. A.Ş&rsquo;e ait
          <a data-fr-linked="true" href="//www.buldans.com.tr">www.buldans.com.tr</a>
          adlı internet sitesi veya mobil uygulaması &uuml;zerinden talep eden
          ger&ccedil;ek ya da t&uuml;zel kişiyi,
        </p>
        <p>
          S&ouml;zleşme :SATICI ve ALICI arasında akdedilen işbu
          S&ouml;zleşme&rsquo;yi,
        </p>
        <p>Taraflar :SATICI ve ALICI&rsquo;yı,</p>
        <p>
          &Uuml;r&uuml;n veya &Uuml;r&uuml;nler :Alışverişe konu olan taşınır
          t&uuml;m eşya.
        </p>
        <p>Y&ouml;netmelik :Mesafeli Satışlar Y&ouml;netmeliği&rsquo;ni,</p>
        <p>3. S&Ouml;ZLEŞMENİN KONUSU ve KAPSAMI</p>
        <p>
          İşbu S&ouml;zleşme 6502 Sayılı T&uuml;keticinin Korunması Hakkında Kanun
          ve Mesafeli S&ouml;zleşmeler Y&ouml;netmeliği&apos;ne uygun olarak
          d&uuml;zenlenmiştir. Taraflar işbu S&ouml;zleşme tahtında 6502 Sayılı
          T&uuml;keticinin Korunması Hakkında Kanun ve Mesafeli S&ouml;zleşmeler
          Y&ouml;netmeliği&apos;nden kaynaklanan y&uuml;k&uuml;ml&uuml;l&uuml;k ve
          sorumluluklarını bildiklerini ve anladıklarını kabul ve beyan ederler.
          İşbu S&ouml;zleşmenin konusunu ALICI&apos;nın, D&Ouml;NMEZ EV TEKSTİLİ VE
          GİYİM SAN. VE TİC. A.Ş&apos;e ait Platform&rsquo;da, Mal/Hizmet satışa
          sunan SATICI&apos;ya ait Mal/Hizmetin satın alınmasına y&ouml;nelik
          elektronik olarak sipariş verdiği, S&ouml;zleşme&rsquo;de belirtilen
          niteliklere sahip Mal/Hizmetin satışı ve teslimi ile ilgili olarak 6502
          Sayılı T&uuml;keticinin Korunması Hakkındaki
        </p>
        <p>2</p>
        <p>
          Kanun ve Mesafeli S&ouml;zleşmeler Y&ouml;netmeliği h&uuml;k&uuml;mleri
          gereğince Taraflar&rsquo;ın hak ve y&uuml;k&uuml;ml&uuml;l&uuml;klerinin
          saptanması oluşturur. İşbu S&ouml;zleşme&rsquo;nin akdedilmesi
          Taraflar&rsquo;ın ayrı ayrı D&Ouml;NMEZ EV TEKSTİLİ VE GİYİM SAN. VE TİC.
          A.Ş ile akdetmiş oldukları &uuml;yelik s&ouml;zleşmelerinin
          h&uuml;k&uuml;mlerinin ifasını engellemeyecek olup Taraflar işbu
          S&ouml;zleşme konusu Mal/Hizmetin satışında D&Ouml;NMEZ EV TEKSTİLİ VE
          GİYİM SAN. VE TİC. A.Ş&rsquo;in herhangi bir şekilde taraf olmadığını ve
          S&ouml;zleşme kapsamında Taraflar&rsquo;ın
          y&uuml;k&uuml;ml&uuml;l&uuml;klerini yerine getirmeleri ile ilgili
          herhangi bir sorumluluğu ve taahh&uuml;d&uuml; bulunmadığını kabul ve
          beyan ederler.
        </p>
        <p>
          ALICI&rsquo;nın işbu s&ouml;zleşmenin akdinden evvel akdetmiş olduğu
          &hellip; tarihli Buldan&rsquo;s Parekende Mağaza Bayilik
          S&ouml;zleşmesindeki maddelerin uygulanması devam eder ve işbu
          s&ouml;zleşme, &hellip; tarihli Buldan&rsquo;s Parekende Mağaza Bayilik
          S&ouml;zleşmesi h&uuml;k&uuml;mlerinin ifasına engel teşkil etmez.
        </p>
        <p>4. ALICI&rsquo;NIN &Ouml;NCEDEN BİLGİLENDİRİLDİĞİ HUSUSLAR</p>
        <p>
          4.1. ALICI, aşağıdaki hususlarda, bu S&ouml;zleşme&apos;nin ALICI
          tarafından Platform&rsquo;dan kabul&uuml; ile kurulmasından ve gerek
          siparişi gerek &ouml;deme y&uuml;k&uuml;ml&uuml;l&uuml;ğ&uuml; altına
          girmesinden &ouml;nce Platform&rsquo;un ilgili sayfaları-kısımlarındaki
          t&uuml;m genel-&ouml;zel a&ccedil;ıklamaları incelediğini, okuduğunu,
          anladığını ve kendisine gerekli bilgilendirmenin yapıldığını kabul eder.
        </p>
        <p>
          a) SATICI&apos;nın unvanı ve iletişim bilgileri ile g&uuml;ncel tanıtıcı
          bilgileri,
        </p>
        <p>
          b) &Uuml;r&uuml;nler&apos;in Platform&rsquo;dan alınması sırasındaki satış
          işlemi aşamaları ile yanlış girilen bilgilerin d&uuml;zeltilmesine ilişkin
          amaca uygun ara&ccedil;lar-y&ouml;ntemler,
        </p>
        <p>
          c) SATICI&apos;nın mensubu olduğu Meslek Odası Buldan Ticaret Odası) ve
          BTO&rsquo;nun meslek ile ilgili &ouml;ng&ouml;rd&uuml;ğ&uuml; davranış
          kuralları bilgisinin edinebileceği elektronik iletişim bilgileri (Telefon:
          0258) 431 30 09,
          <a data-fr-linked="true" href="//www.buldanticaretodasi.org.tr">www.buldanticaretodasi.org.tr</a>)
        </p>
        <p>
          d) D&Ouml;NMEZ EV TEKSTİLİ VE GİYİM SAN. VE TİC. A.Ş tarafından uygulanan
          ALICI bilgileri i&ccedil;in ge&ccedil;erli gizlilik, veri kullanımı-işleme
          ve ALICI&rsquo;ya elektronik iletişim kuralları ile ALICI&rsquo;nın bu
          hususlarda D&Ouml;NMEZ EV TEKSTİLİ VE GİYİM SAN. VE TİC. A.Ş&rsquo;e
          verdiği izinler, ALICI&rsquo;nın kanuni hakları, SATICI&rsquo;nın hakları
          ve Taraflar&rsquo;ın haklarını kullanım usulleri,
        </p>
        <p>
          e) &Uuml;r&uuml;nler i&ccedil;in SATICI tarafından
          &ouml;ng&ouml;r&uuml;len g&ouml;nderim kısıtlamaları,
        </p>
        <p>
          f) S&ouml;zleşme konusu &Uuml;r&uuml;nler i&ccedil;in D&Ouml;NMEZ EV
          TEKSTİLİ VE GİYİM SAN. VE TİC. A.Ş tarafından kabul edilen &ouml;deme
          y&ouml;ntem-ara&ccedil;ları ile &Uuml;r&uuml;nler&apos;in temel
          &ouml;zellik-nitelikleri, vergiler dahil toplam fiyatı (ilgili masraflar
          da dahil olmak &uuml;zere ALICI&rsquo;nın SATICI&apos;ya &ouml;deyeceği
          toplam bedel),
        </p>
        <p>
          g) &Uuml;r&uuml;nler&apos;in ALICI&rsquo;ya teslimine ilişkin usuller ile
          nakliye-teslim-kargo masrafları hakkında bilgiler,
        </p>
        <p>3</p>
        <p>
          h) &Uuml;r&uuml;nler ile ilgili diğer &ouml;deme/tahsilat ve teslimat
          bilgileri ile S&ouml;zleşme&apos;nin ifasına ilişkin bilgiler, bu
          hususlarda Taraflar&rsquo;ın sorumlulukları,
        </p>
        <p>
          i) ALICI&rsquo;nın cayma hakkına sahip olmadığı &Uuml;r&uuml;nler ve diğer
          mal-hizmetler,
        </p>
        <p>
          j) ALICI&rsquo;nın cayma hakkının olduğu durumlarda bu hakkını kullanma
          şartları, s&uuml;resi ve usul&uuml; ile hakkın s&uuml;resinde
          kullanılmaması durumunda ALICI&rsquo;nın cayma hakkını kaybedeceği,
        </p>
        <p>
          k) Cayma hakkı olan &Uuml;r&uuml;nler&apos;de, &Uuml;r&uuml;n cayma
          s&uuml;resi i&ccedil;inde kullanım talimatlarına, olağan işleyişine veya
          teknik &ouml;zelliklerine uygun kullanılmamasından &ouml;t&uuml;r&uuml;
          bozulduğu veya bir değişikliğe uğradığı takdirde ALICI&rsquo;nın cayma
          talebinin kabul edilmeyebileceği ve her durumda SATICI&apos;ya karşı
          sorumlu olacağı, SATICI&apos;nın kabul ettiği hallerde s&ouml;z konusu
          bozukluğa veya değişime g&ouml;re uygun bulduğu bir tutarı ALICI&rsquo;ya
          yapacağı geri &ouml;demeden mahsup edebileceği,
        </p>
        <p>
          l) Cayma hakkının bulunduğu durumlarda &Uuml;r&uuml;nleri SATICI&apos;ya
          ne şekilde iade edebileceği ve ilgili t&uuml;m mali hususlar (iade
          yolları, masrafı ve &Uuml;r&uuml;n bedelinin iadesi ve iade sırasında,
          ALICI tarafından kazanılmış/kullanılmış &ouml;d&uuml;l puanları
          i&ccedil;in yapılabilecek indirim ve mahsuplar dahil),
        </p>
        <p>
          m) ALICI&rsquo;nın Platform&rsquo;da d&ouml;nem d&ouml;nem uygulanabilecek
          &ccedil;eşitli fırsatlara ilişkin yararlanma koşullarının (&ouml;zel
          şartlar) detaylarını,
        </p>
        <p>
          n) Mahiyetine g&ouml;re bu S&ouml;zleşme&apos;de de yer alan diğer
          t&uuml;m satış şartları ile işbu S&ouml;zleşme ALICI tarafından
          Platform&rsquo;da onaylanarak kurulduktan sonra ALICI&rsquo;ya elektronik
          posta ile g&ouml;nderildiğinden ALICI tarafından istenen s&uuml;re ile
          saklanıp buradan erişilebileceği, D&Ouml;NMEZ EV TEKSTİLİ VE GİYİM SAN. VE
          TİC. A.Ş&rsquo;in de &uuml;&ccedil; yıl s&uuml;re ile nezdinde
          saklayabileceği.
        </p>
        <p>
          o) Uyuşmazlık hallerinde ALICI&rsquo;nın D&Ouml;NMEZ EV TEKSTİLİ VE GİYİM
          SAN. VE TİC. A.Ş&rsquo;e veya SATICI&rsquo;ya şikayetlerini iletebileceği
          iletişim bilgileri ile yasal başvurularını, 6502 Sayılı Kanun&apos;un
          ilgili h&uuml;k&uuml;mlerine uygun olarak İl&ccedil;e/İl Hakem Heyetlerine
          ve T&uuml;ketici Mahkemeleri&apos;ne yapabileceği.
        </p>
        <p>5. SATICI BİLGİLERİ</p>
        <p>
          &Uuml;nvanı : D&Ouml;NMEZ EV TEKSTİLİ VE GİYİM SAN. VE TİC. A.Ş-İhsan
          D&ouml;nmez.
        </p>
        <p>
          Adresi : Cumhuriyet Mahallesi 82 Sok. Buldan&rsquo;s Blok No:2 Buldan
          DENİZLİ
        </p>
        <p>Mersis : 1003409388600013</p>
        <p>Telefon : 90258 431 4096</p>
        <p>Fax : 02584312733</p>
        <p>6. ALICI BİLGİLERİ</p>
        <p>Teslim Edilecek Kişi :</p>
        <p>Teslimat Adresi :</p>
        <p>Telefon :</p>
        <p>Faks :</p>
        <p>E-posta/Kullanıcı Adı :</p>
        <p>4</p>
        <p>8. FATURA BİLGİLERİ</p>
        <p>
          Fatura Teslim: Fatura sipariş teslimatı sırasında teslimat adresine
          sipariş ile birlikte teslim edilecektir.
        </p>
        <p>9. S&Ouml;ZLEŞME KONUSU &Uuml;R&Uuml;N/&Uuml;R&Uuml;NLER BİLGİLERİ</p>
        <p>
          9.1. Malın/&Uuml;r&uuml;n/&Uuml;r&uuml;nlerin/ Hizmetin temel
          &ouml;zelliklerini (t&uuml;r&uuml;, miktarı, marka/modeli, rengi, adedi)
          D&Ouml;NMEZ EV TEKSTİLİ VE GİYİM SAN. VE TİC. A.Ş&rsquo;e ait
          Platform&rsquo;da yer almaktadır. &Uuml;r&uuml;n&uuml;n temel
          &ouml;zelliklerini kampanya s&uuml;resince inceleyebilirsiniz.
        </p>
        <p>
          9.2. Listelenen ve sitede ilan edilen fiyatlar satış fiyatıdır. İlan
          edilen fiyatlar ve vaatler g&uuml;ncelleme yapılana ve değiştirilene kadar
          ge&ccedil;erlidir. S&uuml;reli olarak ilan edilen fiyatlar ise belirtilen
          s&uuml;re sonuna kadar ge&ccedil;erlidir.
        </p>
        <p>
          9.3. S&ouml;zleşme konusu mal ya da hizmetin t&uuml;m vergiler d&acirc;hil
          satış fiyatı aşağıdaki tabloda g&ouml;sterilmiştir. Bu birim kar marjları
          13.06.2022 tarihli fiyat listelerindeki marjlardır. Toplam siparişteki
          miktarın toleransı +/- 10%&apos;dur.
        </p>
        <p>
          &Uuml;r&uuml;n A&ccedil;ıklaması Adet Peşin Fiyatı Ara Toplam (KDV Dahil)
        </p>
        <p>
          3500 TL ve &uuml;st&uuml; kargolarda Nakliye ve sigorta alıcıya aittir.
        </p>
        <p>
          *
          <a data-fr-linked="true" href="//www.buldans.com.tr">www.buldans.com.tr</a>
          internet sitesinin a&ccedil;ık pazar ve/veya diğer butiklerinden eş
          zamanlı olarak ger&ccedil;ekleştirilen alışverişlerde hak kazanılan toplam
          indirim tutarı, kargo bedeli ve taksit farkı tutarı birlikte yukarıda
          g&ouml;sterilmiştir.
        </p>
        <p>Teslimat Adresi :</p>
        <p>Teslim Edilecek Kişi :</p>
        <p>Fatura Adresi :</p>
        <p>Sipariş Tarihi :</p>
        <p>Teslim Şekli : Alıcıya Teslim</p>
        <p>Etiket ve paketleme : Buldan&apos;s etiketli. &Ccedil;oklu paketleme.</p>
        <p>
          ALICI&rsquo;nın sipariş esnasında &uuml;r&uuml;n&uuml; Teslimat Noktasına
          teslim y&ouml;ntemiyle teslimat se&ccedil;eneğini se&ccedil;mesi halinde,
          &uuml;r&uuml;n D&Ouml;NMEZ EV TEKSTİLİ VE GİYİM SAN. VE TİC. A.Ş&rsquo;in
          entegrasyon halinde olduğu lojistik firması tarafından ALICI&rsquo;nın
          se&ccedil;miş olduğu teslimat noktasına en ge&ccedil; 30 g&uuml;n
          i&ccedil;erisinde teslim edilecektir. &Uuml;r&uuml;n&uuml;n teslimat
          noktasına bırakılmasının ardından ALICI Platform&rsquo;a kaydolurken
          iletmiş olduğu telefon numarasına gelen kod ile en ge&ccedil; 3 g&uuml;n
          i&ccedil;erisinde &uuml;r&uuml;n&uuml; teslim alacaktır. ALICI&rsquo;nın
          işbu s&uuml;re i&ccedil;erisinde &uuml;r&uuml;n&uuml; teslim almaması
          halinde &uuml;r&uuml;n&uuml; iade ettiği kabul edilecek olup
          &uuml;r&uuml;n bedeli, siparişi ger&ccedil;ekleştirdiği kredi kartı/banka
          hesabına iade edilecektir. M&uuml;cbir sebep halleri olan yangın,sel,
          deprem, salgın hastalık,doğal afetler kaynaklı işletmede ve tedarik
          zincirinde işlerin kısmen ve tamamiyle yapılamaması halinde teslimat
          tarihleri revize edilebilir.
        </p>
        <p>
          9.4. S&Ouml;Z KONUSU &Uuml;R&Uuml;N BEDELİ, &ldquo;BULDAN&rsquo;S ALICI
          G&Uuml;VENCESİ&rdquo; KAPSAMINDA SATICI ADINA, D&Ouml;NMEZ EV TEKSTİLİ VE
          GİYİM SAN. VE TİC. A.Ş TARAFINDAN
        </p>
        <p>5</p>
        <p>
          ALICI&rsquo;DAN TAHSİL EDİLMEKTEDİR. ALICI MALIN BEDELİNİ D&Ouml;NMEZ EV
          TEKSTİLİ VE GİYİM SAN. VE TİC. A.Ş&apos;E &Ouml;DEMEKLE, &Uuml;R&Uuml;N
          BEDELİNİ SATICI&rsquo;YA &Ouml;DEMİŞ SAYILACAK VE BİR DAHA &Ouml;DEME
          Y&Uuml;K&Uuml;ML&Uuml;L&Uuml;Ğ&Uuml; ALTINA GİRMEYECEKTİR. ALICI&rsquo;NIN
          İLGİLİ MEVZUAT KAPSAMINDA İADE HAKLARI SAKLIDIR.
        </p>
        <p>10. GENEL H&Uuml;K&Uuml;MLER</p>
        <p>
          10.1. ALICI, Platform&rsquo;da S&ouml;zleşme konusu
          &Uuml;r&uuml;n&rsquo;&uuml;n temel nitelikleri, satış fiyatı ve &ouml;deme
          şekli ile teslimata ilişkin &ouml;n bilgileri okuyup, bilgi sahibi
          olduğunu, elektronik ortamda gerekli teyidi verdiğini kabul, beyan ve
          taahh&uuml;t eder. ALICI t&uuml;ketici sıfatıyla talep ve şikayetlerini
          yukarıda yer alan SATICI iletişim bilgilerine ve/veya Platform&rsquo;un
          sağladığı kanallarla ulaştırabilirler. ALICI&rsquo;nın; &Ouml;n
          Bilgilendirme Formu&rsquo;nu elektronik ortamda teyit etmesinden, Mesafeli
          Satış S&ouml;zleşmesi&rsquo;nin kurulmasından evvel, SATICI tarafından
          ALICI&rsquo;ya verilmesi gereken adresi, siparişi verilen
          &uuml;r&uuml;nlere ait temel &ouml;zellikleri, &uuml;r&uuml;nlerin
          vergiler d&acirc;hil fiyatını, &ouml;deme ve teslimat bilgilerini de doğru
          ve eksiksiz olarak edindiğini, siparişin verilmesi ile satın alınan
          &uuml;r&uuml;nlerin bedellerinin vadesi hakkında ihtar edilmiş olduğunu,
          vade tarihinde borcun ALICI tarafından &ouml;denmediği takdirde, ek bir
          ihtar yapılması gerekmeksizin temerr&uuml;de d&uuml;şeceğini ve aylık %3
          tutarındaki temerr&uuml;t faizi &ouml;demekle y&uuml;k&uuml;ml&uuml;
          olacağını hi&ccedil;bir koşul olmaksızın kabul, beyan ve taahh&uuml;t
          eder.
        </p>
        <p>
          10.2.Alıcı, işbu s&ouml;zleşme ile satıcının sipariş konusu
          &uuml;r&uuml;nleri &uuml;retime başlayacağını, ham madde teminini
          yapacağını ve &uuml;retim planlamasını bu sipariş doğduğunda
          g&uuml;ncellediğini bilmektedir. Sipariş konusu &uuml;r&uuml;nleri
          almaktan hi&ccedil;bir koşulda vazge&ccedil;meyeceğini, s&ouml;zleşmeden
          d&ouml;nmeyeceğini, bu maddeye aykırı davranması halinde ya da ilerleyen
          s&uuml;re&ccedil;te siparişin bir kısmını almaktan vazge&ccedil;mesi
          halinde verilen kaparonun yanacağını, hi&ccedil;bir şekilde geri
          istenemeyeceğini, ayrıca satıcının doğacak t&uuml;m zararlarını
          karşılayacağını peşinen kabul ve taahh&uuml;t etmiştir.
        </p>
        <p>
          10.3. S&ouml;zleşme konusu her bir &uuml;r&uuml;n, 30 g&uuml;nl&uuml;k
          yasal s&uuml;reyi aşmamak kaydı ile ALICI&rsquo;nın yerleşim yeri
          uzaklığına bağlı olarak internet sitesindeki &ouml;n bilgiler kısmında
          belirtilen s&uuml;re zarfında ALICI veya ALICI&rsquo;nın g&ouml;sterdiği
          adresteki kişi ve/veya kuruluşa veya Buldan&rsquo;s Teslimat Noktasına
          D&Ouml;NMEZ EV TEKSTİLİ VE GİYİM SAN. VE TİC. A.Ş&rsquo;in entegrasyon
          halinde olduğu kargo şirketi aracılığıyla teslim edilir. Bu s&uuml;re
          i&ccedil;erisinde SATICI&rsquo;nın edimini yerine getirmemesi durumunda
          ALICI S&ouml;zleşme&apos;yi feshedebilir. İnternet sitesinde
          &ldquo;tahmini teslimat tarihi&rdquo; şeklinde belirtilen teslimat tarihi
          tahmini olarak belirtilmiş olup bu ifade herhangi bir taahh&uuml;t
          i&ccedil;ermemektedir. Bu &uuml;r&uuml;nler mevzuatta belirtildiği
          &uuml;zere en ge&ccedil; 30 g&uuml;n i&ccedil;erisinde ALICI&rsquo;ya
          teslim edilecektir. ALICI&rsquo;nın veya teslim edilecek kişinin teslim
          anında adreste bulunmaması durumunda ALICI&apos;nın &uuml;r&uuml;n&uuml;
          ge&ccedil; teslim almasından ve/veya hi&ccedil; teslim almamasından
          kaynaklanan zararlardan ve giderlerden SATICI sorumlu değildir.
        </p>
        <p>
          T&uuml;keticinin, satıcının belirlediği taşıyıcı dışında başka bir
          taşıyıcı ile malın g&ouml;nderilmesini talep etmesi durumunda, malın
          ilgili taşıyıcıya tesliminden itibaren oluşabilecek kayıp ya da hasardan
          satıcı sorumlu değildir.
        </p>
        <p>
          10.4. SATICI, S&ouml;zleşme konusu &uuml;r&uuml;n&uuml; eksiksiz,
          siparişte belirtilen niteliklere uygun ve varsa garanti belgeleri,
          kullanım kılavuzları ile işin gereği olan bilgi ve belgeler ile teslim
          etmeyi, her
        </p>
        <p>6</p>
        <p>
          t&uuml;rl&uuml; ayıptan ar&icirc; olarak yasal mevzuat gereklerine
          g&ouml;re sağlam, standartlara uygun bir şekilde işi doğruluk ve
          d&uuml;r&uuml;stl&uuml;k esasları d&acirc;hilinde ifa etmeyi, hizmet
          kalitesini koruyup y&uuml;kseltmeyi, işin ifası sırasında gerekli dikkat
          ve &ouml;zeni g&ouml;stermeyi, ihtiyat ve &ouml;ng&ouml;r&uuml; ile
          hareket etmeyi kabul, beyan ve taahh&uuml;t eder.
        </p>
        <p>
          10.5. Malın teslimi sonrasında, gizli ayıp haricinde, malda bir eksiklik
          ya da ayıp bulunması durumunda, alıcı 15 g&uuml;n i&ccedil;erisinde bu
          durumu satıcıya bildirecektir. Teslimden itibaren 15 g&uuml;n sonrasında
          teslim edilen &uuml;r&uuml;nler hi&ccedil;bir gerek&ccedil;e ile iade
          edilemeyecek, gizli ayıp haricinde ayıp, hata ihbarında
          bulunulamayacaktır. ALICI, ayıba ilişkin işbu bildirim
          y&uuml;k&uuml;ml&uuml;l&uuml;ğ&uuml;n&uuml; peşinen kabul ve taahh&uuml;t
          etmiştir.
        </p>
        <p>
          10.5. SATICI, S&ouml;zleşme&apos;den doğan ifa
          y&uuml;k&uuml;ml&uuml;l&uuml;ğ&uuml;n&uuml;n s&uuml;resi dolmadan
          ALICI&rsquo;yı bilgilendirmek ve a&ccedil;ık&ccedil;a onayını almak
          suretiyle eşit kalite ve fiyatta farklı bir &uuml;r&uuml;n tedarik
          edebilir.
        </p>
        <p>
          10.6. ALICI, S&ouml;zleşme konusu &Uuml;r&uuml;n&rsquo;&uuml;n teslimatı
          i&ccedil;in işbu S&ouml;zleşme&rsquo;yi elektronik ortamda teyit
          edeceğini, herhangi bir nedenle S&ouml;zleşme konusu &uuml;r&uuml;n
          bedelinin &ouml;denmemesi ve/veya banka, finans kuruluşu kayıtlarında
          iptal edilmesi halinde, SATICI&rsquo;nın s&ouml;zleşme konusu
          &uuml;r&uuml;n&uuml; teslim y&uuml;k&uuml;ml&uuml;l&uuml;ğ&uuml;n&uuml;n
          sona ereceğini kabul, beyan ve taahh&uuml;t eder. Herhangi bir sebeple
          banka ve/veya finans kuruluşu tarafından başarısız kodu g&ouml;nderilen
          ancak banka ve/veya finans kuruluşu tarafından SATICI&rsquo;ya yapılan
          &ouml;demelere ilişkin ALICI, SATICI&rsquo;nın herhangi bir sorumluluğunun
          bulunmadığını kabul, beyan ve taahh&uuml;t eder.
        </p>
        <p>
          10.7. ALICI, S&ouml;zleşme konusu &Uuml;r&uuml;n&rsquo;&uuml;n ALICI veya
          ALICI&rsquo;nın g&ouml;sterdiği adresteki kişi ve/veya kuruluşa
          tesliminden sonra veya Buldan&rsquo;s Teslimat Noktasından ALICI
          tarafından teslim alınmasından sonra ALICI&rsquo;ya ait kredi kartının
          yetkisiz kişilerce haksız kullanılması sonucunda S&ouml;zleşme konusu
          &uuml;r&uuml;n bedelinin ilgili banka veya finans kuruluşu tarafından
          SATICI&rsquo;ya &ouml;denmemesi halinde, ALICI S&ouml;zleşme konusu
          &uuml;r&uuml;n&uuml; 3 g&uuml;n i&ccedil;erisinde nakliye gideri
          ALICI&rsquo;ya ait olacak şekilde SATICI&rsquo;ya iade edeceğini kabul,
          beyan ve taahh&uuml;t eder.
        </p>
        <p>
          10.8. ALICI, S&ouml;zleşme konusu mal/hizmeti teslim almadan &ouml;nce
          muayene edecek; ezik, kırık, ambalajı yırtılmış vb. hasarlı ve ayıplı
          mal/hizmeti kargo şirketinden teslim almayacaktır. Teslim alınan
          mal/hizmetin hasarsız ve sağlam olduğu kabul edilecektir. Teslimden sonra
          mal/hizmetin &ouml;zenle korunması borcu, ALICI&rsquo;ya aittir. Cayma
          hakkı kullanılacaksa mal/hizmet kullanılmamalıdır. Fatura iade
          edilmelidir.
        </p>
        <p>
          10.9. Malın teslimat masrafları aksine bir h&uuml;k&uuml;m yoksa
          ALICI&rsquo;ya aittir. SATICI, Platform&rsquo;da teslimat &uuml;cretinin
          kendisince karşılanacağını beyan etmişse teslimat masrafları
          SATICI&apos;ya ait olacaktır. Malın teslimatı SATICI&apos;nın stokunun
          m&uuml;sait olması halinde ve &ouml;demenin ger&ccedil;ekleşmesinden sonra
          taahh&uuml;t edilen s&uuml;rede yapılır.
        </p>
        <p>
          10.10. Sipariş konusu mal ya da hizmet ediminin yerine getirilmesinin
          imkansızlaştığı hallerde SATICI&rsquo;nın bu durumu &ouml;ğrendiği
          tarihten itibaren 3 (&uuml;&ccedil;) g&uuml;n i&ccedil;inde ALICI&rsquo;ya
          yazılı olarak veya ALICI veri saklayıcısı ile bildirmesi ve varsa teslimat
          masrafları da d&acirc;hil olmak &uuml;zere tahsil edilen t&uuml;m
          &ouml;demeleri bildirim tarihinden itibaren en ge&ccedil; on beş g&uuml;n
          i&ccedil;inde iade etmesi zorunludur. Malın stokta bulunmaması durumu, mal
          ediminin yerine getirilmesinin
        </p>
        <p>7</p>
        <p>
          imk&acirc;nsızlaşması olarak kabul edilmez. ALICI&rsquo;nın kredi kartı
          ile yaptığı &ouml;demelerde ise SATICI tarafından kredi kartına iade
          edilen tutarın banka tarafından ALICI hesabına yansıtılmasına ilişkin
          ortalama s&uuml;recin 2 (iki) ile 3 (&uuml;&ccedil;) haftayı
          bulabileceğini, bu tutarın bankaya iadesinden sonra ALICI&rsquo;nın
          hesaplarına yansıması halinin tamamen banka işlem s&uuml;reci ile ilgili
          olduğundan ALICI, olası gecikmeler i&ccedil;in SATICI&rsquo;yı sorumlu
          tutamayacağını kabul, beyan ve taahh&uuml;t eder.
        </p>
        <p>
          10.11. ALICI ile sipariş esnasında kullanılan kredi kartı hamilinin aynı
          kişi olmaması veya &uuml;r&uuml;n&uuml;n ALICI&rsquo;ya tesliminden evvel,
          siparişte kullanılan kredi kartına ilişkin g&uuml;venlik a&ccedil;ığı
          tespit edilmesi halinde, SATICI, kredi kartı hamiline ilişkin kimlik ve
          iletişim bilgilerini, siparişte kullanılan kredi kartının bir &ouml;nceki
          aya ait ekstresini yahut kart hamilinin bankasından kredi kartının
          kendisine ait olduğuna ilişkin yazıyı ibraz etmesini ALICI&rsquo;dan talep
          edebilir. ALICI&rsquo;nın talebe konu bilgi/belgeleri temin etmesine kadar
          ge&ccedil;ecek s&uuml;rede sipariş dondurulacak olup, mezk&ucirc;r
          taleplerin 24 (yirmi d&ouml;rt) saat i&ccedil;erisinde karşılanmaması
          halinde ise SATICI, siparişi iptal etme hakkını haizdir.
        </p>
        <p>
          10.12. ALICI &uuml;r&uuml;n bedelini &ouml;demesi ve bu siparişe ilişkin
          cayma hakkını kullanması halinde cayma hakkından kaynaklı bedel iadesi
          Paytr &uuml;zerinden hesabına yapılacaktır.
        </p>
        <p>
          10.13. &Ouml;deme şekli: %50&apos;si işbu s&ouml;zleşmenin tebliğine
          istinaden peşin ve kalan 50% mal tesliminden 60 g&uuml;n sonra
          &hellip;&hellip;&hellip;...&hellip;&hellip;&hellip; tarihinde TL bazında
          banka havalesiyle peşin &ouml;denecektir.
        </p>
        <p>
          10.14. Vadesinde yapılmayan &ouml;demelerde, aylık % 3 faiz işletilir.
        </p>
        <p>
          10.15. Sipariş&cedil; edilmeyen malların g&ouml;nderilmesi durumunda,
          ALICI&rsquo;ya karşı herhangi bir hak ileri s&uuml;r&uuml;lemez. Bu
          hallerde, ALICI&rsquo;nın sessiz kalması ya da malı kullanmış olması,
          s&ouml;zleşmenin kurulmasına y&ouml;nelik kabul beyanı olarak
          yorumlanamaz.
        </p>
        <p>
          10.16. ALICI&rsquo;nın Platform&rsquo;dan duyurulan zamanlarda sipariş
          edebileceği &uuml;r&uuml;n adetlerine kısıt getirilebilir. ALICI&rsquo;nın
          Platform&rsquo;dan yapılan duyurularda belirtilen adetin &uuml;zerinde
          &uuml;r&uuml;n sipariş etmesi halinde siparişler iptal edilebilecek ve
          yasal s&uuml;resi i&ccedil;erisinde &uuml;r&uuml;n bedelleri
          ALICI&rsquo;ya iade edilecektir. ALICI işbu hususları kabul ederek
          siparişini oluşturduğunu, adet sınırlamasını ge&ccedil;en siparişlerde
          D&Ouml;NMEZ EV TEKSTİLİ VE GİYİM SAN. VE TİC. A.Ş ve/veya SATICI&rsquo;nın
          siparişi iptal etme hakkının olduğunu kabul, beyan ve taahh&uuml;t eder.
        </p>
        <p>
          10.17. D&Ouml;NMEZ EV TEKSTİLİ VE GİYİM SAN. VE TİC. A.Ş, SATICI&rsquo;nın
          herhangi bir sebeple tedarik edemediği siparişleri, mevzuattaki teslim
          s&uuml;resini aşmamak ve ALICI&rsquo;nın &uuml;r&uuml;n&uuml; ile aynı
          &ouml;zellikleri haiz olmak kaydıyla, bir başka satıcıya aktarma hakkına
          sahiptir. B&ouml;yle bir durumda &uuml;r&uuml;n yeni satıcı tarafından
          ALICI&rsquo;ya g&ouml;nderilecek olup mesafeli satış s&ouml;zleşmesi yeni
          satıcı ile ALICI arasında kurulmuş olacaktır. D&Ouml;NMEZ EV TEKSTİLİ VE
          GİYİM SAN. VE TİC. A.Ş ve/veya SATICI, ALICI&rsquo;ya herhangi bir ek
          bedel, &uuml;cret ve/veya masraf yansıtmayacaktır..
        </p>
        <p>11. &Ouml;ZEL ŞARTLAR</p>
        <p>8</p>
        <p>
          11.1. ALICI Platform&rsquo;da aynı sepet i&ccedil;erisinde farklı
          kategorilerden alınan &uuml;r&uuml;nlerin her biri i&ccedil;in SATICI
          tarafından tek fatura kesilebilecektir. Ş&uuml;pheye mahal bırakmamak
          bakımından belirtilmelidir ki, SATICI ALICI&rsquo;nın aldığı
          &uuml;r&uuml;nlerin teslimatını mevzuattaki yasal s&uuml;re
          i&ccedil;erisinde kalmak koşuluyla farklı zamanlarda
          ger&ccedil;ekleştirebilecektir.
        </p>
        <p>
          11.2. Bankanız kampanyalar d&uuml;zenleyerek sizin se&ccedil;tiğiniz
          taksit adedinin daha &uuml;st&uuml;nde bir taksit adedi uygulayabilir,
          taksit &ouml;teleme gibi hizmetler sunulabilir. Bu t&uuml;r kampanyalar
          bankanızın inisiyatifindedir ve D&Ouml;NMEZ EV TEKSTİLİ VE GİYİM SAN. VE
          TİC. A.Ş&rsquo;in bilgisi d&acirc;hilinde olması durumunda sayfalarımızda
          kampanyalar hakkında bilgi verilmektedir. Kredi kartınızın hesap kesim
          tarihinden itibaren sipariş toplamı taksit adedine b&ouml;l&uuml;nerek
          kredi kartı &ouml;zetinize bankanız tarafından yansıtılacaktır. Banka
          taksit tutarlarını k&uuml;surat farklarını dikkate alarak aylara eşit
          olarak dağıtmayabilir. Detaylı &ouml;deme planınızın oluşturulması
          bankanız inisiyatifindedir.
        </p>
        <p>
          11.3. Dijital &uuml;r&uuml;n satışlarında Satıcı, Alıcı&apos;ya
          &uuml;r&uuml;nlerin Alıcı&rsquo;ya tam ve gereği gibi iletildiği ve
          g&ouml;nderilen kodların eksiksiz şekilde &ccedil;alıştığını kanıtlayan
          t&uuml;m bilgi ve belgeleri ve g&uuml;venli şekilde tutulmuş log
          kayıtlarını D&ouml;nmez Teksil&rsquo;e iletmekle
          y&uuml;k&uuml;ml&uuml;d&uuml;r. Aksi halde D&Ouml;NMEZ EV TEKSTİLİ VE
          GİYİM SAN. VE TİC. A.Ş&rsquo;in 4.28. maddeden doğan hakları saklıdır.
        </p>
        <p>
          12. KİŞİSEL VERİLERİN KORUNMASI, TİCARİ ELEKTRONİK İLETİ VE FİKRİ-SINAİ
          HAKLAR İLE İLGİLİ KURALLAR
        </p>
        <p>
          12.1. 6698 sayılı Kişisel Verilerin Korunması Kanunu kapsamında kişisel
          veri olarak tanımlanabilecek ALICI&rsquo;ya ait ad, soyad, e-posta adresi,
          T.C. Kimlik numarası, demografik veriler, mali veriler vb. bilgiler;
        </p>
        <p>
          * sipariş almak, &uuml;r&uuml;n ve hizmetleri sunmak, &uuml;r&uuml;n ve
          hizmetleri geliştirmek, sistemsel sorunların &ccedil;&ouml;z&uuml;m&uuml;,
          &ouml;deme işlemlerini ger&ccedil;ekleştirmek, -&ouml;nceden onay
          verilmesi halinde- siparişler, &uuml;r&uuml;nler ve hizmetler hakkında
          pazarlama faaliyetlerinde kullanılmak, ALICI&rsquo;ya ait bilgilerin
          g&uuml;ncellenmesinde ve &uuml;yeliklerin y&ouml;netimi ve
          s&uuml;rd&uuml;r&uuml;lmesi ile ALICI ile SATICI arasında kurulan mesafeli
          satış s&ouml;zleşmesi ve sair s&ouml;zleşmelerin ifası amacıyla ve 3.
          kişilerin teknik, lojistik ve benzeri diğer işlevlerinin SATICI tarafından
          sağlanabilmesi i&ccedil;in yukarıda sayılan verileri D&Ouml;NMEZ EV
          TEKSTİLİ VE GİYİM SAN. VE TİC. A.Ş, ve &uuml;&ccedil;&uuml;nc&uuml; kişi
          ve/veya kuruluşlar tarafından s&uuml;resiz/s&uuml;reli kaydedilebilir,
          yazılı/manyetik arşivlerde muhafaza edilebilir, kullanılabilir,
          g&uuml;ncellenebilir, paylaşılabilir, transfer olunabilir ve sair suretler
          ile işlenebilir.
        </p>
        <p>
          12.2. ALICILAR&rsquo;a, y&uuml;r&uuml;rl&uuml;kteki mevzuata uygun
          şekilde, her t&uuml;rl&uuml; &uuml;r&uuml;n ve hizmetlere ilişkin tanıtım,
          reklam, iletişim, promosyon, satış ve pazarlama amacıyla, kredi kartı ve
          &uuml;yelik bilgilendirme, işlem, uygulamaları i&ccedil;in D&Ouml;NMEZ EV
          TEKSTİLİ VE GİYİM SAN. VE TİC. A.Ş tarafından SMS/kısa mesaj, anlık
          bildirim, otomatik arama, bilgisayar, telefon, e-posta/mail, faks, diğer
          elektronik iletişim ara&ccedil;ları ile ticari elektronik iletişimler
          yapılabilir, ALICI kendisine ticari elektronik iletiler
          g&ouml;nderilmesini kabul etmiştir.
        </p>
        <p>9</p>
        <p>
          12.3. ALICI tarafından Platform&rsquo;a girilen bilgilerin ve işlemlerin
          g&uuml;venliği i&ccedil;in gerekli &ouml;nlemler, D&Ouml;NMEZ EV TEKSTİLİ
          VE GİYİM SAN. VE TİC. A.Ş tarafındaki kendi sistem altyapısında, bilgi ve
          işlemin mahiyetine g&ouml;re g&uuml;n&uuml;m&uuml;z teknik imkanları
          &ouml;l&ccedil;&uuml;s&uuml;nde alınmıştır. Bununla beraber, s&ouml;z
          konusu bilgiler ALICI&rsquo;ya ait cihazlardan girildiğinden ALICI
          tarafından korunmaları ve ilgisiz kişilerce erişilememesi i&ccedil;in,
          vir&uuml;s ve benzeri zararlı uygulamalara ilişkin olanlar dahil, gerekli
          tedbirlerin alınması sorumluluğu ALICI&rsquo;ya aittir.
        </p>
        <p>
          12.4. ALICI, D&Ouml;NMEZ EV TEKSTİLİ VE GİYİM SAN. VE TİC. A.Ş&rsquo;e
          belirtilen iletişim kanallarından ulaşarak veri kullanımı-işlenmelerini
          ve/veya iletişimleri her zaman i&ccedil;in durdurulmasını talep edebilir.
          ALICI&rsquo;nın bu husustaki a&ccedil;ık bildirimine g&ouml;re, kişisel
          veri işlemleri ve/veya tarafına iletişimler yasal azami s&uuml;re
          i&ccedil;inde durdurulur; ayrıca dilerse, hukuken muhafazası gerekenler
          ve/veya m&uuml;mk&uuml;n olanlar haricindeki bilgileri, veri kayıt
          sisteminden silinir ya da kimliği belli olmayacak bi&ccedil;imde anonim
          hale getirilir. ALICI isterse kişisel verilerinin işlenmesi ile ilgili
          işlemler, aktarıldığı kişiler, eksik veya yanlış olması halinde
          d&uuml;zeltilmesi, d&uuml;zeltilen bilgilerin ilgili
          &uuml;&ccedil;&uuml;nc&uuml; kişilere bildirilmesi, verilerin silinmesi
          veya yok edilmesi, otomatik sistemler ile analiz edilmesi sureti ile
          kendisi aleyhine bir sonucun ortaya &ccedil;ıkmasına itiraz, verilerin
          kanuna aykırı olarak işlenmesi sebebi ile zarara uğrama halinde
          giderilmesi gibi konularda D&Ouml;NMEZ EV TEKSTİLİ VE GİYİM SAN. VE TİC.
          A.Ş&rsquo;e her zaman başvurabilir ve bilgi alabilir. S&ouml;z konusu
          başvurular incelenerek yasal s&uuml;resi i&ccedil;erisinde ALICI&rsquo;ya
          mevzuatta &ouml;ng&ouml;r&uuml;len s&uuml;relerde d&ouml;n&uuml;ş
          yapılacaktır.
        </p>
        <p>
          12.5. Platform&rsquo;a ait her t&uuml;rl&uuml; bilgi ve i&ccedil;erik ile
          bunların d&uuml;zenlenmesi, revizyonu ve kısmen/tamamen kullanımı
          konusunda; D&Ouml;NMEZ EV TEKSTİLİ VE GİYİM SAN. VE TİC. A.Ş&rsquo;in
          anlaşmasına g&ouml;re diğer &uuml;&ccedil;&uuml;nc&uuml; şahıslara ait
          olanlar hari&ccedil;; t&uuml;m fikri-sınai haklar ve m&uuml;lkiyet hakları
          D&Ouml;NMEZ EV TEKSTİLİ VE GİYİM SAN. VE TİC. A.Ş&rsquo;e aittir.
        </p>
        <p>
          12.6. Platform&rsquo;dan ulaşılan diğer sitelerde kendilerine ait
          gizlilik-g&uuml;venlik politikaları ve kullanım şartları
          ge&ccedil;erlidir, oluşabilecek ihtilaflar ile menfi neticelerinden
          D&Ouml;NMEZ EV TEKSTİLİ VE GİYİM SAN. VE TİC. A.Ş sorumlu değildir.
        </p>
        <p>13. CAYMA HAKKI</p>
        <p>
          13.1. ALICI hi&ccedil;bir hukuki ve cezai sorumluluk &uuml;stlenmeksizin
          ve hi&ccedil;bir gerek&ccedil;e g&ouml;stermeksizin satın aldığı
          mal/hizmeti teslim tarihinden itibaren 14 (on beş) g&uuml;n
          i&ccedil;erisinde cayma hakkını kullanarak iade edebilir.
        </p>
        <p>
          13.2. Cayma hakkı bildirimi ve S&ouml;zleşme&rsquo;ye ilişkin bildirimler
          Platform&rsquo;da belirtilen iletişim kanalları ile g&ouml;sterilecektir.
          Cayma bildiriminin yapılacağı iletişim kanallarına
          <a data-fr-linked="true" href="https://www.buldans.com.tr/">https://www.buldans.com.tr/</a>
          iletisim.html linkinden ulaşılabilir.
        </p>
        <p>
          13.3. Cayma hakkının kullanılması i&ccedil;in s&uuml;resi
          i&ccedil;erisinde SATICI veya D&Ouml;NMEZ EV TEKSTİLİ VE GİYİM SAN. VE
          TİC. A.Ş&rsquo;in mevzuat h&uuml;k&uuml;mlerine ve Platform&rsquo;daki
          cayma hakkı kullanım se&ccedil;eneğine uygun olarak bildirimde bulunulması
          şarttır.
        </p>
        <p>13.5. Cayma hakkının kullanılması halinde:</p>
        <p>10</p>
        <p>
          a) ALICI cayma hakkını kullanmasından itibaren 10 (on) g&uuml;n
          i&ccedil;erisinde Malı SATICI&apos;ya anlaşmalı kargo şirketiyle geri
          g&ouml;nderir.
        </p>
        <p>
          b) Cayma hakkı kapsamında iade edilecek Mal kutusu, ambalajı, varsa
          standart aksesuarları varsa Mal ile birlikte hediye edilen diğer
          &uuml;r&uuml;nlerin de eksiksiz ve hasarsız olarak iade edilmesi
          gerekmektedir.
        </p>
        <p>
          13.6. ALICI cayma s&uuml;resi i&ccedil;inde malı, işleyişine, teknik
          &ouml;zelliklerine ve kullanım talimatlarına uygun bir şekilde kullandığı
          takdirde meydana gelen değişiklik ve bozulmalardan sorumlu değildir.
        </p>
        <p>
          13.7. Cayma hakkının kullanılmasını takip eden 14 (on d&ouml;rt) g&uuml;n
          i&ccedil;erisinde Mal bedeli ALICI&rsquo;ya &ouml;dediği şekilde iade
          edilir. Mal, SATICI&apos;ya iade edilirken, Malın teslimi sırasında
          ALICI&rsquo;ya ibraz edilmiş olan orijinal faturanın da ALICI tarafından
          iade edilmesi gerekmektedir.
        </p>
        <p>
          13.8. ALICI iade edeceği Malı &ouml;n bilgilendirme formunda belirtilen
          SATICI&apos;nın anlaşmalı kargo şirketi ile SATICI&apos;ya g&ouml;nderdiği
          s&uuml;rece iade kargo bedeli SATICI&apos;ya aittir. İade i&ccedil;in
          ALICI&rsquo;nın bulunduğu yerde SATICI&rsquo;nın anlaşmalı kargo şirketi
          şubesi bulunmaması halinde ALICI herhangi bir kargo şirketiyle
          g&ouml;nderebilecektir, bu halde kargo bedeli ALICI&rsquo;ya aittir.
          ALICI&rsquo;nın iade edeceği Malı &Ouml;n Bilgilendirme Formunda
          belirtilen SATICI&apos;nın anlaşmalı kargo şirketi dışında bir kargo
          şirketi ile g&ouml;ndermesi halinde iade kargo bedeli ve Malın kargo
          s&uuml;recinde uğrayacağı hasardan SATICI sorumlu değildir.
        </p>
        <p>
          13.9. ALICI&rsquo;nın cayma hakkını kullandığı durumlarda ya da siparişe
          konu olan &uuml;r&uuml;n&uuml;n &ccedil;eşitli sebeplerle tedarik
          edilememesi veya hakem heyeti kararları ile ALICI&rsquo;ya bedel iadesine
          karar verilen durumlarda, alışveriş kredi kartı ile ve taksitli olarak
          yapılmışsa, kredi kartına iade prosed&uuml;r&uuml; aşağıda belirtilmiştir:
        </p>
        <p>
          ALICI &uuml;r&uuml;n&uuml; ka&ccedil; taksit ile aldıysa Banka
          ALICI&rsquo;ya geri &ouml;demesini taksitle yapmaktadır. SATICI bankaya
          &uuml;r&uuml;n bedelinin tamamını tek seferde &ouml;dedikten sonra, Banka
          poslarından yapılan taksitli harcamaların ALICI&rsquo;nın kredi kartına
          iadesi durumunda, konuya m&uuml;dahil tarafların mağdur duruma
          d&uuml;şmemesi i&ccedil;in talep edilen iade tutarları, yine taksitli
          olarak hamil taraf hesaplarına Banka tarafından aktarılır. ALICI&rsquo;nın
          satış iptaline kadar &ouml;demiş olduğu taksit tutarları, eğer iade tarihi
          ile kartın hesap kesim tarihleri &ccedil;akışmazsa her ay karta 1 (bir)
          iade yansıyacak ve ALICI iade &ouml;ncesinde &ouml;demiş olduğu taksitleri
          satışın taksitleri bittikten sonra, iade &ouml;ncesinde &ouml;demiş olduğu
          taksitleri sayısı kadar ay daha alacak ve mevcut bor&ccedil;larından
          d&uuml;şm&uuml;ş olacaktır.
        </p>
        <p>14. CAYMA HAKKININ KULLANILAMAYACAĞI HALLER</p>
        <p>14.1. ALICI aşağıdaki s&ouml;zleşmelerde cayma hakkını kullanamaz:</p>
        <p>
          a) Fiyatı finansal piyasalardaki dalgalanmalara bağlı olarak değişen ve
          SATICI veya D&Ouml;NMEZ EV TEKSTİLİ VE GİYİM SAN. VE TİC. A.Ş&rsquo;in
          kontrol&uuml;nde olmayan mal veya hizmetlere ilişkin s&ouml;zleşmeler
        </p>
        <p>11</p>
        <p>
          b) T&uuml;keticinin istekleri veya kişisel ihtiya&ccedil;ları
          doğrultusunda hazırlanan mallara ilişkin s&ouml;zleşmeler
        </p>
        <p>
          c) &Ccedil;abuk bozulabilen veya son kullanma tarihi ge&ccedil;ebilecek
          malların teslimine ilişkin s&ouml;zleşmeler
        </p>
        <p>
          &ccedil;) Tesliminden sonra ambalaj, bant, m&uuml;h&uuml;r, paket gibi
          koruyucu unsurları a&ccedil;ılmış olan mallardan; iadesi sağlık ve hijyen
          a&ccedil;ısından uygun olmayanların teslimine ilişkin s&ouml;zleşmeler.
        </p>
        <p>
          d) Tesliminden sonra başka &uuml;r&uuml;nlerle karışan ve doğası gereği
          ayrıştırılması m&uuml;mk&uuml;n olmayan mallara ilişkin s&ouml;zleşmeler.
        </p>
        <p>
          e) Malın tesliminden sonra ambalaj, bant, m&uuml;h&uuml;r, paket gibi
          koruyucu unsurları a&ccedil;ılmış olması halinde maddi ortamda sunulan
          kitap, dijital i&ccedil;erik ve bilgisayar sarf malzemelerine ilişkin
          s&ouml;zleşmeler.
        </p>
        <p>
          f) Abonelik s&ouml;zleşmesi kapsamında sağlananlar dışında gazete ve dergi
          gibi s&uuml;reli yayınların teslimine ilişkin s&ouml;zleşmeler.
        </p>
        <p>
          g) Belirli bir tarihte veya d&ouml;nemde yapılması gereken, konaklama,
          eşya taşıma, araba kiralama, yiyecek i&ccedil;ecek tedariki ve eğlence
          veya dinlenme amacıyla yapılan boş zamanın değerlendirilmesine ilişkin
          s&ouml;zleşmeler.
        </p>
        <p>
          ğ) Elektronik ortamda anında ifa edilen hizmetler ile ALICI&rsquo;ya
          anında teslim edilen gayri maddi mallara ilişkin s&ouml;zleşmeler.
        </p>
        <p>
          h) Cayma hakkı s&uuml;resi sona ermeden &ouml;nce, ALICI&rsquo;nın onayı
          ile ifasına başlanan hizmetlere ilişkin s&ouml;zleşmeler.
        </p>
        <p>
          S&ouml;zleşmeye konu Mal/Hizmet&apos;in Mesafeli S&ouml;zleşmeler
          Y&ouml;netmeliği&apos;nin uygulama alanı dışında bırakılmış olan
          (SATICI&rsquo;nın d&uuml;zenli teslimatları ile ALICInın meskenine teslim
          edilen gıda maddelerinin, i&ccedil;eceklerin ya da diğer g&uuml;nl&uuml;k
          t&uuml;ketim maddeleri ile seyahat, konaklama, lokantacılık, eğlence
          sekt&ouml;r&uuml; gibi alanlarda hizmetler) Mal/Hizmet t&uuml;rlerinden
          m&uuml;teşekkil olması halinde ALICI ve SATICI arasındaki hukuki ilişkiye
          Mesafeli S&ouml;zleşmeler Y&ouml;netmeliği h&uuml;k&uuml;mleri
          uygulanamaması sebebiyle cayma hakkı kullanılamayacaktır.
        </p>
        <p>
          14.2. D&Ouml;NMEZ EV TEKSTİLİ VE GİYİM SAN. VE TİC. A.Ş&rsquo;e ait
          Platform &uuml;zerinden ELEKTRONİK KOD SATIN ALINDIĞI DURUMLARDA bahse
          konu siparişlerde Mesafeli S&ouml;zleşmeler Y&ouml;netmeliği&rsquo;nin
          15/1.ğ maddesi gereği cayma hakkı s&ouml;z konusu olmayacaktır. Bu
          siparişler bakımından internet sitesi &uuml;zerinden iade kodu da
          oluşturulamayacaktır.
        </p>
        <p>15. UYUŞMAZLIKLARIN &Ccedil;&Ouml;Z&Uuml;M&Uuml;</p>
        <p>
          15.1. İşbu Mesafeli Satış S&ouml;zleşmesi&apos;nin uygulanması sırasında
          meydana gelebilecek ihtilaflarda yahut &ccedil;ekişmesiz işlerde Denizli
          Mahkemeleri ve İcra Daireleri yetkilidir.
        </p>
        <p>12</p>
        <p>
          15.2 İşbu Mesafeli Satış S&ouml;zleşmesi&apos;nin uygulanmasında, Ticaret
          Bakanlığınca ilan edilen değere kadar T&uuml;ketici Hakem Heyetleri ile
          T&uuml;ketici Mahkemeleri yetkilidir.
        </p>
        <p>
          15.3. 6502 Sayılı T&uuml;keticinin Korunması Hakkında Kanun&apos;un 68.
          maddesinin 1. fıkrasında belirtilen alt ve &uuml;st limitler doğrultusunda
          t&uuml;ketici talepleri hakkında t&uuml;ketici hakem heyetleri yetkilidir.
        </p>
        <p>16. MALIN/HİZMETİN FİYATI</p>
        <p>
          Malın peşin veya vadeli satış fiyatı, sipariş formunda yer almakla
          birlikte, sipariş sonu g&ouml;nderilen bilgilendirme maili ve
          &uuml;r&uuml;n ile birlikte m&uuml;şteriye g&ouml;nderilen fatura
          i&ccedil;eriğinde mevcut olan fiyattır. SATICI veya D&Ouml;NMEZ EV
          TEKSTİLİ VE GİYİM SAN. VE TİC. A.Ş tarafından yapılan indirimler,
          kuponlar, kargo &uuml;creti ve sair uygulamalar satış fiyatına yansıtılır.
        </p>
        <p>17. TEMERR&Uuml;D HALİ VE HUKUKİ SONU&Ccedil;LARI</p>
        <p>
          17.1. SATICI&rsquo;nın &ouml;demekle y&uuml;k&uuml;ml&uuml; olduğu bedelin
          %50&apos;si işbu s&ouml;zleşmenin tebliğine istinaden peşin ve kalan 50%
          mal tesliminden 60 g&uuml;n sonra
          &hellip;&hellip;&hellip;...&hellip;&hellip;&hellip; tarihinde TL bazında
          banka havalesiyle peşin &ouml;denecektir.
        </p>
        <p>17.2. Vadesinde yapılmayan &ouml;demelerde, aylık % 3 faiz işletilir.</p>
        <p>
          17.3. İşbu siparişin verilmesi ile alıcı taraf, satın aldığı
          &uuml;r&uuml;nlerin bedellerinin vadesi hakkında ihtar edilmiş olur. Karşı
          taraf, vade tarihinde borcunu &ouml;demediği takdirde kendisine ek bir
          ihtar yapılması gerekmeksizin temerr&uuml;de d&uuml;şer ve satıcı
          temerr&uuml;t faizine hak kazanır. (TTK 1530/2)
        </p>
        <p>
          17.4. ALICI&rsquo;nın, kredi kartı ile yapmış olduğu işlemlerde
          temerr&uuml;de d&uuml;şmesi halinde kart sahibi bankanın kendisi ile
          yapmış olduğu kredi kartı s&ouml;zleşmesi &ccedil;er&ccedil;evesinde, faiz
          &ouml;deyecek ve bankaya karşı sorumlu olacaktır. Bu durumda ilgili banka
          hukuki yollara başvurabilir, doğacak masrafları ve vek&acirc;let
          &uuml;cretini ALICI&rsquo;dan talep edebilir ve her koşulda
          ALICI&rsquo;nın borcundan dolayı temerr&uuml;de d&uuml;şmesi halinde,
          ALICI&rsquo;nın borcu gecikmeli ifasından dolayı SATICI&apos;nın uğradığı
          zarar ve ziyandan ALICI sorumlu olacaktır.
        </p>
        <p>
          17.5. ALICI&rsquo;nın kredi kartı ile yapmış olduğu işlemlerde
          temerr&uuml;de d&uuml;şmesi halinde kart sahibi bankanın kendisi ile
          yapmış olduğu kredi kartı s&ouml;zleşmesi &ccedil;er&ccedil;evesinde
          &ouml;deyeceği faiz, SATICI&rsquo;ya &ouml;demekle y&uuml;k&uuml;ml&uuml;
          olduğu temerr&uuml;t faizinden m&uuml;stesna olup, aylık %3 oranında
          &ouml;denecek temerr&uuml;t faizinin işlemesine engel teşkil etmez.
        </p>
        <p>18. BİLDİRİMLER ve DELİL S&Ouml;ZLEŞMESİ</p>
        <p>
          18.1. İşbu S&ouml;zleşme tahtında Taraflar arasında yapılacak her
          t&uuml;rl&uuml; yazışma, mevzuatta sayılan zorunlu haller dışında, e-mail
          aracılığıyla yapılacaktır.
        </p>
        <p>
          18.2. ALICI, işbu S&ouml;zleşme&apos;den doğabilecek ihtilaflarda
          SATICI&apos;nın ve D&Ouml;NMEZ EV TEKSTİLİ VE GİYİM SAN. VE TİC.
          A.Ş&rsquo;in resmi defter ve ticari kayıtlarıyla, kendi veri tabanında,
          sunucularında tuttuğu elektronik bilgilerin ve bilgisayar kayıtlarının,
          bağlayıcı, kesin ve m&uuml;nhasır delil teşkil edeceğini, bu maddenin
          Hukuk Muhakemeleri Kanunu&apos;nun 193. maddesi anlamında delil
          s&ouml;zleşmesi niteliğinde olduğunu kabul, beyan ve taahh&uuml;t eder.
        </p>
        <p>13</p>
        <p>19. Y&Uuml;R&Uuml;RL&Uuml;K</p>
        <p>
          19.1. İşbu belge taraflar arasındaki mutakabat sonucunda oluşturulan nihai
          s&ouml;zleşmedir. Alıcı siparişin durumunda ve adetlerinde, modellerde
          değişiklik yapamaz. Ancak bazı durumlarda satıcının yazılı onayına
          istinaden değişiklikler satıcı insiyatifinde kabul edilebilir.
        </p>
        <p>
          19.2 . 19 (on dokuz) maddeden ibaret bu S&ouml;zleşme, Taraflarca
          okunarak, işlem tarihinde, ALICI tarafından elektronik ortamda onaylanmak
          suretiyle akdedilmiş ve y&uuml;r&uuml;rl&uuml;ğe girmiştir.
          S&ouml;zleşmenin bir n&uuml;shası ALICI&rsquo;nın &uuml;yelik hesabında
          mevcuttur ve talep edilmesi halinde ayrıca e-posta ile de
          g&ouml;nderilebilecektir.
        </p>
      </div>
    </div>
    <div v-else>
      <div>
        <div>
          <p>MESAFELİ SATIŞ S&Ouml;ZLEŞMESİ&nbsp;</p>
        </div>
        <div>
          <p>{{ firma }}</p>
        </div>
        <div>
          <p>1. TARAFLAR&nbsp;</p>
        </div>
        <div>
          <p>İşbu Mesafeli Satış S&ouml;zleşmesi (&quot;S&ouml;zleşme&quot;); adresi 7. maddede belirtilen
            (&quot;ALICI&rdquo;) ile adresi 6. Maddede belirtilen (&ldquo;SATICI&rdquo;) arasında aşağıda belirtilen
            h&uuml;k&uuml;m ve şartlar &ccedil;er&ccedil;evesinde elektronik ortamda kurulmuştur.&nbsp;</p>
        </div>
        <div>
          <p>2. TANIMLAR&nbsp;</p>
        </div>
        <div>
          <p>İşbu s&ouml;zleşmenin uygulanmasında ve yorumlanmasında aşağıda yazılı terimler karşılarındaki yazılı
            a&ccedil;ıklamaları ifade edeceklerdir.&nbsp;</p>
        </div>
        <div>
          <p>ALICI :Bir&nbsp;mal veya hizmeti ticari veya mesleki olmayan ama&ccedil;larla edinen, kullanan veya
            yararlanan ger&ccedil;ek ya da t&uuml;zel kişiyi,&nbsp;</p>
        </div>
        <div>
          <p>Bakan :Ticaret&nbsp;Bakanı&rsquo;nı,&nbsp;</p>
        </div>
        <div>
          <p>Bakanlık :Ticaret&nbsp;Bakanlığı&rsquo;nı,&nbsp;</p>
        </div>
        <div>
          <p>{{ firma }}SATICI&rsquo;lar&rsquo;ın&nbsp;&uuml;r&uuml;n ve
            hizmet sunduğu&nbsp;Platform&rsquo;u&nbsp;sağlayan aracı hizmet sağlayıcısı olan&nbsp;{{ firma }} Şirketi&nbsp;</p>
        </div>
        <div>
          <p>Hizmet :Bir&nbsp;&uuml;cret veya menfaat karşılığında yapılan ya da yapılması taahh&uuml;t edilen mal sağlama
            dışındaki her t&uuml;rl&uuml; t&uuml;ketici işleminin konusu,&nbsp;</p>
        </div>
        <div>
          <p>Kanun :T&uuml;keticinin&nbsp;Korunması Hakkında Kanun&rsquo;u,&nbsp;</p>
        </div>
        <div>
          <p>Platform :{{ firma }} e&nbsp;ait <a
              :href="sistemAdres" target="_blank"
              rel="noreferrer noopener">{{ sistemAdres }}</a> adlı internet sitesini ve mobil uygulamasını,&nbsp;
          </p>
        </div>
        <div>
          <p>SATICI:Kamu&nbsp;t&uuml;zel kişileri de dahil olmak &uuml;zere ticari veya mesleki ama&ccedil;larla
            t&uuml;keticiye mal sunan ya da mal sunanın adına ya da hesabına hareket eden ve S&ouml;zleşme&rsquo;nin 6.
            maddesinde bilgileri bulunan ger&ccedil;ek ve/veya t&uuml;zel kişiyi,&nbsp;</p>
        </div>
        <div>
          <p>Sipariş&nbsp;Veren :Bir&nbsp;mal veya hizmeti&nbsp;{{ firma }} e&nbsp;ait <a :href="sistemAdres" target="_blank"
              rel="noreferrer noopener">{{ sistemAdres }}</a> adlı internet sitesi veya mobil uygulaması
            &uuml;zerinden talep eden ger&ccedil;ek ya da t&uuml;zel kişiyi,&nbsp;</p>
        </div>
        <div>
          <p>S&ouml;zleşme :SATICI&nbsp;ve ALICI arasında akdedilen işbu&nbsp;S&ouml;zleşme&rsquo;yi,&nbsp;</p>
        </div>
        <div>
          <p>Taraflar :SATICI&nbsp;ve&nbsp;ALICI&rsquo;yı,&nbsp;</p>
        </div>
        <div>
          <p>&Uuml;r&uuml;n veya&nbsp;&Uuml;r&uuml;nler :Alışverişe&nbsp;konu olan taşınır t&uuml;m eşya.&nbsp;</p>
        </div>
        <div>
          <p>Y&ouml;netmelik :Mesafeli&nbsp;Satışlar Y&ouml;netmeliği&rsquo;ni,&nbsp;</p>
        </div>
        <div>
          <p>3. S&Ouml;ZLEŞMENİN KONUSU ve KAPSAMI&nbsp;</p>
        </div>
        <div>
          <p>İşbu S&ouml;zleşme 6502 Sayılı T&uuml;keticinin Korunması Hakkında Kanun ve Mesafeli S&ouml;zleşmeler
            Y&ouml;netmeliği&apos;ne uygun olarak d&uuml;zenlenmiştir. Taraflar işbu S&ouml;zleşme tahtında 6502 Sayılı
            T&uuml;keticinin Korunması Hakkında Kanun ve Mesafeli S&ouml;zleşmeler Y&ouml;netmeliği&apos;nden kaynaklanan
            y&uuml;k&uuml;ml&uuml;l&uuml;k ve sorumluluklarını bildiklerini ve anladıklarını kabul ve beyan ederler. İşbu
            S&ouml;zleşmenin konusunu&nbsp;ALICI&apos;nın,&nbsp;{{ firma }} e&nbsp;ait&nbsp;Platform&rsquo;da, Mal/Hizmet satışa sunan&nbsp;SATICI&apos;ya&nbsp;ait
            Mal/Hizmetin satın alınmasına y&ouml;nelik elektronik olarak sipariş
            verdiği,&nbsp;S&ouml;zleşme&rsquo;de&nbsp;belirtilen niteliklere sahip Mal/Hizmetin satışı ve teslimi ile
            ilgili olarak 6502 Sayılı T&uuml;keticinin Korunması Hakkındaki&nbsp;</p>
        </div>
        <div>
          <p>2&nbsp;</p>
        </div>
        <div>
          <p>Kanun ve Mesafeli S&ouml;zleşmeler Y&ouml;netmeliği h&uuml;k&uuml;mleri
            gereğince&nbsp;Taraflar&rsquo;ın&nbsp;hak ve y&uuml;k&uuml;ml&uuml;l&uuml;klerinin saptanması
            oluşturur.&nbsp;İşbu S&ouml;zleşme&rsquo;nin akdedilmesi&nbsp;Taraflar&rsquo;ın&nbsp;ayrı ayrı&nbsp;{{ firma }} ile akdetmiş oldukları &uuml;yelik s&ouml;zleşmelerinin
            h&uuml;k&uuml;mlerinin ifasını engellemeyecek olup Taraflar işbu S&ouml;zleşme konusu Mal/Hizmetin
            satışında&nbsp;{{ firma }} in&nbsp;herhangi bir şekilde taraf
            olmadığını ve S&ouml;zleşme kapsamında&nbsp;Taraflar&rsquo;ın&nbsp;y&uuml;k&uuml;ml&uuml;l&uuml;klerini yerine
            getirmeleri ile ilgili herhangi bir sorumluluğu ve taahh&uuml;d&uuml; bulunmadığını kabul ve beyan
            ederler.&nbsp;</p>
        </div>
        <div>
          <p>ALICI&rsquo;nın&nbsp;işbu s&ouml;zleşmenin akdinden evvel akdetmiş&nbsp;olduğu
            &hellip;&nbsp;tarihli&nbsp;{{ firma }}&nbsp;Parekende&nbsp;Mağaza Bayilik S&ouml;zleşmesindeki maddelerin
            uygulanması devam eder ve işbu s&ouml;zleşme,
            &hellip;&nbsp;tarihli&nbsp;{{ firma }}&nbsp;Parekende&nbsp;Mağaza Bayilik S&ouml;zleşmesi
            h&uuml;k&uuml;mlerinin ifasına engel teşkil etmez.&nbsp;</p>
        </div>
        <div>
          <p>4. ALICI&rsquo;NIN &Ouml;NCEDEN BİLGİLENDİRİLDİĞİ HUSUSLAR&nbsp;</p>
        </div>
        <div>
          <p>4.1. ALICI, aşağıdaki hususlarda, bu S&ouml;zleşme&apos;nin ALICI
            tarafından&nbsp;Platform&rsquo;dan&nbsp;kabul&uuml; ile kurulmasından ve gerek siparişi gerek &ouml;deme
            y&uuml;k&uuml;ml&uuml;l&uuml;ğ&uuml; altına girmesinden &ouml;nce&nbsp;Platform&rsquo;un&nbsp;ilgili
            sayfaları-kısımlarındaki t&uuml;m genel-&ouml;zel a&ccedil;ıklamaları incelediğini, okuduğunu, anladığını ve
            kendisine gerekli bilgilendirmenin yapıldığını kabul eder.&nbsp;</p>
        </div>
        <div>
          <p>a)&nbsp;SATICI&apos;nın&nbsp;unvanı ve iletişim bilgileri ile g&uuml;ncel tanıtıcı bilgileri,&nbsp;</p>
        </div>
        <div>
          <p>b)&nbsp;&Uuml;r&uuml;nler&apos;in&nbsp;Platform&rsquo;dan&nbsp;alınması sırasındaki satış işlemi aşamaları
            ile yanlış girilen bilgilerin d&uuml;zeltilmesine ilişkin amaca uygun ara&ccedil;lar-y&ouml;ntemler,&nbsp;</p>
        </div>
        <div>
          <p>c)&nbsp;SATICI&apos;nın&nbsp;mensubu olduğu Meslek Odası&nbsp;Bursa&nbsp;Ticaret&nbsp;ve Sanayi&nbsp;Odası)
            ve&nbsp;BTSO&rsquo;nun&nbsp;meslek ile ilgili &ouml;ng&ouml;rd&uuml;ğ&uuml; davranış kuralları bilgisinin
            edinebileceği elektronik iletişim bilgileri (Telefon:&nbsp;444 7 005)&nbsp;</p>
        </div>
        <div>
          <p>d)&nbsp;{{ firma }}tarafından uygulanan ALICI bilgileri
            i&ccedil;in ge&ccedil;erli gizlilik, veri kullanımı-işleme ve&nbsp;ALICI&rsquo;ya&nbsp;elektronik iletişim
            kuralları ile&nbsp;ALICI&rsquo;nın&nbsp;bu hususlarda&nbsp;{{ firma }} ye&nbsp;verdiği izinler,&nbsp;ALICI&rsquo;nın&nbsp;kanuni
            hakları,&nbsp;SATICI&rsquo;nın&nbsp;hakları ve&nbsp;Taraflar&rsquo;ın&nbsp;haklarını kullanım usulleri,&nbsp;
          </p>
        </div>
        <div>
          <p>e) &Uuml;r&uuml;nler i&ccedil;in SATICI tarafından &ouml;ng&ouml;r&uuml;len g&ouml;nderim
            kısıtlamaları,&nbsp;</p>
        </div>
        <div>
          <p>f) S&ouml;zleşme konusu &Uuml;r&uuml;nler i&ccedil;in&nbsp;{{ firma }} tarafından kabul edilen &ouml;deme y&ouml;ntem-ara&ccedil;ları
            ile&nbsp;&Uuml;r&uuml;nler&apos;in&nbsp;temel &ouml;zellik-nitelikleri,&nbsp;vergiler&nbsp;dahil&nbsp;toplam
            fiyatı (ilgili masraflar da dahil olmak
            &uuml;zere&nbsp;ALICI&rsquo;nın&nbsp;SATICI&apos;ya&nbsp;&ouml;deyeceği toplam bedel),&nbsp;</p>
        </div>
        <div>
          <p>g)&nbsp;&Uuml;r&uuml;nler&apos;in&nbsp;ALICI&rsquo;ya&nbsp;teslimine ilişkin usuller ile nakliye-teslim-kargo
            masrafları hakkında bilgiler,&nbsp;</p>
        </div>
        <div>
          <p>3&nbsp;</p>
        </div>
        <div>
          <p>h) &Uuml;r&uuml;nler ile ilgili diğer &ouml;deme/tahsilat ve teslimat bilgileri ile S&ouml;zleşme&apos;nin
            ifasına ilişkin bilgiler, bu hususlarda&nbsp;Taraflar&rsquo;ın&nbsp;sorumlulukları,&nbsp;</p>
        </div>
        <div>
          <p>i)&nbsp;ALICI&rsquo;nın&nbsp;cayma hakkına sahip olmadığı &Uuml;r&uuml;nler ve diğer mal-hizmetler,&nbsp;</p>
        </div>
        <div>
          <p>j)&nbsp;ALICI&rsquo;nın&nbsp;cayma hakkının olduğu durumlarda bu hakkını kullanma şartları, s&uuml;resi ve
            usul&uuml; ile hakkın s&uuml;resinde kullanılmaması durumunda&nbsp;ALICI&rsquo;nın&nbsp;cayma hakkını
            kaybedeceği,&nbsp;</p>
        </div>
        <div>
          <p>k) Cayma hakkı olan&nbsp;&Uuml;r&uuml;nler&apos;de, &Uuml;r&uuml;n cayma s&uuml;resi i&ccedil;inde kullanım
            talimatlarına, olağan işleyişine veya teknik &ouml;zelliklerine uygun kullanılmamasından &ouml;t&uuml;r&uuml;
            bozulduğu veya bir değişikliğe uğradığı takdirde&nbsp;ALICI&rsquo;nın&nbsp;cayma talebinin kabul
            edilmeyebileceği ve her durumda&nbsp;SATICI&apos;ya&nbsp;karşı sorumlu
            olacağı,&nbsp;SATICI&apos;nın&nbsp;kabul ettiği hallerde s&ouml;z konusu bozukluğa veya değişime g&ouml;re
            uygun bulduğu bir tutarı&nbsp;ALICI&rsquo;ya&nbsp;yapacağı geri &ouml;demeden mahsup edebileceği,&nbsp;</p>
        </div>
        <div>
          <p>l) Cayma hakkının bulunduğu durumlarda &Uuml;r&uuml;nleri&nbsp;SATICI&apos;ya&nbsp;ne şekilde iade
            edebileceği ve ilgili t&uuml;m mali hususlar (iade yolları, masrafı ve &Uuml;r&uuml;n bedelinin iadesi ve iade
            sırasında, ALICI tarafından kazanılmış/kullanılmış &ouml;d&uuml;l puanları i&ccedil;in yapılabilecek indirim
            ve mahsuplar&nbsp;dahil),&nbsp;</p>
        </div>
        <div>
          <p>m)&nbsp;ALICI&rsquo;nın&nbsp;Platform&rsquo;da&nbsp;d&ouml;nem&nbsp;d&ouml;nem&nbsp;uygulanabilecek
            &ccedil;eşitli fırsatlara ilişkin yararlanma koşullarının (&ouml;zel şartlar) detaylarını,&nbsp;</p>
        </div>
        <div>
          <p>n) Mahiyetine g&ouml;re bu&nbsp;S&ouml;zleşme&apos;de&nbsp;de yer alan diğer t&uuml;m satış şartları ile işbu
            S&ouml;zleşme ALICI tarafından&nbsp;Platform&rsquo;da&nbsp;onaylanarak kurulduktan
            sonra&nbsp;ALICI&rsquo;ya&nbsp;elektronik posta ile g&ouml;nderildiğinden ALICI tarafından istenen s&uuml;re
            ile saklanıp buradan erişilebileceği,&nbsp;{{ firma }} in&nbsp;de &uuml;&ccedil; yıl s&uuml;re ile nezdinde saklayabileceği.&nbsp;</p>
        </div>
        <div>
          <p>o) Uyuşmazlık hallerinde&nbsp;ALICI&rsquo;nın&nbsp;{{ firma }} e&nbsp;veya&nbsp;SATICI&rsquo;ya&nbsp;şikayetlerini&nbsp;iletebileceği iletişim bilgileri
            ile yasal başvurularını, 6502 Sayılı Kanun&apos;un ilgili h&uuml;k&uuml;mlerine uygun olarak İl&ccedil;e/İl
            Hakem Heyetlerine ve T&uuml;ketici Mahkemeleri&apos;ne yapabileceği.&nbsp;</p>
        </div>
        <div>
          <p>5. SATICI BİLGİLERİ&nbsp;</p>
        </div>
        <div>
          <p>&Uuml;nvanı&nbsp;:&nbsp;{{ firma }}</p>
        </div>
        <div>
          <p>Adresi :&nbsp;Ovaak&ccedil;a&nbsp;Merkez&nbsp;mah.&nbsp;İstanbul&nbsp;cad.&nbsp;No:567-A/B
            Osmangazi/Bursa&nbsp;</p>
        </div>
        <div>
          <p>Mersis&nbsp;:&nbsp;0624036646400012&nbsp;</p>
        </div>
        <div>
          <p>Telefon :&nbsp;444&nbsp;7 005&nbsp;</p>
        </div>
        <div>
          <p>6. ALICI BİLGİLERİ&nbsp;</p>
        </div>
        <div>
          <p>Teslim Edilecek&nbsp;Kişi :&nbsp;</p>
        </div>
        <div>
          <p>Teslimat&nbsp;Adresi :&nbsp;</p>
        </div>
        <div>
          <p>Telefon :&nbsp;</p>
        </div>
        <div>
          <p>Faks :&nbsp;</p>
        </div>
        <div>
          <p>E-posta/Kullanıcı&nbsp;Adı :&nbsp;</p>
        </div>
        <div>
          <p>4&nbsp;</p>
        </div>
        <div>
          <p>8. FATURA BİLGİLERİ&nbsp;</p>
        </div>
        <div>
          <p>Fatura Teslim: Fatura sipariş teslimatı sırasında teslimat adresine sipariş ile birlikte teslim
            edilecektir.&nbsp;</p>
        </div>
        <div>
          <p>9. S&Ouml;ZLEŞME KONUSU &Uuml;R&Uuml;N/&Uuml;R&Uuml;NLER BİLGİLERİ&nbsp;</p>
        </div>
        <div>
          <p>9.1. Malın/&Uuml;r&uuml;n/&Uuml;r&uuml;nlerin/ Hizmetin temel &ouml;zelliklerini (t&uuml;r&uuml;, miktarı,
            marka/modeli, rengi, adedi)&nbsp;{{ firma }} e&nbsp;ait&nbsp;Platform&rsquo;da&nbsp;yer almaktadır. &Uuml;r&uuml;n&uuml;n temel
            &ouml;zelliklerini kampanya s&uuml;resince inceleyebilirsiniz.&nbsp;</p>
        </div>
        <div>
          <p>9.2. Listelenen ve sitede ilan edilen fiyatlar satış fiyatıdır. İlan edilen fiyatlar ve vaatler
            g&uuml;ncelleme yapılana ve değiştirilene kadar ge&ccedil;erlidir. S&uuml;reli olarak ilan edilen fiyatlar ise
            belirtilen s&uuml;re sonuna kadar ge&ccedil;erlidir.&nbsp;</p>
        </div>
        <div>
          <p>9.3. S&ouml;zleşme konusu mal ya da hizmetin t&uuml;m vergiler d&acirc;hil satış fiyatı aşağıdaki tabloda
            g&ouml;sterilmiştir. Bu birim kar&nbsp;marjları&nbsp;13.06.2022 tarihli fiyat listelerindeki marjlardır.
            Toplam siparişteki miktarın toleransı +/- 10%&apos;dur.&nbsp;</p>
        </div>
        <div>
          <p>&Uuml;r&uuml;n A&ccedil;ıklaması Adet Peşin Fiyatı Ara Toplam (KDV&nbsp;Dahil)&nbsp;</p>
        </div>
        <div>
          <p>3500 TL ve &uuml;st&uuml; kargolarda Nakliye ve sigorta alıcıya aittir.&nbsp;</p>
        </div>
        <div>
          <p>* <a :href="sistemAdres" target="_blank"
              rel="noreferrer noopener">{{ sistemAdres }}</a> internet sitesinin a&ccedil;ık pazar ve/veya diğer
            butiklerinden eş zamanlı olarak ger&ccedil;ekleştirilen alışverişlerde hak kazanılan toplam indirim tutarı,
            kargo bedeli ve taksit farkı tutarı birlikte yukarıda g&ouml;sterilmiştir.&nbsp;</p>
        </div>
        <div>
          <p>Teslimat&nbsp;Adresi :&nbsp;</p>
        </div>
        <div>
          <p>Teslim Edilecek&nbsp;Kişi :&nbsp;</p>
        </div>
        <div>
          <p>Fatura&nbsp;Adresi :&nbsp;</p>
        </div>
        <div>
          <p>Sipariş&nbsp;Tarihi :&nbsp;</p>
        </div>
        <div>
          <p>Teslim&nbsp;Şekli : Alıcıya&nbsp;Teslim&nbsp;</p>
        </div>
        <div>
          <p>Etiket ve&nbsp;paketleme : &Ccedil;oklu&nbsp;paketleme.&nbsp;</p>
        </div>
        <div>
          <p>ALICI&rsquo;nın&nbsp;sipariş esnasında &uuml;r&uuml;n&uuml; Teslimat Noktasına teslim y&ouml;ntemiyle
            teslimat se&ccedil;eneğini se&ccedil;mesi halinde, &uuml;r&uuml;n&nbsp;{{ firma }} in&nbsp;entegrasyon&nbsp;halinde olduğu lojistik firması
            tarafından&nbsp;ALICI&rsquo;nın&nbsp;se&ccedil;miş olduğu teslimat noktasına en ge&ccedil; 30 g&uuml;n
            i&ccedil;erisinde teslim edilecektir. &Uuml;r&uuml;n&uuml;n teslimat noktasına bırakılmasının ardından
            ALICI&nbsp;Platform&rsquo;a&nbsp;kaydolurken iletmiş olduğu telefon numarasına gelen kod ile en ge&ccedil; 3
            g&uuml;n i&ccedil;erisinde &uuml;r&uuml;n&uuml; teslim alacaktır.&nbsp;ALICI&rsquo;nın&nbsp;işbu s&uuml;re
            i&ccedil;erisinde &uuml;r&uuml;n&uuml; teslim almaması halinde &uuml;r&uuml;n&uuml; iade ettiği kabul edilecek
            olup &uuml;r&uuml;n bedeli, siparişi ger&ccedil;ekleştirdiği kredi kartı/banka hesabına iade edilecektir.
            M&uuml;cbir sebep halleri olan&nbsp;yangın,sel, deprem, salgın&nbsp;hastalık,doğal&nbsp;afetler kaynaklı
            işletmede ve tedarik zincirinde işlerin kısmen ve&nbsp;tamamiyle&nbsp;yapılamaması halinde teslimat tarihleri
            revize edilebilir.&nbsp;</p>
        </div>
        <div>
          <p>9.4. S&Ouml;Z KONUSU &Uuml;R&Uuml;N BEDELİ, &ldquo;{{ firma }} &nbsp;ALICI G&Uuml;VENCESİ&rdquo; KAPSAMINDA
            SATICI ADINA,&nbsp;{{ firma }}TARAFINDAN&nbsp;</p>
        </div>
        <div>
          <p>5&nbsp;</p>
        </div>
        <div>
          <p>ALICI&rsquo;DAN TAHSİL EDİLMEKTEDİR. ALICI MALIN BEDELİNİ&nbsp;{{ firma }} E &Ouml;DEMEKLE, &Uuml;R&Uuml;N BEDELİNİ SATICI&rsquo;YA &Ouml;DEMİŞ SAYILACAK VE BİR DAHA &Ouml;DEME
            Y&Uuml;K&Uuml;ML&Uuml;L&Uuml;Ğ&Uuml; ALTINA GİRMEYECEKTİR. ALICI&rsquo;NIN İLGİLİ MEVZUAT KAPSAMINDA İADE
            HAKLARI SAKLIDIR.&nbsp;</p>
        </div>
        <div>
          <p>10. GENEL H&Uuml;K&Uuml;MLER&nbsp;</p>
        </div>
        <div>
          <p>10.1. ALICI,&nbsp;Platform&rsquo;da&nbsp;S&ouml;zleşme konusu &Uuml;r&uuml;n&rsquo;&uuml;n temel nitelikleri,
            satış fiyatı ve &ouml;deme şekli ile teslimata ilişkin &ouml;n bilgileri okuyup, bilgi sahibi olduğunu,
            elektronik ortamda gerekli teyidi verdiğini kabul, beyan ve taahh&uuml;t eder. ALICI t&uuml;ketici sıfatıyla
            talep ve&nbsp;şikayetlerini&nbsp;yukarıda yer alan SATICI iletişim bilgilerine
            ve/veya&nbsp;Platform&rsquo;un&nbsp;sağladığı kanallarla ulaştırabilirler.&nbsp;ALICI&rsquo;nın; &Ouml;n
            Bilgilendirme&nbsp;Formu&rsquo;nu&nbsp;elektronik ortamda teyit etmesinden, Mesafeli Satış
            S&ouml;zleşmesi&rsquo;nin kurulmasından evvel, SATICI tarafından&nbsp;ALICI&rsquo;ya&nbsp;verilmesi gereken
            adresi, siparişi verilen &uuml;r&uuml;nlere ait temel &ouml;zellikleri, &uuml;r&uuml;nlerin vergiler
            d&acirc;hil fiyatını, &ouml;deme ve teslimat bilgilerini de doğru ve eksiksiz olarak edindiğini, siparişin
            verilmesi ile satın alınan &uuml;r&uuml;nlerin bedellerinin vadesi hakkında ihtar edilmiş olduğunu, vade
            tarihinde borcun ALICI tarafından &ouml;denmediği takdirde, ek bir ihtar yapılması gerekmeksizin
            temerr&uuml;de d&uuml;şeceğini ve aylık %3 tutarındaki temerr&uuml;t faizi &ouml;demekle
            y&uuml;k&uuml;ml&uuml; olacağını hi&ccedil;bir koşul olmaksızın kabul, beyan ve taahh&uuml;t eder.&nbsp;</p>
        </div>
        <div>
          <p>10.2.Alıcı, işbu s&ouml;zleşme ile satıcının sipariş konusu &uuml;r&uuml;nleri &uuml;retime başlayacağını,
            ham madde teminini yapacağını ve &uuml;retim planlamasını bu sipariş doğduğunda g&uuml;ncellediğini
            bilmektedir. Sipariş konusu &uuml;r&uuml;nleri almaktan hi&ccedil;bir koşulda vazge&ccedil;meyeceğini,
            s&ouml;zleşmeden d&ouml;nmeyeceğini, bu maddeye aykırı davranması halinde ya da ilerleyen s&uuml;re&ccedil;te
            siparişin bir kısmını almaktan vazge&ccedil;mesi halinde verilen kaparonun yanacağını, hi&ccedil;bir şekilde
            geri istenemeyeceğini, ayrıca satıcının doğacak t&uuml;m zararlarını karşılayacağını peşinen kabul ve
            taahh&uuml;t etmiştir.&nbsp;</p>
        </div>
        <div>
          <p>10.3. S&ouml;zleşme konusu her bir &uuml;r&uuml;n, 30 g&uuml;nl&uuml;k yasal s&uuml;reyi aşmamak kaydı
            ile&nbsp;ALICI&rsquo;nın&nbsp;yerleşim yeri uzaklığına bağlı olarak internet sitesindeki &ouml;n bilgiler
            kısmında belirtilen s&uuml;re zarfında ALICI veya&nbsp;ALICI&rsquo;nın&nbsp;g&ouml;sterdiği adresteki kişi
            ve/veya kuruluşa veya&nbsp;{{ firma }}&nbsp;Teslimat Noktasına&nbsp;{{ firma }} in&nbsp;entegrasyon&nbsp;halinde olduğu kargo şirketi aracılığıyla teslim edilir. Bu
            s&uuml;re i&ccedil;erisinde&nbsp;SATICI&rsquo;nın&nbsp;edimini yerine getirmemesi durumunda
            ALICI&nbsp;S&ouml;zleşme&apos;yi&nbsp;feshedebilir. İnternet sitesinde &ldquo;tahmini teslimat tarihi&rdquo;
            şeklinde belirtilen teslimat tarihi tahmini olarak belirtilmiş olup bu ifade herhangi bir
            taahh&uuml;t&nbsp;i&ccedil;ermemektedir. Bu &uuml;r&uuml;nler mevzuatta belirtildiği &uuml;zere en ge&ccedil;
            30 g&uuml;n i&ccedil;erisinde&nbsp;ALICI&rsquo;ya&nbsp;teslim edilecektir.&nbsp;ALICI&rsquo;nın&nbsp;veya
            teslim edilecek kişinin teslim anında adreste bulunmaması
            durumunda&nbsp;ALICI&apos;nın&nbsp;&uuml;r&uuml;n&uuml; ge&ccedil; teslim almasından ve/veya hi&ccedil; teslim
            almamasından kaynaklanan zararlardan ve giderlerden SATICI sorumlu değildir.&nbsp;</p>
        </div>
        <div>
          <p>T&uuml;keticinin, satıcının belirlediği taşıyıcı dışında başka bir taşıyıcı ile malın g&ouml;nderilmesini
            talep etmesi durumunda, malın ilgili taşıyıcıya tesliminden itibaren oluşabilecek kayıp ya da hasardan satıcı
            sorumlu değildir.&nbsp;</p>
        </div>
        <div>
          <p>10.4. SATICI, S&ouml;zleşme konusu &uuml;r&uuml;n&uuml; eksiksiz, siparişte belirtilen niteliklere uygun ve
            varsa garanti belgeleri, kullanım kılavuzları ile işin gereği olan bilgi ve belgeler ile teslim etmeyi,
            her&nbsp;</p>
        </div>
        <div>
          <p>6&nbsp;</p>
        </div>
        <div>
          <p>t&uuml;rl&uuml;&nbsp;ayıptan ar&icirc; olarak yasal mevzuat gereklerine g&ouml;re sağlam, standartlara uygun
            bir şekilde işi doğruluk ve d&uuml;r&uuml;stl&uuml;k esasları d&acirc;hilinde ifa etmeyi, hizmet kalitesini
            koruyup y&uuml;kseltmeyi, işin ifası sırasında gerekli dikkat ve &ouml;zeni g&ouml;stermeyi, ihtiyat ve
            &ouml;ng&ouml;r&uuml; ile hareket etmeyi kabul, beyan ve taahh&uuml;t eder.&nbsp;</p>
        </div>
        <div>
          <p>10.5. Malın teslimi sonrasında, gizli ayıp haricinde, malda bir eksiklik ya da ayıp bulunması durumunda,
            alıcı 15 g&uuml;n i&ccedil;erisinde bu durumu satıcıya bildirecektir. Teslimden itibaren 15 g&uuml;n
            sonrasında teslim edilen &uuml;r&uuml;nler hi&ccedil;bir gerek&ccedil;e ile iade edilemeyecek, gizli ayıp
            haricinde ayıp, hata ihbarında bulunulamayacaktır. ALICI, ayıba ilişkin işbu bildirim
            y&uuml;k&uuml;ml&uuml;l&uuml;ğ&uuml;n&uuml; peşinen kabul ve taahh&uuml;t etmiştir.&nbsp;</p>
        </div>
        <div>
          <p>10.5. SATICI,&nbsp;S&ouml;zleşme&apos;den&nbsp;doğan ifa y&uuml;k&uuml;ml&uuml;l&uuml;ğ&uuml;n&uuml;n
            s&uuml;resi dolmadan&nbsp;ALICI&rsquo;yı&nbsp;bilgilendirmek ve a&ccedil;ık&ccedil;a onayını almak suretiyle
            eşit kalite ve fiyatta farklı bir &uuml;r&uuml;n tedarik edebilir.&nbsp;</p>
        </div>
        <div>
          <p>10.6. ALICI, S&ouml;zleşme konusu &Uuml;r&uuml;n&rsquo;&uuml;n teslimatı i&ccedil;in
            işbu&nbsp;S&ouml;zleşme&rsquo;yi&nbsp;elektronik ortamda teyit edeceğini, herhangi bir nedenle S&ouml;zleşme
            konusu &uuml;r&uuml;n bedelinin &ouml;denmemesi ve/veya banka, finans kuruluşu kayıtlarında iptal edilmesi
            halinde,&nbsp;SATICI&rsquo;nın&nbsp;s&ouml;zleşme konusu &uuml;r&uuml;n&uuml; teslim
            y&uuml;k&uuml;ml&uuml;l&uuml;ğ&uuml;n&uuml;n sona ereceğini kabul, beyan ve taahh&uuml;t eder. Herhangi bir
            sebeple banka ve/veya finans kuruluşu tarafından başarısız kodu g&ouml;nderilen ancak banka ve/veya finans
            kuruluşu tarafından&nbsp;SATICI&rsquo;ya&nbsp;yapılan &ouml;demelere ilişkin
            ALICI,&nbsp;SATICI&rsquo;nın&nbsp;herhangi bir sorumluluğunun bulunmadığını kabul, beyan ve taahh&uuml;t
            eder.&nbsp;</p>
        </div>
        <div>
          <p>10.7. ALICI, S&ouml;zleşme konusu &Uuml;r&uuml;n&rsquo;&uuml;n ALICI
            veya&nbsp;ALICI&rsquo;nın&nbsp;g&ouml;sterdiği adresteki kişi ve/veya kuruluşa tesliminden sonra
            veya&nbsp;{{ firma }}&nbsp;Teslimat Noktasından ALICI tarafından teslim alınmasından
            sonra&nbsp;ALICI&rsquo;ya&nbsp;ait kredi kartının yetkisiz kişilerce haksız kullanılması sonucunda
            S&ouml;zleşme konusu &uuml;r&uuml;n bedelinin ilgili banka veya finans kuruluşu
            tarafından&nbsp;SATICI&rsquo;ya&nbsp;&ouml;denmemesi halinde, ALICI S&ouml;zleşme konusu &uuml;r&uuml;n&uuml;
            3 g&uuml;n i&ccedil;erisinde nakliye gideri&nbsp;ALICI&rsquo;ya&nbsp;ait olacak
            şekilde&nbsp;SATICI&rsquo;ya&nbsp;iade edeceğini kabul, beyan ve taahh&uuml;t eder.&nbsp;</p>
        </div>
        <div>
          <p>10.8. ALICI, S&ouml;zleşme konusu mal/hizmeti teslim almadan &ouml;nce muayene edecek; ezik, kırık, ambalajı
            yırtılmış vb. hasarlı ve ayıplı mal/hizmeti kargo şirketinden teslim almayacaktır. Teslim alınan mal/hizmetin
            hasarsız ve sağlam olduğu kabul edilecektir. Teslimden sonra mal/hizmetin &ouml;zenle korunması
            borcu,&nbsp;ALICI&rsquo;ya&nbsp;aittir. Cayma hakkı kullanılacaksa mal/hizmet kullanılmamalıdır. Fatura iade
            edilmelidir.&nbsp;</p>
        </div>
        <div>
          <p>10.9. Malın teslimat masrafları aksine bir h&uuml;k&uuml;m yoksa&nbsp;ALICI&rsquo;ya&nbsp;aittir.
            SATICI,&nbsp;Platform&rsquo;da&nbsp;teslimat &uuml;cretinin kendisince karşılanacağını beyan etmişse teslimat
            masrafları&nbsp;SATICI&apos;ya&nbsp;ait olacaktır. Malın teslimatı&nbsp;SATICI&apos;nın&nbsp;stokunun
            m&uuml;sait olması halinde ve &ouml;demenin ger&ccedil;ekleşmesinden sonra taahh&uuml;t edilen s&uuml;rede
            yapılır.&nbsp;</p>
        </div>
        <div>
          <p>10.10. Sipariş konusu mal ya da hizmet ediminin yerine
            getirilmesinin&nbsp;imkansızlaştığı&nbsp;hallerde&nbsp;SATICI&rsquo;nın&nbsp;bu durumu &ouml;ğrendiği tarihten
            itibaren 3 (&uuml;&ccedil;) g&uuml;n i&ccedil;inde&nbsp;ALICI&rsquo;ya&nbsp;yazılı olarak veya ALICI veri
            saklayıcısı ile bildirmesi ve varsa teslimat masrafları da d&acirc;hil olmak &uuml;zere tahsil edilen t&uuml;m
            &ouml;demeleri bildirim tarihinden itibaren en ge&ccedil; on beş g&uuml;n i&ccedil;inde iade etmesi
            zorunludur. Malın stokta bulunmaması durumu, mal ediminin yerine getirilmesinin&nbsp;</p>
        </div>
        <div>
          <p>7&nbsp;</p>
        </div>
        <div>
          <p>imk&acirc;nsızlaşması&nbsp;olarak kabul edilmez.&nbsp;ALICI&rsquo;nın&nbsp;kredi kartı ile yaptığı
            &ouml;demelerde ise SATICI tarafından kredi kartına iade edilen tutarın banka tarafından ALICI hesabına
            yansıtılmasına ilişkin ortalama s&uuml;recin 2 (iki) ile 3 (&uuml;&ccedil;) haftayı bulabileceğini, bu tutarın
            bankaya iadesinden sonra&nbsp;ALICI&rsquo;nın&nbsp;hesaplarına yansıması halinin tamamen banka işlem
            s&uuml;reci ile ilgili olduğundan ALICI, olası gecikmeler i&ccedil;in&nbsp;SATICI&rsquo;yı&nbsp;sorumlu
            tutamayacağını kabul, beyan ve taahh&uuml;t eder.&nbsp;</p>
        </div>
        <div>
          <p>10.11. ALICI ile sipariş esnasında kullanılan kredi kartı hamilinin aynı kişi olmaması veya
            &uuml;r&uuml;n&uuml;n&nbsp;ALICI&rsquo;ya&nbsp;tesliminden evvel, siparişte kullanılan kredi kartına ilişkin
            g&uuml;venlik a&ccedil;ığı tespit edilmesi halinde, SATICI, kredi kartı hamiline ilişkin kimlik ve iletişim
            bilgilerini, siparişte kullanılan kredi kartının bir &ouml;nceki aya ait&nbsp;ekstresini&nbsp;yahut kart
            hamilinin bankasından kredi kartının kendisine ait olduğuna ilişkin yazıyı ibraz
            etmesini&nbsp;ALICI&rsquo;dan&nbsp;talep edebilir.&nbsp;ALICI&rsquo;nın&nbsp;talebe konu bilgi/belgeleri temin
            etmesine kadar ge&ccedil;ecek s&uuml;rede sipariş dondurulacak olup, mezk&ucirc;r taleplerin 24 (yirmi
            d&ouml;rt) saat i&ccedil;erisinde karşılanmaması halinde ise SATICI, siparişi iptal etme hakkını
            haizdir.&nbsp;</p>
        </div>
        <div>
          <p>10.12. ALICI &uuml;r&uuml;n bedelini &ouml;demesi ve bu siparişe ilişkin cayma hakkını kullanması halinde
            cayma hakkından kaynaklı bedel iadesi&nbsp;Paytr&nbsp;&uuml;zerinden hesabına yapılacaktır.&nbsp;</p>
        </div>
        <div>
          <p>10.13. &Ouml;deme şekli: %50&apos;si işbu s&ouml;zleşmenin tebliğine istinaden peşin ve kalan 50% mal
            tesliminden 60 g&uuml;n sonra&nbsp;&hellip;&hellip;&hellip;...&hellip;&hellip;&hellip;&nbsp;tarihinde&nbsp;TL
            bazında banka havalesiyle peşin &ouml;denecektir.&nbsp;</p>
        </div>
        <div>
          <p>10.14. Vadesinde yapılmayan &ouml;demelerde, aylık % 3 faiz işletilir.&nbsp;</p>
        </div>
        <div>
          <p>10.15. Sipariş&cedil; edilmeyen malların g&ouml;nderilmesi durumunda,&nbsp;ALICI&rsquo;ya&nbsp;karşı herhangi
            bir hak ileri s&uuml;r&uuml;lemez. Bu hallerde,&nbsp;ALICI&rsquo;nın&nbsp;sessiz kalması ya da malı kullanmış
            olması, s&ouml;zleşmenin kurulmasına y&ouml;nelik kabul beyanı olarak yorumlanamaz.&nbsp;</p>
        </div>
        <div>
          <p>10.16.&nbsp;ALICI&rsquo;nın&nbsp;Platform&rsquo;dan&nbsp;duyurulan zamanlarda sipariş edebileceği
            &uuml;r&uuml;n adetlerine kısıt getirilebilir.&nbsp;ALICI&rsquo;nın&nbsp;Platform&rsquo;dan&nbsp;yapılan
            duyurularda belirtilen&nbsp;adetin&nbsp;&uuml;zerinde &uuml;r&uuml;n sipariş etmesi halinde siparişler iptal
            edilebilecek ve yasal s&uuml;resi i&ccedil;erisinde &uuml;r&uuml;n bedelleri&nbsp;ALICI&rsquo;ya&nbsp;iade
            edilecektir. ALICI işbu hususları kabul ederek siparişini oluşturduğunu, adet sınırlamasını ge&ccedil;en
            siparişlerde&nbsp;{{ firma }}ve/veya&nbsp;SATICI&rsquo;nın&nbsp;siparişi iptal etme hakkının olduğunu kabul, beyan ve taahh&uuml;t
            eder.&nbsp;</p>
        </div>
        <div>
          <p>10.17.&nbsp;{{ firma }}SATICI&rsquo;nın&nbsp;herhangi bir
            sebeple tedarik edemediği siparişleri, mevzuattaki teslim s&uuml;resini aşmamak
            ve&nbsp;ALICI&rsquo;nın&nbsp;&uuml;r&uuml;n&uuml; ile aynı &ouml;zellikleri haiz olmak kaydıyla, bir başka
            satıcıya aktarma hakkına sahiptir. B&ouml;yle bir durumda &uuml;r&uuml;n yeni satıcı
            tarafından&nbsp;ALICI&rsquo;ya&nbsp;g&ouml;nderilecek olup mesafeli satış s&ouml;zleşmesi yeni satıcı ile
            ALICI arasında kurulmuş olacaktır.&nbsp;{{ firma }}ve/veya
            SATICI,&nbsp;ALICI&rsquo;ya&nbsp;herhangi bir ek bedel, &uuml;cret ve/veya masraf yansıtmayacaktır..&nbsp;</p>
        </div>
        <div>
          <p>11. &Ouml;ZEL ŞARTLAR&nbsp;</p>
        </div>
        <div>
          <p>8&nbsp;</p>
        </div>
        <div>
          <p>11.1. ALICI&nbsp;Platform&rsquo;da&nbsp;aynı sepet i&ccedil;erisinde farklı kategorilerden alınan
            &uuml;r&uuml;nlerin her biri i&ccedil;in SATICI tarafından tek fatura kesilebilecektir. Ş&uuml;pheye mahal
            bırakmamak bakımından belirtilmelidir ki, SATICI&nbsp;ALICI&rsquo;nın&nbsp;aldığı &uuml;r&uuml;nlerin
            teslimatını mevzuattaki yasal s&uuml;re i&ccedil;erisinde kalmak koşuluyla farklı zamanlarda
            ger&ccedil;ekleştirebilecektir.&nbsp;</p>
        </div>
        <div>
          <p>11.2. Bankanız kampanyalar d&uuml;zenleyerek sizin se&ccedil;tiğiniz taksit adedinin daha &uuml;st&uuml;nde
            bir taksit adedi uygulayabilir, taksit &ouml;teleme gibi hizmetler sunulabilir. Bu t&uuml;r kampanyalar
            bankanızın&nbsp;inisiyatifindedir&nbsp;ve&nbsp;{{ firma }}in&nbsp;bilgisi d&acirc;hilinde olması durumunda sayfalarımızda kampanyalar hakkında bilgi
            verilmektedir. Kredi kartınızın hesap kesim tarihinden itibaren sipariş toplamı taksit adedine
            b&ouml;l&uuml;nerek kredi kartı &ouml;zetinize bankanız tarafından yansıtılacaktır. Banka taksit tutarlarını
            k&uuml;surat farklarını dikkate alarak aylara eşit olarak dağıtmayabilir. Detaylı &ouml;deme planınızın
            oluşturulması bankanız&nbsp;inisiyatifindedir.&nbsp;</p>
        </div>
        <div>
          <p>11.3. Dijital &uuml;r&uuml;n satışlarında Satıcı, Alıcı&apos;ya &uuml;r&uuml;nlerin Alıcı&rsquo;ya tam ve
            gereği gibi iletildiği ve g&ouml;nderilen kodların eksiksiz şekilde &ccedil;alıştığını kanıtlayan t&uuml;m
            bilgi ve belgeleri ve g&uuml;venli şekilde tutulmuş&nbsp;log&nbsp;kayıtlarını&nbsp;{{ firma }} e&nbsp;iletmekle y&uuml;k&uuml;ml&uuml;d&uuml;r. Aksi halde&nbsp;
            {{ firma }}in&nbsp;4.28. maddeden doğan hakları saklıdır.&nbsp;
          </p>
        </div>
        <div>
          <p>12. KİŞİSEL VERİLERİN KORUNMASI, TİCARİ ELEKTRONİK İLETİ VE FİKRİ-SINAİ HAKLAR İLE İLGİLİ KURALLAR&nbsp;</p>
        </div>
        <div>
          <p>12.1. 6698 sayılı Kişisel Verilerin Korunması Kanunu kapsamında kişisel veri olarak
            tanımlanabilecek&nbsp;ALICI&rsquo;ya&nbsp;ait ad,&nbsp;soyad, e-posta adresi, T.C. Kimlik numarası, demografik
            veriler, mali veriler vb. bilgiler;&nbsp;</p>
        </div>
        <div>
          <p>* sipariş almak, &uuml;r&uuml;n ve hizmetleri sunmak, &uuml;r&uuml;n ve hizmetleri geliştirmek, sistemsel
            sorunların &ccedil;&ouml;z&uuml;m&uuml;, &ouml;deme işlemlerini ger&ccedil;ekleştirmek, -&ouml;nceden onay
            verilmesi halinde- siparişler, &uuml;r&uuml;nler ve hizmetler hakkında pazarlama faaliyetlerinde
            kullanılmak,&nbsp;ALICI&rsquo;ya&nbsp;ait bilgilerin g&uuml;ncellenmesinde ve &uuml;yeliklerin y&ouml;netimi
            ve s&uuml;rd&uuml;r&uuml;lmesi ile ALICI ile SATICI arasında kurulan mesafeli satış s&ouml;zleşmesi ve sair
            s&ouml;zleşmelerin ifası amacıyla ve 3. kişilerin teknik, lojistik ve benzeri diğer işlevlerinin SATICI
            tarafından sağlanabilmesi i&ccedil;in yukarıda sayılan verileri&nbsp;{{ firma }} ve &uuml;&ccedil;&uuml;nc&uuml; kişi ve/veya kuruluşlar tarafından
            s&uuml;resiz/s&uuml;reli kaydedilebilir, yazılı/manyetik arşivlerde muhafaza edilebilir, kullanılabilir,
            g&uuml;ncellenebilir, paylaşılabilir, transfer olunabilir ve sair suretler ile işlenebilir.&nbsp;</p>
        </div>
        <div>
          <p>12.2.&nbsp;ALICILAR&rsquo;a, y&uuml;r&uuml;rl&uuml;kteki mevzuata uygun şekilde, her t&uuml;rl&uuml;
            &uuml;r&uuml;n ve hizmetlere ilişkin tanıtım, reklam, iletişim,&nbsp;promosyon, satış ve pazarlama amacıyla,
            kredi kartı ve &uuml;yelik bilgilendirme, işlem, uygulamaları i&ccedil;in&nbsp;{{ firma }} tarafından SMS/kısa mesaj, anlık bildirim, otomatik arama, bilgisayar, telefon,
            e-posta/mail, faks, diğer elektronik iletişim ara&ccedil;ları ile ticari elektronik iletişimler yapılabilir,
            ALICI kendisine ticari elektronik iletiler g&ouml;nderilmesini kabul etmiştir.&nbsp;</p>
        </div>
        <div>
          <p>9&nbsp;</p>
        </div>
        <div>
          <p>12.3. ALICI tarafından&nbsp;Platform&rsquo;a&nbsp;girilen bilgilerin ve işlemlerin g&uuml;venliği i&ccedil;in
            gerekli &ouml;nlemler,&nbsp;{{ firma }}tarafındaki kendi sistem
            altyapısında, bilgi ve işlemin mahiyetine g&ouml;re g&uuml;n&uuml;m&uuml;z
            teknik&nbsp;imkanları&nbsp;&ouml;l&ccedil;&uuml;s&uuml;nde alınmıştır. Bununla beraber, s&ouml;z konusu
            bilgiler&nbsp;ALICI&rsquo;ya&nbsp;ait cihazlardan girildiğinden ALICI tarafından korunmaları ve ilgisiz
            kişilerce erişilememesi i&ccedil;in, vir&uuml;s ve benzeri zararlı uygulamalara ilişkin olanlar&nbsp;dahil,
            gerekli tedbirlerin alınması sorumluluğu&nbsp;ALICI&rsquo;ya&nbsp;aittir.&nbsp;</p>
        </div>
        <div>
          <p>12.4. ALICI,&nbsp;{{ firma }}e&nbsp;belirtilen iletişim
            kanallarından ulaşarak veri kullanımı-işlenmelerini ve/veya iletişimleri her zaman i&ccedil;in durdurulmasını
            talep edebilir.&nbsp;ALICI&rsquo;nın&nbsp;bu husustaki a&ccedil;ık bildirimine g&ouml;re, kişisel veri
            işlemleri ve/veya tarafına iletişimler yasal azami s&uuml;re i&ccedil;inde durdurulur; ayrıca dilerse, hukuken
            muhafazası gerekenler ve/veya m&uuml;mk&uuml;n olanlar haricindeki bilgileri, veri kayıt sisteminden silinir
            ya da kimliği belli olmayacak bi&ccedil;imde anonim hale getirilir.&nbsp;ALICI isterse kişisel verilerinin
            işlenmesi ile ilgili işlemler, aktarıldığı kişiler, eksik veya yanlış olması halinde d&uuml;zeltilmesi,
            d&uuml;zeltilen bilgilerin ilgili &uuml;&ccedil;&uuml;nc&uuml; kişilere bildirilmesi, verilerin silinmesi veya
            yok edilmesi, otomatik sistemler ile analiz edilmesi sureti ile kendisi aleyhine bir sonucun ortaya
            &ccedil;ıkmasına itiraz, verilerin kanuna aykırı olarak işlenmesi sebebi ile zarara uğrama halinde giderilmesi
            gibi konularda&nbsp;{{ firma }} e&nbsp;her zaman başvurabilir
            ve bilgi alabilir.&nbsp;S&ouml;z konusu başvurular incelenerek yasal s&uuml;resi
            i&ccedil;erisinde&nbsp;ALICI&rsquo;ya&nbsp;mevzuatta &ouml;ng&ouml;r&uuml;len s&uuml;relerde d&ouml;n&uuml;ş
            yapılacaktır.&nbsp;</p>
        </div>
        <div>
          <p>12.5.&nbsp;Platform&rsquo;a&nbsp;ait her t&uuml;rl&uuml; bilgi ve i&ccedil;erik ile bunların
            d&uuml;zenlenmesi,&nbsp;revizyonu&nbsp;ve kısmen/tamamen kullanımı konusunda;&nbsp;{{ firma }}in&nbsp;anlaşmasına g&ouml;re diğer &uuml;&ccedil;&uuml;nc&uuml; şahıslara
            ait olanlar hari&ccedil;; t&uuml;m fikri-sınai haklar ve m&uuml;lkiyet hakları&nbsp;{{ firma }} e&nbsp;aittir.&nbsp;</p>
        </div>
        <div>
          <p>12.6.&nbsp;Platform&rsquo;dan&nbsp;ulaşılan diğer sitelerde kendilerine ait gizlilik-g&uuml;venlik
            politikaları ve kullanım şartları ge&ccedil;erlidir, oluşabilecek ihtilaflar ile menfi
            neticelerinden&nbsp;{{ firma }}sorumlu değildir.&nbsp;</p>
        </div>
        <div>
          <p>13. CAYMA HAKKI&nbsp;</p>
        </div>
        <div>
          <p>13.1. ALICI hi&ccedil;bir hukuki ve cezai sorumluluk &uuml;stlenmeksizin ve hi&ccedil;bir gerek&ccedil;e
            g&ouml;stermeksizin satın aldığı mal/hizmeti teslim tarihinden itibaren 14 (on beş) g&uuml;n i&ccedil;erisinde
            cayma hakkını kullanarak iade edebilir.&nbsp;</p>
        </div>
        <div>
          <p>13.2. Cayma hakkı bildirimi ve&nbsp;S&ouml;zleşme&rsquo;ye&nbsp;ilişkin
            bildirimler&nbsp;Platform&rsquo;da&nbsp;belirtilen iletişim kanalları ile g&ouml;sterilecektir. Cayma
            bildiriminin yapılacağı iletişim kanallarına <a :href="sistemAdres" target="_blank"
              rel="noreferrer noopener">{{sistemAdres}}</a> iletisim.html linkinden ulaşılabilir.&nbsp;
          </p>
        </div>
        <div>
          <p>13.3. Cayma hakkının kullanılması i&ccedil;in s&uuml;resi i&ccedil;erisinde SATICI veya&nbsp;{{ firma }} in&nbsp;mevzuat h&uuml;k&uuml;mlerine
            ve&nbsp;Platform&rsquo;daki&nbsp;cayma hakkı kullanım se&ccedil;eneğine uygun olarak bildirimde bulunulması
            şarttır.&nbsp;</p>
        </div>
        <div>
          <p>13.5. Cayma hakkının kullanılması halinde:&nbsp;</p>
        </div>
        <div>
          <p>10&nbsp;</p>
        </div>
        <div>
          <p>a) ALICI cayma hakkını kullanmasından itibaren 10 (on) g&uuml;n i&ccedil;erisinde
            Malı&nbsp;SATICI&apos;ya&nbsp;anlaşmalı kargo şirketiyle geri g&ouml;nderir.&nbsp;</p>
        </div>
        <div>
          <p>b) Cayma hakkı kapsamında iade edilecek Mal kutusu, ambalajı, varsa standart aksesuarları varsa Mal ile
            birlikte hediye edilen diğer &uuml;r&uuml;nlerin de eksiksiz ve hasarsız olarak iade edilmesi
            gerekmektedir.&nbsp;</p>
        </div>
        <div>
          <p>13.6. ALICI cayma s&uuml;resi i&ccedil;inde malı, işleyişine, teknik &ouml;zelliklerine ve kullanım
            talimatlarına uygun bir şekilde kullandığı takdirde meydana gelen değişiklik ve bozulmalardan sorumlu
            değildir.&nbsp;</p>
        </div>
        <div>
          <p>13.7. Cayma hakkının kullanılmasını takip eden 14 (on d&ouml;rt) g&uuml;n i&ccedil;erisinde Mal
            bedeli&nbsp;ALICI&rsquo;ya&nbsp;&ouml;dediği şekilde iade edilir. Mal,&nbsp;SATICI&apos;ya&nbsp;iade
            edilirken, Malın teslimi sırasında&nbsp;ALICI&rsquo;ya&nbsp;ibraz edilmiş olan orijinal faturanın da ALICI
            tarafından iade edilmesi gerekmektedir.&nbsp;</p>
        </div>
        <div>
          <p>13.8. ALICI iade edeceği Malı &ouml;n bilgilendirme formunda belirtilen&nbsp;SATICI&apos;nın&nbsp;anlaşmalı
            kargo şirketi ile&nbsp;SATICI&apos;ya&nbsp;g&ouml;nderdiği s&uuml;rece iade kargo
            bedeli&nbsp;SATICI&apos;ya&nbsp;aittir. İade i&ccedil;in&nbsp;ALICI&rsquo;nın&nbsp;bulunduğu
            yerde&nbsp;SATICI&rsquo;nın&nbsp;anlaşmalı kargo şirketi şubesi bulunmaması halinde ALICI herhangi bir kargo
            şirketiyle g&ouml;nderebilecektir, bu halde kargo
            bedeli&nbsp;ALICI&rsquo;ya&nbsp;aittir.&nbsp;ALICI&rsquo;nın&nbsp;iade edeceği Malı &Ouml;n Bilgilendirme
            Formunda belirtilen&nbsp;SATICI&apos;nın&nbsp;anlaşmalı kargo şirketi dışında bir kargo şirketi ile
            g&ouml;ndermesi halinde iade kargo bedeli ve Malın kargo s&uuml;recinde uğrayacağı hasardan SATICI sorumlu
            değildir.&nbsp;</p>
        </div>
        <div>
          <p>13.9.&nbsp;ALICI&rsquo;nın&nbsp;cayma hakkını kullandığı durumlarda ya da siparişe konu olan
            &uuml;r&uuml;n&uuml;n &ccedil;eşitli sebeplerle tedarik edilememesi veya hakem heyeti kararları
            ile&nbsp;ALICI&rsquo;ya&nbsp;bedel iadesine karar verilen durumlarda, alışveriş kredi kartı ile ve taksitli
            olarak yapılmışsa, kredi kartına iade&nbsp;prosed&uuml;r&uuml;&nbsp;aşağıda belirtilmiştir:&nbsp;</p>
        </div>
        <div>
          <p>ALICI &uuml;r&uuml;n&uuml; ka&ccedil; taksit ile aldıysa Banka&nbsp;ALICI&rsquo;ya&nbsp;geri &ouml;demesini
            taksitle yapmaktadır. SATICI bankaya &uuml;r&uuml;n bedelinin tamamını tek seferde &ouml;dedikten sonra, Banka
            poslarından yapılan taksitli harcamaların&nbsp;ALICI&rsquo;nın&nbsp;kredi kartına iadesi durumunda, konuya
            m&uuml;dahil tarafların mağdur duruma d&uuml;şmemesi i&ccedil;in talep edilen iade tutarları, yine taksitli
            olarak hamil taraf hesaplarına Banka tarafından aktarılır.&nbsp;ALICI&rsquo;nın&nbsp;satış iptaline kadar
            &ouml;demiş olduğu taksit tutarları, eğer iade tarihi ile kartın hesap kesim tarihleri &ccedil;akışmazsa her
            ay karta 1 (bir) iade yansıyacak ve ALICI iade &ouml;ncesinde &ouml;demiş olduğu taksitleri satışın taksitleri
            bittikten sonra, iade &ouml;ncesinde &ouml;demiş olduğu taksitleri sayısı kadar ay daha alacak ve mevcut
            bor&ccedil;larından d&uuml;şm&uuml;ş olacaktır.&nbsp;</p>
        </div>
        <div>
          <p>14. CAYMA HAKKININ KULLANILAMAYACAĞI HALLER&nbsp;</p>
        </div>
        <div>
          <p>14.1. ALICI aşağıdaki s&ouml;zleşmelerde cayma hakkını kullanamaz:&nbsp;</p>
        </div>
        <div>
          <p>a) Fiyatı finansal piyasalardaki dalgalanmalara bağlı olarak değişen ve SATICI veya&nbsp;{{ firma }} in&nbsp;kontrol&uuml;nde olmayan mal veya hizmetlere ilişkin
            s&ouml;zleşmeler&nbsp;</p>
        </div>
        <div>
          <p>11&nbsp;</p>
        </div>
        <div>
          <p>b) T&uuml;keticinin istekleri veya kişisel ihtiya&ccedil;ları doğrultusunda hazırlanan mallara ilişkin
            s&ouml;zleşmeler&nbsp;</p>
        </div>
        <div>
          <p>c) &Ccedil;abuk bozulabilen veya son kullanma tarihi ge&ccedil;ebilecek malların teslimine ilişkin
            s&ouml;zleşmeler&nbsp;</p>
        </div>
        <div>
          <p>&ccedil;) Tesliminden sonra ambalaj, bant, m&uuml;h&uuml;r, paket gibi koruyucu unsurları a&ccedil;ılmış olan
            mallardan; iadesi sağlık ve&nbsp;hijyen&nbsp;a&ccedil;ısından uygun olmayanların teslimine ilişkin
            s&ouml;zleşmeler.&nbsp;</p>
        </div>
        <div>
          <p>d) Tesliminden sonra başka &uuml;r&uuml;nlerle karışan ve doğası gereği ayrıştırılması m&uuml;mk&uuml;n
            olmayan mallara ilişkin s&ouml;zleşmeler.&nbsp;</p>
        </div>
        <div>
          <p>e) Malın tesliminden sonra ambalaj, bant, m&uuml;h&uuml;r, paket gibi koruyucu unsurları a&ccedil;ılmış
            olması halinde maddi ortamda sunulan kitap, dijital i&ccedil;erik ve bilgisayar sarf malzemelerine ilişkin
            s&ouml;zleşmeler.&nbsp;</p>
        </div>
        <div>
          <p>f) Abonelik s&ouml;zleşmesi kapsamında sağlananlar dışında gazete ve dergi gibi s&uuml;reli yayınların
            teslimine ilişkin s&ouml;zleşmeler.&nbsp;</p>
        </div>
        <div>
          <p>g) Belirli bir tarihte veya d&ouml;nemde yapılması gereken, konaklama, eşya taşıma, araba kiralama, yiyecek
            i&ccedil;ecek tedariki ve eğlence veya dinlenme amacıyla yapılan boş zamanın değerlendirilmesine ilişkin
            s&ouml;zleşmeler.&nbsp;</p>
        </div>
        <div>
          <p>ğ) Elektronik ortamda anında ifa edilen hizmetler ile&nbsp;ALICI&rsquo;ya&nbsp;anında teslim edilen gayri
            maddi mallara ilişkin s&ouml;zleşmeler.&nbsp;</p>
        </div>
        <div>
          <p>h) Cayma hakkı s&uuml;resi sona ermeden &ouml;nce,&nbsp;ALICI&rsquo;nın&nbsp;onayı ile ifasına başlanan
            hizmetlere ilişkin s&ouml;zleşmeler.&nbsp;</p>
        </div>
        <div>
          <p>S&ouml;zleşmeye konu Mal/Hizmet&apos;in&nbsp;Mesafeli S&ouml;zleşmeler Y&ouml;netmeliği&apos;nin uygulama
            alanı dışında bırakılmış olan (SATICI&rsquo;nın&nbsp;d&uuml;zenli teslimatları
            ile&nbsp;ALICInın&nbsp;meskenine teslim edilen gıda maddelerinin, i&ccedil;eceklerin ya da diğer
            g&uuml;nl&uuml;k t&uuml;ketim maddeleri ile seyahat, konaklama, lokantacılık, eğlence sekt&ouml;r&uuml; gibi
            alanlarda hizmetler) Mal/Hizmet t&uuml;rlerinden m&uuml;teşekkil olması halinde ALICI ve SATICI arasındaki
            hukuki ilişkiye Mesafeli S&ouml;zleşmeler Y&ouml;netmeliği h&uuml;k&uuml;mleri uygulanamaması sebebiyle cayma
            hakkı kullanılamayacaktır.&nbsp;</p>
        </div>
        <div>
          <p>14.2.&nbsp;{{ firma }}e&nbsp;ait Platform &uuml;zerinden
            ELEKTRONİK KOD SATIN ALINDIĞI DURUMLARDA bahse konu siparişlerde Mesafeli S&ouml;zleşmeler
            Y&ouml;netmeliği&rsquo;nin 15/1.ğ maddesi gereği cayma hakkı s&ouml;z konusu olmayacaktır. Bu siparişler
            bakımından internet sitesi &uuml;zerinden iade kodu da oluşturulamayacaktır.&nbsp;</p>
        </div>
        <div>
          <p>15. UYUŞMAZLIKLARIN &Ccedil;&Ouml;Z&Uuml;M&Uuml;&nbsp;</p>
        </div>
        <div>
          <p>15.1. İşbu Mesafeli Satış S&ouml;zleşmesi&apos;nin uygulanması sırasında meydana gelebilecek ihtilaflarda
            yahut &ccedil;ekişmesiz işlerde&nbsp;Bursa&nbsp;Mahkemeleri ve İcra Daireleri yetkilidir.&nbsp;</p>
        </div>
        <div>
          <p>12&nbsp;</p>
        </div>
        <div>
          <p>15.2 İşbu Mesafeli Satış S&ouml;zleşmesi&apos;nin uygulanmasında, Ticaret Bakanlığınca ilan edilen değere
            kadar T&uuml;ketici Hakem Heyetleri ile T&uuml;ketici Mahkemeleri yetkilidir.&nbsp;</p>
        </div>
        <div>
          <p>15.3. 6502 Sayılı T&uuml;keticinin Korunması Hakkında Kanun&apos;un 68. maddesinin 1. fıkrasında belirtilen
            alt ve &uuml;st limitler doğrultusunda t&uuml;ketici talepleri hakkında t&uuml;ketici hakem heyetleri
            yetkilidir.&nbsp;</p>
        </div>
        <div>
          <p>16. MALIN/HİZMETİN FİYATI&nbsp;</p>
        </div>
        <div>
          <p>Malın peşin veya vadeli satış fiyatı, sipariş formunda yer almakla birlikte, sipariş sonu g&ouml;nderilen
            bilgilendirme maili ve &uuml;r&uuml;n ile birlikte m&uuml;şteriye g&ouml;nderilen fatura i&ccedil;eriğinde
            mevcut olan fiyattır. SATICI veya&nbsp;{{ firma }}tarafından
            yapılan indirimler, kuponlar, kargo &uuml;creti ve sair uygulamalar satış fiyatına yansıtılır.&nbsp;</p>
        </div>
        <div>
          <p>17. TEMERR&Uuml;D HALİ VE HUKUKİ SONU&Ccedil;LARI&nbsp;</p>
        </div>
        <div>
          <p>17.1.&nbsp;SATICI&rsquo;nın&nbsp;&ouml;demekle y&uuml;k&uuml;ml&uuml; olduğu bedelin %50&apos;si işbu
            s&ouml;zleşmenin tebliğine istinaden peşin ve kalan 50% mal tesliminden 60 g&uuml;n
            sonra&nbsp;&hellip;&hellip;&hellip;...&hellip;&hellip;&hellip;&nbsp;tarihinde&nbsp;TL bazında banka
            havalesiyle peşin &ouml;denecektir.&nbsp;</p>
        </div>
        <div>
          <p>17.2. Vadesinde yapılmayan &ouml;demelerde, aylık % 3 faiz işletilir.&nbsp;</p>
        </div>
        <div>
          <p>17.3. İşbu siparişin verilmesi ile alıcı taraf, satın aldığı &uuml;r&uuml;nlerin bedellerinin vadesi hakkında
            ihtar edilmiş olur. Karşı taraf, vade tarihinde borcunu &ouml;demediği takdirde kendisine ek bir ihtar
            yapılması gerekmeksizin temerr&uuml;de d&uuml;şer ve satıcı temerr&uuml;t faizine hak kazanır. (TTK
            1530/2)&nbsp;</p>
        </div>
        <div>
          <p>17.4.&nbsp;ALICI&rsquo;nın, kredi kartı ile yapmış olduğu işlemlerde temerr&uuml;de d&uuml;şmesi halinde kart
            sahibi bankanın kendisi ile yapmış olduğu kredi kartı s&ouml;zleşmesi &ccedil;er&ccedil;evesinde, faiz
            &ouml;deyecek ve bankaya karşı sorumlu olacaktır. Bu durumda ilgili banka hukuki yollara başvurabilir, doğacak
            masrafları ve vek&acirc;let &uuml;cretini&nbsp;ALICI&rsquo;dan&nbsp;talep edebilir ve her
            koşulda&nbsp;ALICI&rsquo;nın&nbsp;borcundan dolayı temerr&uuml;de d&uuml;şmesi
            halinde,&nbsp;ALICI&rsquo;nın&nbsp;borcu gecikmeli ifasından dolayı&nbsp;SATICI&apos;nın&nbsp;uğradığı zarar
            ve ziyandan ALICI sorumlu olacaktır.&nbsp;</p>
        </div>
        <div>
          <p>17.5.&nbsp;ALICI&rsquo;nın&nbsp;kredi kartı ile yapmış olduğu işlemlerde temerr&uuml;de d&uuml;şmesi halinde
            kart sahibi bankanın kendisi ile yapmış olduğu kredi kartı s&ouml;zleşmesi &ccedil;er&ccedil;evesinde
            &ouml;deyeceği faiz,&nbsp;SATICI&rsquo;ya&nbsp;&ouml;demekle y&uuml;k&uuml;ml&uuml; olduğu temerr&uuml;t
            faizinden m&uuml;stesna olup, aylık %3 oranında &ouml;denecek temerr&uuml;t faizinin işlemesine engel teşkil
            etmez.&nbsp;</p>
        </div>
        <div>
          <p>18. BİLDİRİMLER ve DELİL S&Ouml;ZLEŞMESİ&nbsp;</p>
        </div>
        <div>
          <p>18.1. İşbu S&ouml;zleşme tahtında Taraflar arasında yapılacak her t&uuml;rl&uuml; yazışma, mevzuatta sayılan
            zorunlu haller dışında, e-mail aracılığıyla yapılacaktır.&nbsp;</p>
        </div>
        <div>
          <p>18.2. ALICI, işbu&nbsp;S&ouml;zleşme&apos;den&nbsp;doğabilecek
            ihtilaflarda&nbsp;SATICI&apos;nın&nbsp;ve&nbsp;{{ firma }}in&nbsp;resmi defter ve ticari kayıtlarıyla, kendi veri&nbsp;tabanında, sunucularında
            tuttuğu elektronik bilgilerin ve bilgisayar kayıtlarının, bağlayıcı, kesin ve m&uuml;nhasır delil teşkil
            edeceğini, bu maddenin Hukuk Muhakemeleri Kanunu&apos;nun 193. maddesi anlamında delil s&ouml;zleşmesi
            niteliğinde olduğunu kabul, beyan ve taahh&uuml;t eder.&nbsp;</p>
        </div>
        <div>
          <p>13&nbsp;</p>
        </div>
        <div>
          <p>19. Y&Uuml;R&Uuml;RL&Uuml;K&nbsp;</p>
        </div>
        <div>
          <p>19.1. İşbu belge taraflar arasındaki&nbsp;mutakabat&nbsp;sonucunda oluşturulan nihai s&ouml;zleşmedir. Alıcı
            siparişin durumunda ve adetlerinde, modellerde değişiklik yapamaz. Ancak bazı durumlarda satıcının yazılı
            onayına istinaden değişiklikler satıcı&nbsp;insiyatifinde&nbsp;kabul edilebilir.&nbsp;</p>
        </div>
        <div>
          <p>19.2 .&nbsp;19 (on dokuz) maddeden ibaret bu S&ouml;zleşme, Taraflarca okunarak, işlem tarihinde, ALICI
            tarafından elektronik ortamda onaylanmak suretiyle akdedilmiş ve y&uuml;r&uuml;rl&uuml;ğe girmiştir.
            S&ouml;zleşmenin bir n&uuml;shası&nbsp;ALICI&rsquo;nın&nbsp;&uuml;yelik hesabında mevcuttur ve talep edilmesi
            halinde ayrıca e-posta ile de g&ouml;nderilebilecektir.&nbsp;</p>
        </div>
        <div>
          <p>&nbsp;</p>
        </div>
      </div>
      <div><br></div>
    </div>
    </vx-card>
   

  </div>
</template>
<script>
import Store from "../../store/store";
import state from "../../store/state";
import userJson from "../../../public/user.json";
export default {
  name: "FileComponent",
  data(){
    return{
      firma: userJson.firma,
      sistemAdres :userJson.url,
      mailAdres : userJson.mail,
      logoUrl: "",
    }
  },
  created() {
    this.logoUrl = userJson.userLogo;
    }
};
</script>
